import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';

export class LL_0003_HMI_CAN59 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0003_HMI_CAN59',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'BusIdentification',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcList',
              isRead: 'true',
              interval: '257',
              texttableentry: 'StatusDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcHistory',
              isRead: 'true',
              interval: '258',
              texttableentry: 'StatusDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcList',
              isRead: 'true',
              interval: '259',
              texttableentry: 'InfoDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcHistory',
              isRead: 'true',
              interval: '260',
              texttableentry: 'InfoDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcList',
              isRead: 'true',
              interval: '261',
              texttableentry: 'ServiceDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcHistory',
              isRead: 'true',
              interval: '262',
              texttableentry: 'ServiceDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WarningDtcList',
              isRead: 'true',
              interval: '263',
              texttableentry: 'WarningDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcHistory',
              isRead: 'true',
              interval: '264',
              texttableentry: 'WarningDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcHistory',
              isRead: 'true',
              interval: '266',
              texttableentry: 'ErrorDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ShadowDtcList',
              isRead: 'true',
              interval: '267',
              texttableentry: 'ShadowDtcList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlowTemperatureSensor',
              isRead: 'true',
              interval: '268',
              texttableentry: 'FlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ReturnTemperatureSensor',
              isRead: 'true',
              interval: '269',
              texttableentry: 'ReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterFlowSensor',
              isRead: 'true',
              interval: '270',
              texttableentry: 'WaterFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterSensor',
              isRead: 'true',
              interval: '271',
              texttableentry: 'DomesticHotWaterSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterFlowSensor',
              isRead: 'true',
              interval: '272',
              texttableentry: 'DomesticHotWaterFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarRoofTemperatureSensor',
              isRead: 'true',
              interval: '273',
              texttableentry: 'SolarRoofTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureSensor',
              isRead: 'true',
              interval: '274',
              texttableentry: 'OutsideTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarBottomTemperatureSensor',
              isRead: 'true',
              interval: '275',
              texttableentry: 'SolarBottomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarTopTemperatureSensor',
              isRead: 'true',
              interval: '276',
              texttableentry: 'SolarTopTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferBottomTemperatureSensor',
              isRead: 'true',
              interval: '277',
              texttableentry: 'BufferBottomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferMidBottomTemperatureSensor',
              isRead: 'true',
              interval: '278',
              texttableentry: 'BufferMidBottomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferMidTemperatureSensor',
              isRead: 'true',
              interval: '279',
              texttableentry: 'BufferMidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferMidTopTemperatureSensor',
              isRead: 'true',
              interval: '280',
              texttableentry: 'BufferMidTopTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferTopTemperatureSensor',
              isRead: 'true',
              interval: '281',
              texttableentry: 'BufferTopTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicSeparatorTemperatureSensor',
              isRead: 'true',
              interval: '282',
              texttableentry: 'HydraulicSeparatorTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicSeparatorReturnTemperatureSensor',
              isRead: 'true',
              interval: '283',
              texttableentry: 'HydraulicSeparatorReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '284',
              texttableentry: 'MixerOneCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '285',
              texttableentry: 'MixerOneCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '286',
              texttableentry: 'MixerTwoCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '287',
              texttableentry: 'MixerTwoCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '288',
              texttableentry: 'MixerThreeCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '289',
              texttableentry: 'MixerThreeCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '290',
              texttableentry: 'MixerFourCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '291',
              texttableentry: 'MixerFourCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '292',
              texttableentry: 'MixerFiveCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '293',
              texttableentry: 'MixerFiveCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '294',
              texttableentry: 'MixerSixCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '295',
              texttableentry: 'MixerSixCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '296',
              texttableentry: 'MixerSevenCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '297',
              texttableentry: 'MixerSevenCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '298',
              texttableentry: 'MixerEightCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '299',
              texttableentry: 'MixerEightCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '300',
              texttableentry: 'MixerNineCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '301',
              texttableentry: 'MixerNineCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '302',
              texttableentry: 'MixerTenCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '303',
              texttableentry: 'MixerTenCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '304',
              texttableentry: 'MixerElevenCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '305',
              texttableentry: 'MixerElevenCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '306',
              texttableentry: 'MixerTwelveCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '307',
              texttableentry: 'MixerTwelveCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '308',
              texttableentry: 'MixerThirteenCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '309',
              texttableentry: 'MixerThirteenCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '310',
              texttableentry: 'MixerFourteenCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '311',
              texttableentry: 'MixerFourteenCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '312',
              texttableentry: 'MixerFifteenCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '313',
              texttableentry: 'MixerFifteenCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '314',
              texttableentry: 'MixerSixteenCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '315',
              texttableentry: 'MixerSixteenCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BrineInletTemperatureSensor',
              isRead: 'true',
              interval: '316',
              texttableentry: 'BrineInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BrineOutletTemperatureSensor',
              isRead: 'true',
              interval: '317',
              texttableentry: 'BrineOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterPressureSensor',
              isRead: 'true',
              interval: '318',
              texttableentry: 'WaterPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BrinePresssureSensor',
              isRead: 'true',
              interval: '319',
              texttableentry: 'BrinePresssureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerLiquidTemperatureSensor',
              isRead: 'true',
              interval: '320',
              texttableentry: 'PrimaryHeatExchangerLiquidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorInletTemperatureSensor',
              isRead: 'true',
              interval: '321',
              texttableentry: 'CompressorInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorInletPressureSensor',
              isRead: 'true',
              interval: '322',
              texttableentry: 'CompressorInletPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnhancedVapourInjectionTemperatureSensor',
              isRead: 'true',
              interval: '323',
              texttableentry: 'EnhancedVapourInjectionTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOutletTemperatureSensor',
              isRead: 'true',
              interval: '324',
              texttableentry: 'CompressorOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOutletPressureSensor',
              isRead: 'true',
              interval: '325',
              texttableentry: 'CompressorOutletPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DischargeTwoTemperatureSensor',
              isRead: 'true',
              interval: '326',
              texttableentry: 'DischargeTwoTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OutdoorAirTemperatureSensor',
              isRead: 'true',
              interval: '327',
              texttableentry: 'OutdoorAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupplyAirTemperatureSensor',
              isRead: 'true',
              interval: '328',
              texttableentry: 'SupplyAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExtractAirTemperatureSensor',
              isRead: 'true',
              interval: '329',
              texttableentry: 'ExtractAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirTemperatureSensor',
              isRead: 'true',
              interval: '330',
              texttableentry: 'ExhaustAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlueGasTemperatureSensor',
              isRead: 'true',
              interval: '331',
              texttableentry: 'FlueGasTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CoSensor',
              isRead: 'true',
              interval: '332',
              texttableentry: 'CoSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTemperatureSensor',
              isRead: 'true',
              interval: '333',
              texttableentry: 'RoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '334',
              texttableentry: 'MixerOneCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '335',
              texttableentry: 'MixerTwoCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '336',
              texttableentry: 'MixerThreeCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '337',
              texttableentry: 'MixerFourCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '338',
              texttableentry: 'MixerFiveCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '339',
              texttableentry: 'MixerSixCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '340',
              texttableentry: 'MixerSevenCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '341',
              texttableentry: 'MixerEightCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '342',
              texttableentry: 'MixerNineCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '343',
              texttableentry: 'MixerTenCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '344',
              texttableentry: 'MixerElevenCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '345',
              texttableentry: 'MixerTwelveCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '346',
              texttableentry: 'MixerThirteenCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '347',
              texttableentry: 'MixerFourteenCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '348',
              texttableentry: 'MixerFifteenCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '349',
              texttableentry: 'MixerSixteenCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlowOneSensor',
              isRead: 'true',
              interval: '350',
              texttableentry: 'FlowOneSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlowTwoSensor',
              isRead: 'true',
              interval: '351',
              texttableentry: 'FlowTwoSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlowOneSwitch',
              isRead: 'true',
              interval: '352',
              texttableentry: 'FlowOneSwitch',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlowTwoSwitch',
              isRead: 'true',
              interval: '353',
              texttableentry: 'FlowTwoSwitch',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerBaseHeater',
              isRead: 'true',
              interval: '354',
              texttableentry: 'PrimaryHeatExchangerBaseHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerLiquidTemperatureSensor',
              isRead: 'true',
              interval: '355',
              texttableentry: 'SecondaryHeatExchangerLiquidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MainPowerSupplyValue',
              isRead: 'true',
              interval: '356',
              texttableentry: 'MainPowerSupplyValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MainPowerSupplyMinValue',
              isRead: 'true',
              interval: '357',
              texttableentry: 'MainPowerSupplyMinValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MainPowerSupplyMaxValue',
              isRead: 'true',
              interval: '358',
              texttableentry: 'MainPowerSupplyMaxValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterInletSensor',
              isRead: 'true',
              interval: '359',
              texttableentry: 'DomesticHotWaterInletSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterOutletSensor',
              isRead: 'true',
              interval: '360',
              texttableentry: 'DomesticHotWaterOutletSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MainPowerSupplyAverageValue',
              isRead: 'true',
              interval: '361',
              texttableentry: 'MainPowerSupplyAverageValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SafetyTemperatureLimiterOneSwitch',
              isRead: 'true',
              interval: '362',
              texttableentry: 'SafetyTemperatureLimiterOneSwitch',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SafetyTemperatureLimiterTwoSwitch',
              isRead: 'true',
              interval: '363',
              texttableentry: 'SafetyTemperatureLimiterTwoSwitch',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_Flame',
              isRead: 'true',
              interval: '364',
              texttableentry: 'Flame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlameStatistical',
              isRead: 'true',
              interval: '365',
              texttableentry: 'FlameStatistical',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Ignitor',
              isRead: 'true',
              interval: '366',
              texttableentry: 'Ignitor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelValve',
              isRead: 'true',
              interval: '367',
              texttableentry: 'FuelValve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelValveTargetPositionPercent',
              isRead: 'true',
              interval: '368',
              texttableentry: 'FuelValveTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelValveCurrentPositionPercent',
              isRead: 'true',
              interval: '369',
              texttableentry: 'FuelValveCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelValveTargetPositionStep',
              isRead: 'true',
              interval: '370',
              texttableentry: 'FuelValveTargetPositionStep',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelValveCurrentPositionStep',
              isRead: 'true',
              interval: '371',
              texttableentry: 'FuelValveCurrentPositionStep',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_Fan',
              isRead: 'true',
              interval: '372',
              texttableentry: 'Fan',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FanTargetSpeed',
              isRead: 'true',
              interval: '373',
              texttableentry: 'FanTargetSpeed',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FanCurrentSpeed',
              isRead: 'true',
              interval: '374',
              texttableentry: 'FanCurrentSpeed',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FanSpeedOffset',
              isRead: 'true',
              interval: '375',
              texttableentry: 'FanSpeedOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MassFlowSensor',
              isRead: 'true',
              interval: '376',
              texttableentry: 'MassFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumber',
              isRead: 'true',
              interval: '377',
              texttableentry: 'ViessmannIdentificationNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingPhaseOne',
              isRead: 'true',
              interval: '378',
              texttableentry: 'PointOfCommonCouplingPhaseOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingPhaseTwo',
              isRead: 'true',
              interval: '379',
              texttableentry: 'PointOfCommonCouplingPhaseTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingPhaseThree',
              isRead: 'true',
              interval: '380',
              texttableentry: 'PointOfCommonCouplingPhaseThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPump',
              isRead: 'true',
              interval: '381',
              texttableentry: 'CentralHeatingPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UnitsAndFormats',
              isRead: 'true',
              interval: '382',
              texttableentry: 'UnitsAndFormats',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasAirRatioSystem',
              isRead: 'true',
              interval: '383',
              texttableentry: 'GasAirRatioSystem',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiverterValveTargetPositionPercent',
              isRead: 'true',
              interval: '384',
              texttableentry: 'DiverterValveTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveCurrentPositionPercent',
              isRead: 'true',
              interval: '385',
              texttableentry: 'DiverterValveCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiverterValveTargetPosition',
              isRead: 'true',
              interval: '386',
              texttableentry: 'DiverterValveTargetPosition',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveCurrentPosition',
              isRead: 'true',
              interval: '387',
              texttableentry: 'DiverterValveCurrentPosition',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveOneTargetPositionPercent',
              isRead: 'true',
              interval: '388',
              texttableentry: 'ElectronicExpansionValveOneTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveOneCurrentPositionPercent',
              isRead: 'true',
              interval: '389',
              texttableentry: 'ElectronicExpansionValveOneCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveTwoTargetPositionPercent',
              isRead: 'true',
              interval: '390',
              texttableentry: 'ElectronicExpansionValveTwoTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveTwoCurrentPositionPercent',
              isRead: 'true',
              interval: '391',
              texttableentry: 'ElectronicExpansionValveTwoCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPump',
              isRead: 'true',
              interval: '392',
              texttableentry: 'DomesticHotWaterPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentMemoryPartOne',
              isRead: 'true',
              interval: '393',
              texttableentry: 'PersistentMemoryPartOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentMemoryPartTwo',
              isRead: 'true',
              interval: '394',
              texttableentry: 'PersistentMemoryPartTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingTemperatureSetpoint',
              isRead: 'true',
              interval: '395',
              texttableentry: 'CentralHeatingTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpoint',
              isRead: 'true',
              interval: '396',
              texttableentry: 'DomesticHotWaterTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpointCircuitOne',
              isRead: 'true',
              interval: '397',
              texttableentry: 'DomesticHotWaterTemperatureSetpointCircuitOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpointCircuitTwo',
              isRead: 'true',
              interval: '398',
              texttableentry: 'DomesticHotWaterTemperatureSetpointCircuitTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpointCircuitThree',
              isRead: 'true',
              interval: '399',
              texttableentry: 'DomesticHotWaterTemperatureSetpointCircuitThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpointCircuitFour',
              isRead: 'true',
              interval: '400',
              texttableentry: 'DomesticHotWaterTemperatureSetpointCircuitFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPump',
              isRead: 'true',
              interval: '401',
              texttableentry: 'MixerOneCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPump',
              isRead: 'true',
              interval: '402',
              texttableentry: 'MixerTwoCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPump',
              isRead: 'true',
              interval: '403',
              texttableentry: 'MixerThreeCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPump',
              isRead: 'true',
              interval: '404',
              texttableentry: 'MixerFourCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitPump',
              isRead: 'true',
              interval: '405',
              texttableentry: 'MixerFiveCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitPump',
              isRead: 'true',
              interval: '406',
              texttableentry: 'MixerSixCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitPump',
              isRead: 'true',
              interval: '407',
              texttableentry: 'MixerSevenCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitPump',
              isRead: 'true',
              interval: '408',
              texttableentry: 'MixerEightCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitPump',
              isRead: 'true',
              interval: '409',
              texttableentry: 'MixerNineCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitPump',
              isRead: 'true',
              interval: '410',
              texttableentry: 'MixerTenCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitPump',
              isRead: 'true',
              interval: '411',
              texttableentry: 'MixerElevenCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitPump',
              isRead: 'true',
              interval: '412',
              texttableentry: 'MixerTwelveCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitPump',
              isRead: 'true',
              interval: '413',
              texttableentry: 'MixerThirteenCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitPump',
              isRead: 'true',
              interval: '414',
              texttableentry: 'MixerFourteenCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitPump',
              isRead: 'true',
              interval: '415',
              texttableentry: 'MixerFifteenCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitPump',
              isRead: 'true',
              interval: '416',
              texttableentry: 'MixerSixteenCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPump',
              isRead: 'true',
              interval: '417',
              texttableentry: 'SolarCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OpenThermDomesticHotWaterTemperatureSetpoint',
              isRead: 'true',
              interval: '418',
              texttableentry: 'OpenThermDomesticHotWaterTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutdoorAirHumiditySensor',
              isRead: 'true',
              interval: '419',
              texttableentry: 'OutdoorAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupplyAirHumiditySensor',
              isRead: 'true',
              interval: '420',
              texttableentry: 'SupplyAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExtractAirHumiditySensor',
              isRead: 'true',
              interval: '421',
              texttableentry: 'ExtractAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirHumiditySensor',
              isRead: 'true',
              interval: '422',
              texttableentry: 'ExhaustAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '423',
              texttableentry: 'CentralHeatingRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '424',
              texttableentry: 'MixerOneCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupplyAirPressureSensor',
              isRead: 'true',
              interval: '425',
              texttableentry: 'SupplyAirPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '426',
              texttableentry: 'MixerTwoCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirPressureSensor',
              isRead: 'true',
              interval: '427',
              texttableentry: 'ExhaustAirPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '428',
              texttableentry: 'MixerThreeCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPreHeater',
              isRead: 'true',
              interval: '429',
              texttableentry: 'ElectricalPreHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '430',
              texttableentry: 'MixerFourCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupplyAirVolumeFlowSensor',
              isRead: 'true',
              interval: '431',
              texttableentry: 'SupplyAirVolumeFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '432',
              texttableentry: 'MixerFiveCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirVolumeFlowSensor',
              isRead: 'true',
              interval: '433',
              texttableentry: 'ExhaustAirVolumeFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '434',
              texttableentry: 'MixerSixCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationStageTargetVolumeFlow',
              isRead: 'true',
              interval: '435',
              texttableentry: 'VentilationStageTargetVolumeFlow',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '436',
              texttableentry: 'MixerSevenCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BypassOperationState',
              isRead: 'true',
              interval: '437',
              texttableentry: 'BypassOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '438',
              texttableentry: 'MixerEightCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BypassAvailableModes',
              isRead: 'true',
              interval: '439',
              texttableentry: 'BypassAvailableModes',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '440',
              texttableentry: 'MixerNineCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageInternalVoltage',
              isRead: 'true',
              interval: '441',
              texttableentry: 'ElectricalEnergyStorageInternalVoltage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '442',
              texttableentry: 'MixerTenCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageExternalVoltage',
              isRead: 'true',
              interval: '443',
              texttableentry: 'ElectricalEnergyStorageExternalVoltage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '444',
              texttableentry: 'MixerElevenCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageElectricCurrent',
              isRead: 'true',
              interval: '445',
              texttableentry: 'ElectricalEnergyStorageElectricCurrent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '446',
              texttableentry: 'MixerTwelveCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageElectricCurrentReference',
              isRead: 'true',
              interval: '447',
              texttableentry: 'ElectricalEnergyStorageElectricCurrentReference',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '448',
              texttableentry: 'MixerThirteenCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyMatrix',
              isRead: 'true',
              interval: '449',
              texttableentry: 'ElectricalEnergyMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '450',
              texttableentry: 'MixerFourteenCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalAlternatingCurrentPowerSetpoint',
              isRead: 'true',
              interval: '451',
              texttableentry: 'ExternalAlternatingCurrentPowerSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '452',
              texttableentry: 'MixerFifteenCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrechargeRelais',
              isRead: 'true',
              interval: '453',
              texttableentry: 'PrechargeRelais',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '454',
              texttableentry: 'MixerSixteenCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MainPowerRelais',
              isRead: 'true',
              interval: '455',
              texttableentry: 'MainPowerRelais',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalRoomSetpoint',
              isRead: 'true',
              interval: '456',
              texttableentry: 'ExternalRoomSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpStatistical',
              isRead: 'true',
              interval: '457',
              texttableentry: 'CentralHeatingPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPumpStatistical',
              isRead: 'true',
              interval: '458',
              texttableentry: 'DomesticHotWaterPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpStatistical',
              isRead: 'true',
              interval: '459',
              texttableentry: 'MixerOneCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpStatistical',
              isRead: 'true',
              interval: '460',
              texttableentry: 'MixerTwoCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpStatistical',
              isRead: 'true',
              interval: '461',
              texttableentry: 'MixerThreeCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpStatistical',
              isRead: 'true',
              interval: '462',
              texttableentry: 'MixerFourCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitPumpStatistical',
              isRead: 'true',
              interval: '463',
              texttableentry: 'MixerFiveCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitPumpStatistical',
              isRead: 'true',
              interval: '464',
              texttableentry: 'MixerSixCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitPumpStatistical',
              isRead: 'true',
              interval: '465',
              texttableentry: 'MixerSevenCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitPumpStatistical',
              isRead: 'true',
              interval: '466',
              texttableentry: 'MixerEightCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitPumpStatistical',
              isRead: 'true',
              interval: '467',
              texttableentry: 'MixerNineCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitPumpStatistical',
              isRead: 'true',
              interval: '468',
              texttableentry: 'MixerTenCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitPumpStatistical',
              isRead: 'true',
              interval: '469',
              texttableentry: 'MixerElevenCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitPumpStatistical',
              isRead: 'true',
              interval: '470',
              texttableentry: 'MixerTwelveCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitPumpStatistical',
              isRead: 'true',
              interval: '471',
              texttableentry: 'MixerThirteenCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitPumpStatistical',
              isRead: 'true',
              interval: '472',
              texttableentry: 'MixerFourteenCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitPumpStatistical',
              isRead: 'true',
              interval: '473',
              texttableentry: 'MixerFifteenCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitPumpStatistical',
              isRead: 'true',
              interval: '474',
              texttableentry: 'MixerSixteenCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '475',
              texttableentry: 'MixerOneCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '476',
              texttableentry: 'MixerTwoCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '477',
              texttableentry: 'MixerThreeCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '478',
              texttableentry: 'MixerFourCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '479',
              texttableentry: 'MixerFiveCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '480',
              texttableentry: 'MixerSixCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '481',
              texttableentry: 'MixerSevenCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '482',
              texttableentry: 'MixerEightCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '483',
              texttableentry: 'MixerNineCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '484',
              texttableentry: 'MixerTenCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '485',
              texttableentry: 'MixerElevenCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '486',
              texttableentry: 'MixerTwelveCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '487',
              texttableentry: 'MixerThirteenCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '488',
              texttableentry: 'MixerFourteenCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '489',
              texttableentry: 'MixerFifteenCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '490',
              texttableentry: 'MixerSixteenCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPump',
              isRead: 'true',
              interval: '491',
              texttableentry: 'DomesticHotWaterCirculationPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitOne',
              isRead: 'true',
              interval: '492',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitTwo',
              isRead: 'true',
              interval: '493',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitThree',
              isRead: 'true',
              interval: '494',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitFour',
              isRead: 'true',
              interval: '495',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpDemand',
              isRead: 'true',
              interval: '496',
              texttableentry: 'DomesticHotWaterCirculationPumpDemand',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpMode',
              isRead: 'true',
              interval: '497',
              texttableentry: 'DomesticHotWaterCirculationPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FanCumulatedStatistical',
              isRead: 'true',
              interval: '498',
              texttableentry: 'FanCumulatedStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatDemandExternalDc',
              isRead: 'true',
              interval: '499',
              texttableentry: 'CentralHeatDemandExternalDc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatDemandExternalAc',
              isRead: 'true',
              interval: '500',
              texttableentry: 'CentralHeatDemandExternalAc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatDemandExternalAccessory',
              isRead: 'true',
              interval: '501',
              texttableentry: 'CentralHeatDemandExternalAccessory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingSetpointMetaData',
              isRead: 'true',
              interval: '502',
              texttableentry: 'CentralHeatingSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ScaldProtection',
              isRead: 'true',
              interval: '503',
              texttableentry: 'ScaldProtection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterSetpointMetaData',
              isRead: 'true',
              interval: '504',
              texttableentry: 'DomesticHotWaterSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Date',
              isRead: 'true',
              interval: '505',
              texttableentry: 'Date',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Time',
              isRead: 'true',
              interval: '506',
              texttableentry: 'Time',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinated',
              isRead: 'true',
              interval: '507',
              texttableentry: 'UniversalTimeCoordinated',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinatedOffset',
              isRead: 'true',
              interval: '508',
              texttableentry: 'UniversalTimeCoordinatedOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NtpStatus',
              isRead: 'true',
              interval: '509',
              texttableentry: 'NtpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_Language',
              isRead: 'true',
              interval: '510',
              texttableentry: 'Language',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhase',
              isRead: 'true',
              interval: '511',
              texttableentry: 'HolidayPhase',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhase',
              isRead: 'true',
              interval: '512',
              texttableentry: 'HolidayAtHomePhase',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitOne',
              isRead: 'true',
              interval: '513',
              texttableentry: 'HolidayPhaseCircuitOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitOne',
              isRead: 'true',
              interval: '514',
              texttableentry: 'HolidayAtHomePhaseCircuitOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitTwo',
              isRead: 'true',
              interval: '515',
              texttableentry: 'HolidayPhaseCircuitTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitTwo',
              isRead: 'true',
              interval: '516',
              texttableentry: 'HolidayAtHomePhaseCircuitTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitThree',
              isRead: 'true',
              interval: '517',
              texttableentry: 'HolidayPhaseCircuitThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitThree',
              isRead: 'true',
              interval: '518',
              texttableentry: 'HolidayAtHomePhaseCircuitThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitFour',
              isRead: 'true',
              interval: '519',
              texttableentry: 'HolidayPhaseCircuitFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitFour',
              isRead: 'true',
              interval: '520',
              texttableentry: 'HolidayAtHomePhaseCircuitFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OperatingHoursTillService',
              isRead: 'true',
              interval: '521',
              texttableentry: 'OperatingHoursTillService',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceDateNext',
              isRead: 'true',
              interval: '522',
              texttableentry: 'ServiceDateNext',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceDateLast',
              isRead: 'true',
              interval: '523',
              texttableentry: 'ServiceDateLast',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ModulationTargetSetpoint',
              isRead: 'true',
              interval: '524',
              texttableentry: 'ModulationTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalModulationSetpoint',
              isRead: 'true',
              interval: '525',
              texttableentry: 'ExternalModulationSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ModulationCurrentValue',
              isRead: 'true',
              interval: '526',
              texttableentry: 'ModulationCurrentValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '527',
              texttableentry: 'FlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalTargetFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '528',
              texttableentry: 'ExternalTargetFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HumiditySensor',
              isRead: 'true',
              interval: '529',
              texttableentry: 'HumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingOperationState',
              isRead: 'true',
              interval: '530',
              texttableentry: 'CentralHeatingOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterOperationState',
              isRead: 'true',
              interval: '531',
              texttableentry: 'DomesticHotWaterOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoolingTargetOperationState',
              isRead: 'true',
              interval: '532',
              texttableentry: 'CoolingTargetOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationTargetOperationLevel',
              isRead: 'true',
              interval: '533',
              texttableentry: 'VentilationTargetOperationLevel',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPumpPostRunTime',
              isRead: 'true',
              interval: '534',
              texttableentry: 'DomesticHotWaterPumpPostRunTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectElectricalEnergyStatistical',
              isRead: 'true',
              interval: '535',
              texttableentry: 'ObjectElectricalEnergyStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CoolingTargetOperationMode',
              isRead: 'true',
              interval: '536',
              texttableentry: 'CoolingTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerOneCircuitTargetOperationMode',
              isRead: 'true',
              interval: '537',
              texttableentry: 'ExternalMixerOneCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalDomesticHotWaterTargetOperationMode',
              isRead: 'true',
              interval: '538',
              texttableentry: 'ExternalDomesticHotWaterTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalCoolingTargetOperationMode',
              isRead: 'true',
              interval: '539',
              texttableentry: 'ExternalCoolingTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingTargetHeatNeed',
              isRead: 'true',
              interval: '540',
              texttableentry: 'CentralHeatingTargetHeatNeed',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTargetHeatNeed',
              isRead: 'true',
              interval: '541',
              texttableentry: 'DomesticHotWaterTargetHeatNeed',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoolingTargetHeatNeed',
              isRead: 'true',
              interval: '542',
              texttableentry: 'CoolingTargetHeatNeed',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SmartGridReadyConsolidator',
              isRead: 'true',
              interval: '543',
              texttableentry: 'SmartGridReadyConsolidator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionCentralHeating',
              isRead: 'true',
              interval: '544',
              texttableentry: 'GasConsumptionCentralHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionDomesticHotWater',
              isRead: 'true',
              interval: '545',
              texttableentry: 'GasConsumptionDomesticHotWater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OilConsumptionCentralHeating',
              isRead: 'true',
              interval: '546',
              texttableentry: 'OilConsumptionCentralHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OilConsumptionDomesticHotWater',
              isRead: 'true',
              interval: '547',
              texttableentry: 'OilConsumptionDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeating',
              isRead: 'true',
              interval: '548',
              texttableentry: 'EnergyConsumptionCentralHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerOneCircuit',
              isRead: 'true',
              interval: '549',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerOneCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerTwoCircuit',
              isRead: 'true',
              interval: '550',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerTwoCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerThreeCircuit',
              isRead: 'true',
              interval: '551',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerThreeCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerFourCircuit',
              isRead: 'true',
              interval: '552',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerFourCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerFiveCircuit',
              isRead: 'true',
              interval: '553',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerFiveCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerSixCircuit',
              isRead: 'true',
              interval: '554',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerSixCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerSevenCircuit',
              isRead: 'true',
              interval: '555',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerSevenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerEightCircuit',
              isRead: 'true',
              interval: '556',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerEightCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerNineCircuit',
              isRead: 'true',
              interval: '557',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerNineCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerTenCircuit',
              isRead: 'true',
              interval: '558',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerTenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerElevenCircuit',
              isRead: 'true',
              interval: '559',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerElevenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerTwelveCircuit',
              isRead: 'true',
              interval: '560',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerTwelveCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerThirteenCircuit',
              isRead: 'true',
              interval: '561',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerThirteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerFourteenCircuit',
              isRead: 'true',
              interval: '562',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerFourteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerFifteenCircuit',
              isRead: 'true',
              interval: '563',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerFifteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMixerSixteenCircuit',
              isRead: 'true',
              interval: '564',
              texttableentry: 'EnergyConsumptionCentralHeatingMixerSixteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWater',
              isRead: 'true',
              interval: '565',
              texttableentry: 'EnergyConsumptionDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCooling',
              isRead: 'true',
              interval: '566',
              texttableentry: 'EnergyConsumptionCooling',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedElectricity',
              isRead: 'true',
              interval: '567',
              texttableentry: 'GeneratedElectricity',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoTwoSavings',
              isRead: 'true',
              interval: '568',
              texttableentry: 'CoTwoSavings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetSensorMinMaxAverageStatistics',
              isRead: 'true',
              interval: '569',
              texttableentry: 'ResetSensorMinMaxAverageStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetStatistics',
              isRead: 'true',
              interval: '570',
              texttableentry: 'ResetStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValues',
              isRead: 'false',
              interval: '571',
              texttableentry: 'SetDefaultValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValuesDate',
              isRead: 'true',
              interval: '572',
              texttableentry: 'SetDefaultValuesDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteReset',
              isRead: 'true',
              interval: '573',
              texttableentry: 'RemoteReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteResetCounter',
              isRead: 'true',
              interval: '574',
              texttableentry: 'RemoteResetCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatusDate',
              isRead: 'true',
              interval: '576',
              texttableentry: 'SetDeliveryStatusDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeliveryStatusActive',
              isRead: 'true',
              interval: '577',
              texttableentry: 'DeliveryStatusActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetFailSafeMode',
              isRead: 'true',
              interval: '578',
              texttableentry: 'SetFailSafeMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionInitialisation',
              isRead: 'true',
              interval: '579',
              texttableentry: 'ProductionInitialisation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerOnCounter',
              isRead: 'true',
              interval: '582',
              texttableentry: 'PowerOnCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingSwitches',
              isRead: 'true',
              interval: '583',
              texttableentry: 'CentralHeatingSwitches',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterSwitches',
              isRead: 'true',
              interval: '584',
              texttableentry: 'DomesticHotWaterSwitches',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CoolingSwitches',
              isRead: 'true',
              interval: '585',
              texttableentry: 'CoolingSwitches',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingOperationHours',
              isRead: 'true',
              interval: '586',
              texttableentry: 'CentralHeatingOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterOperationHours',
              isRead: 'true',
              interval: '587',
              texttableentry: 'DomesticHotWaterOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CoolingOperationHours',
              isRead: 'true',
              interval: '588',
              texttableentry: 'CoolingOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationOperationHours',
              isRead: 'true',
              interval: '589',
              texttableentry: 'VentilationOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOperationHours',
              isRead: 'true',
              interval: '590',
              texttableentry: 'ElectronicControlUnitOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InternalWatchDogCounter',
              isRead: 'true',
              interval: '591',
              texttableentry: 'InternalWatchDogCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MacAddressLan',
              isRead: 'true',
              interval: '592',
              texttableentry: 'MacAddressLan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayMac',
              isRead: 'true',
              interval: '593',
              texttableentry: 'GatewayMac',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPartLoadKw',
              isRead: 'true',
              interval: '594',
              texttableentry: 'CentralHeatingPartLoadKw',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPartLoadKw',
              isRead: 'true',
              interval: '595',
              texttableentry: 'DomesticHotWaterPartLoadKw',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPartLoadPercent',
              isRead: 'true',
              interval: '596',
              texttableentry: 'CentralHeatingPartLoadPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPartLoadPercent',
              isRead: 'true',
              interval: '597',
              texttableentry: 'DomesticHotWaterPartLoadPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MinimumLoadKwValueMetaData',
              isRead: 'true',
              interval: '598',
              texttableentry: 'MinimumLoadKwValueMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPartLoadMaxKwValueMetaData',
              isRead: 'true',
              interval: '599',
              texttableentry: 'CentralHeatingPartLoadMaxKwValueMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellReset',
              isRead: 'true',
              interval: '600',
              texttableentry: 'FuelCellReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPartLoadMaxKwValueMetaData',
              isRead: 'true',
              interval: '601',
              texttableentry: 'DomesticHotWaterPartLoadMaxKwValueMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteLocalNetworkStatus',
              isRead: 'true',
              interval: '602',
              texttableentry: 'GatewayRemoteLocalNetworkStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayApEnable',
              isRead: 'true',
              interval: '603',
              texttableentry: 'GatewayApEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayApDataSet',
              isRead: 'true',
              interval: '604',
              texttableentry: 'GatewayApDataSet',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogInputConfigurationOnBoardOne',
              isRead: 'true',
              interval: '605',
              texttableentry: 'GenericAnalogInputConfigurationOnBoardOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogInputConfigurationOnBoardTwo',
              isRead: 'true',
              interval: '606',
              texttableentry: 'GenericAnalogInputConfigurationOnBoardTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIp',
              isRead: 'true',
              interval: '607',
              texttableentry: 'GatewayRemoteIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryDnsServer',
              isRead: 'true',
              interval: '608',
              texttableentry: 'SecondaryDnsServer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyServer',
              isRead: 'true',
              interval: '609',
              texttableentry: 'ProxyServer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyPort',
              isRead: 'true',
              interval: '610',
              texttableentry: 'ProxyPort',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyUser',
              isRead: 'true',
              interval: '611',
              texttableentry: 'ProxyUser',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyPassword',
              isRead: 'false',
              interval: '612',
              texttableentry: 'ProxyPassword',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyEnabled',
              isRead: 'true',
              interval: '613',
              texttableentry: 'ProxyEnabled',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteUpdateStatus',
              isRead: 'true',
              interval: '614',
              texttableentry: 'RemoteUpdateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RemoteUpdateCounter',
              isRead: 'true',
              interval: '615',
              texttableentry: 'RemoteUpdateCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteEnable',
              isRead: 'true',
              interval: '616',
              texttableentry: 'GatewayRemoteEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSsid',
              isRead: 'false',
              interval: '617',
              texttableentry: 'GatewayRemoteSsid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIpStatic',
              isRead: 'true',
              interval: '618',
              texttableentry: 'GatewayRemoteIpStatic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteScanNetwork',
              isRead: 'true',
              interval: '619',
              texttableentry: 'GatewayRemoteScanNetwork',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticServiceConnectionStatus',
              isRead: 'true',
              interval: '620',
              texttableentry: 'DiagnosticServiceConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ObjectContactDetails',
              isRead: 'true',
              interval: '621',
              texttableentry: 'ObjectContactDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerDetails',
              isRead: 'true',
              interval: '622',
              texttableentry: 'CustomerDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceEngineer',
              isRead: 'true',
              interval: '623',
              texttableentry: 'ServiceEngineer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TechnicalSupport',
              isRead: 'true',
              interval: '624',
              texttableentry: 'TechnicalSupport',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectDetails',
              isRead: 'true',
              interval: '625',
              texttableentry: 'ObjectDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationMatrix',
              isRead: 'true',
              interval: '626',
              texttableentry: 'VentilationMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingOneCircuitName',
              isRead: 'true',
              interval: '627',
              texttableentry: 'CentralHeatingOneCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingTwoCircuitName',
              isRead: 'true',
              interval: '628',
              texttableentry: 'CentralHeatingTwoCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingThreeCircuitName',
              isRead: 'true',
              interval: '629',
              texttableentry: 'CentralHeatingThreeCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingFourCircuitName',
              isRead: 'true',
              interval: '630',
              texttableentry: 'CentralHeatingFourCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingFiveCircuitName',
              isRead: 'true',
              interval: '631',
              texttableentry: 'CentralHeatingFiveCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingSixCircuitName',
              isRead: 'true',
              interval: '632',
              texttableentry: 'CentralHeatingSixCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingSevenCircuitName',
              isRead: 'true',
              interval: '633',
              texttableentry: 'CentralHeatingSevenCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingEightCircuitName',
              isRead: 'true',
              interval: '634',
              texttableentry: 'CentralHeatingEightCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingNineCircuitName',
              isRead: 'true',
              interval: '635',
              texttableentry: 'CentralHeatingNineCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingTenCircuitName',
              isRead: 'true',
              interval: '636',
              texttableentry: 'CentralHeatingTenCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingElevenCircuitName',
              isRead: 'true',
              interval: '637',
              texttableentry: 'CentralHeatingElevenCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingTwelveCircuitName',
              isRead: 'true',
              interval: '638',
              texttableentry: 'CentralHeatingTwelveCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingThirteenCircuitName',
              isRead: 'true',
              interval: '639',
              texttableentry: 'CentralHeatingThirteenCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingFourteenCircuitName',
              isRead: 'true',
              interval: '640',
              texttableentry: 'CentralHeatingFourteenCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingFifteenCircuitName',
              isRead: 'true',
              interval: '641',
              texttableentry: 'CentralHeatingFifteenCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingSixteenCircuitName',
              isRead: 'true',
              interval: '642',
              texttableentry: 'CentralHeatingSixteenCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalOutputConfigurationOnBoardOne',
              isRead: 'true',
              interval: '643',
              texttableentry: 'GenericDigitalOutputConfigurationOnBoardOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalOutputConfigurationOnBoardTwo',
              isRead: 'true',
              interval: '644',
              texttableentry: 'GenericDigitalOutputConfigurationOnBoardTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryOneModulFunction',
              isRead: 'true',
              interval: '645',
              texttableentry: 'GenericAnalogDigitalAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryTwoModulFunction',
              isRead: 'true',
              interval: '646',
              texttableentry: 'GenericAnalogDigitalAccessoryTwoModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryThreeModulFunction',
              isRead: 'true',
              interval: '647',
              texttableentry: 'GenericAnalogDigitalAccessoryThreeModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryFourModulFunction',
              isRead: 'true',
              interval: '648',
              texttableentry: 'GenericAnalogDigitalAccessoryFourModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryFiveModulFunction',
              isRead: 'true',
              interval: '649',
              texttableentry: 'GenericAnalogDigitalAccessoryFiveModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryOneModulFunction',
              isRead: 'true',
              interval: '650',
              texttableentry: 'GenericDigitalAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryTwoModulFunction',
              isRead: 'true',
              interval: '651',
              texttableentry: 'GenericDigitalAccessoryTwoModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryThreeModulFunction',
              isRead: 'true',
              interval: '652',
              texttableentry: 'GenericDigitalAccessoryThreeModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryFourModulFunction',
              isRead: 'true',
              interval: '653',
              texttableentry: 'GenericDigitalAccessoryFourModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryFiveModulFunction',
              isRead: 'true',
              interval: '654',
              texttableentry: 'GenericDigitalAccessoryFiveModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalOutputConfigurationOne',
              isRead: 'true',
              interval: '655',
              texttableentry: 'GenericDigitalOutputConfigurationOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalOutputConfigurationTwo',
              isRead: 'true',
              interval: '656',
              texttableentry: 'GenericDigitalOutputConfigurationTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalOutputConfigurationThree',
              isRead: 'true',
              interval: '657',
              texttableentry: 'GenericDigitalOutputConfigurationThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalOutputConfigurationFour',
              isRead: 'true',
              interval: '658',
              texttableentry: 'GenericDigitalOutputConfigurationFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalOutputConfigurationFive',
              isRead: 'true',
              interval: '659',
              texttableentry: 'GenericDigitalOutputConfigurationFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOne',
              isRead: 'true',
              interval: '660',
              texttableentry: 'GenericDigitalInputConfigurationOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationTwo',
              isRead: 'true',
              interval: '661',
              texttableentry: 'GenericDigitalInputConfigurationTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationThree',
              isRead: 'true',
              interval: '662',
              texttableentry: 'GenericDigitalInputConfigurationThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationFour',
              isRead: 'true',
              interval: '663',
              texttableentry: 'GenericDigitalInputConfigurationFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogInputConfigurationOne',
              isRead: 'true',
              interval: '664',
              texttableentry: 'GenericAnalogInputConfigurationOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogInputConfigurationTwo',
              isRead: 'true',
              interval: '665',
              texttableentry: 'GenericAnalogInputConfigurationTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogInputConfigurationThree',
              isRead: 'true',
              interval: '666',
              texttableentry: 'GenericAnalogInputConfigurationThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogInputConfigurationFour',
              isRead: 'true',
              interval: '667',
              texttableentry: 'GenericAnalogInputConfigurationFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogInputConfigurationFive',
              isRead: 'true',
              interval: '668',
              texttableentry: 'GenericAnalogInputConfigurationFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericZeroToTenInputConfiguration',
              isRead: 'true',
              interval: '669',
              texttableentry: 'GenericZeroToTenInputConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericZeroToTenOutputConfiguration',
              isRead: 'true',
              interval: '670',
              texttableentry: 'GenericZeroToTenOutputConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericPWMOutputConfigurationOne',
              isRead: 'true',
              interval: '671',
              texttableentry: 'GenericPWMOutputConfigurationOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericPWMOutputConfigurationTwo',
              isRead: 'true',
              interval: '672',
              texttableentry: 'GenericPWMOutputConfigurationTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMcuIoAccessoryOneModulFunction',
              isRead: 'true',
              interval: '673',
              texttableentry: 'GenericMcuIoAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMcuIoAccessoryTwoModulFunction',
              isRead: 'true',
              interval: '674',
              texttableentry: 'GenericMcuIoAccessoryTwoModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMcuIoAccessoryThreeModulFunction',
              isRead: 'true',
              interval: '675',
              texttableentry: 'GenericMcuIoAccessoryThreeModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMTwoIoAccessoryOneModuleFunction',
              isRead: 'true',
              interval: '676',
              texttableentry: 'GenericMTwoIoAccessoryOneModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMTwoIoAccessoryTwoModuleFunction',
              isRead: 'true',
              interval: '677',
              texttableentry: 'GenericMTwoIoAccessoryTwoModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMTwoIoAccessoryThreeModuleFunction',
              isRead: 'true',
              interval: '678',
              texttableentry: 'GenericMTwoIoAccessoryThreeModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MBusHeatMeter',
              isRead: 'true',
              interval: '679',
              texttableentry: 'MBusHeatMeter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyMeter',
              isRead: 'true',
              interval: '680',
              texttableentry: 'EnergyMeter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MBusFlowMeter',
              isRead: 'true',
              interval: '681',
              texttableentry: 'MBusFlowMeter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BurnerBlockingTargetTime',
              isRead: 'true',
              interval: '682',
              texttableentry: 'BurnerBlockingTargetTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BurnerBlockingRemainingTime',
              isRead: 'true',
              interval: '683',
              texttableentry: 'BurnerBlockingRemainingTime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ConsolidatedClimateTimeScheduleMonday',
              isRead: 'true',
              interval: '684',
              texttableentry: 'ConsolidatedClimateTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ConsolidatedClimateTimeScheduleTuesday',
              isRead: 'true',
              interval: '685',
              texttableentry: 'ConsolidatedClimateTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ConsolidatedClimateTimeScheduleWednesday',
              isRead: 'true',
              interval: '686',
              texttableentry: 'ConsolidatedClimateTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ConsolidatedClimateTimeScheduleThursday',
              isRead: 'true',
              interval: '687',
              texttableentry: 'ConsolidatedClimateTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ConsolidatedClimateTimeScheduleFriday',
              isRead: 'true',
              interval: '688',
              texttableentry: 'ConsolidatedClimateTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ConsolidatedClimateTimeScheduleSaturday',
              isRead: 'true',
              interval: '689',
              texttableentry: 'ConsolidatedClimateTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ConsolidatedClimateTimeScheduleSunday',
              isRead: 'true',
              interval: '690',
              texttableentry: 'ConsolidatedClimateTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleMonday',
              isRead: 'true',
              interval: '691',
              texttableentry: 'DomesticHotWaterTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleTuesday',
              isRead: 'true',
              interval: '692',
              texttableentry: 'DomesticHotWaterTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleWednesday',
              isRead: 'true',
              interval: '693',
              texttableentry: 'DomesticHotWaterTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleThursday',
              isRead: 'true',
              interval: '694',
              texttableentry: 'DomesticHotWaterTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleFriday',
              isRead: 'true',
              interval: '695',
              texttableentry: 'DomesticHotWaterTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleSaturday',
              isRead: 'true',
              interval: '696',
              texttableentry: 'DomesticHotWaterTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleSunday',
              isRead: 'true',
              interval: '697',
              texttableentry: 'DomesticHotWaterTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitOneScheduleMonday',
              isRead: 'true',
              interval: '698',
              texttableentry: 'DomesticHotWaterTimeCircuitOneScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitOneScheduleTuesday',
              isRead: 'true',
              interval: '699',
              texttableentry: 'DomesticHotWaterTimeCircuitOneScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitOneScheduleWednesday',
              isRead: 'true',
              interval: '700',
              texttableentry: 'DomesticHotWaterTimeCircuitOneScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitOneScheduleThursday',
              isRead: 'true',
              interval: '701',
              texttableentry: 'DomesticHotWaterTimeCircuitOneScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitOneScheduleFriday',
              isRead: 'true',
              interval: '702',
              texttableentry: 'DomesticHotWaterTimeCircuitOneScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitOneScheduleSaturday',
              isRead: 'true',
              interval: '703',
              texttableentry: 'DomesticHotWaterTimeCircuitOneScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitOneScheduleSunday',
              isRead: 'true',
              interval: '704',
              texttableentry: 'DomesticHotWaterTimeCircuitOneScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitTwoScheduleMonday',
              isRead: 'true',
              interval: '705',
              texttableentry: 'DomesticHotWaterTimeCircuitTwoScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitTwoScheduleTuesday',
              isRead: 'true',
              interval: '706',
              texttableentry: 'DomesticHotWaterTimeCircuitTwoScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitTwoScheduleWednesday',
              isRead: 'true',
              interval: '707',
              texttableentry: 'DomesticHotWaterTimeCircuitTwoScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitTwoScheduleThursday',
              isRead: 'true',
              interval: '708',
              texttableentry: 'DomesticHotWaterTimeCircuitTwoScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitTwoScheduleFriday',
              isRead: 'true',
              interval: '709',
              texttableentry: 'DomesticHotWaterTimeCircuitTwoScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitTwoScheduleSaturday',
              isRead: 'true',
              interval: '710',
              texttableentry: 'DomesticHotWaterTimeCircuitTwoScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitTwoScheduleSunday',
              isRead: 'true',
              interval: '711',
              texttableentry: 'DomesticHotWaterTimeCircuitTwoScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitThreeScheduleMonday',
              isRead: 'true',
              interval: '712',
              texttableentry: 'DomesticHotWaterTimeCircuitThreeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitThreeScheduleTuesday',
              isRead: 'true',
              interval: '713',
              texttableentry: 'DomesticHotWaterTimeCircuitThreeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitThreeScheduleWednesday',
              isRead: 'true',
              interval: '714',
              texttableentry: 'DomesticHotWaterTimeCircuitThreeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitThreeScheduleThursday',
              isRead: 'true',
              interval: '715',
              texttableentry: 'DomesticHotWaterTimeCircuitThreeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitThreeScheduleFriday',
              isRead: 'true',
              interval: '716',
              texttableentry: 'DomesticHotWaterTimeCircuitThreeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitThreeScheduleSaturday',
              isRead: 'true',
              interval: '717',
              texttableentry: 'DomesticHotWaterTimeCircuitThreeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitThreeScheduleSunday',
              isRead: 'true',
              interval: '718',
              texttableentry: 'DomesticHotWaterTimeCircuitThreeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitFourScheduleMonday',
              isRead: 'true',
              interval: '719',
              texttableentry: 'DomesticHotWaterTimeCircuitFourScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitFourScheduleTuesday',
              isRead: 'true',
              interval: '720',
              texttableentry: 'DomesticHotWaterTimeCircuitFourScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitFourScheduleWednesday',
              isRead: 'true',
              interval: '721',
              texttableentry: 'DomesticHotWaterTimeCircuitFourScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitFourScheduleThursday',
              isRead: 'true',
              interval: '722',
              texttableentry: 'DomesticHotWaterTimeCircuitFourScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitFourScheduleFriday',
              isRead: 'true',
              interval: '723',
              texttableentry: 'DomesticHotWaterTimeCircuitFourScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitFourScheduleSaturday',
              isRead: 'true',
              interval: '724',
              texttableentry: 'DomesticHotWaterTimeCircuitFourScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeCircuitFourScheduleSunday',
              isRead: 'true',
              interval: '725',
              texttableentry: 'DomesticHotWaterTimeCircuitFourScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleMonday',
              isRead: 'true',
              interval: '726',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleTuesday',
              isRead: 'true',
              interval: '727',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleWednesday',
              isRead: 'true',
              interval: '728',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleThursday',
              isRead: 'true',
              interval: '729',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleFriday',
              isRead: 'true',
              interval: '730',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleSaturday',
              isRead: 'true',
              interval: '731',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleSunday',
              isRead: 'true',
              interval: '732',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitOneScheduleMonday',
              isRead: 'true',
              interval: '733',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitOneScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitOneScheduleTuesday',
              isRead: 'true',
              interval: '734',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitOneScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitOneScheduleWednesday',
              isRead: 'true',
              interval: '735',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitOneScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitOneScheduleThursday',
              isRead: 'true',
              interval: '736',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitOneScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitOneScheduleFriday',
              isRead: 'true',
              interval: '737',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitOneScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitOneScheduleSaturday',
              isRead: 'true',
              interval: '738',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitOneScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitOneScheduleSunday',
              isRead: 'true',
              interval: '739',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitOneScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitTwoScheduleMonday',
              isRead: 'true',
              interval: '740',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitTwoScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitTwoScheduleTuesday',
              isRead: 'true',
              interval: '741',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitTwoScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitTwoScheduleWednesday',
              isRead: 'true',
              interval: '742',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitTwoScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitTwoScheduleThursday',
              isRead: 'true',
              interval: '743',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitTwoScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitTwoScheduleFriday',
              isRead: 'true',
              interval: '744',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitTwoScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitTwoScheduleSaturday',
              isRead: 'true',
              interval: '745',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitTwoScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitTwoScheduleSunday',
              isRead: 'true',
              interval: '746',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitTwoScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitThreeScheduleMonday',
              isRead: 'true',
              interval: '747',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitThreeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitThreeScheduleTuesday',
              isRead: 'true',
              interval: '748',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitThreeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitThreeScheduleWednesday',
              isRead: 'true',
              interval: '749',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitThreeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitThreeScheduleThursday',
              isRead: 'true',
              interval: '750',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitThreeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitThreeScheduleFriday',
              isRead: 'true',
              interval: '751',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitThreeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitThreeScheduleSaturday',
              isRead: 'true',
              interval: '752',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitThreeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitThreeScheduleSunday',
              isRead: 'true',
              interval: '753',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitThreeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitFourScheduleMonday',
              isRead: 'true',
              interval: '754',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitFourScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitFourScheduleTuesday',
              isRead: 'true',
              interval: '755',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitFourScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitFourScheduleWednesday',
              isRead: 'true',
              interval: '756',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitFourScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitFourScheduleThursday',
              isRead: 'true',
              interval: '757',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitFourScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitFourScheduleFriday',
              isRead: 'true',
              interval: '758',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitFourScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitFourScheduleSaturday',
              isRead: 'true',
              interval: '759',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitFourScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeCircuitFourScheduleSunday',
              isRead: 'true',
              interval: '760',
              texttableentry: 'DomesticHotWaterCirculationTimeCircuitFourScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '761',
              texttableentry: 'MixerOneCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '762',
              texttableentry: 'MixerOneCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '763',
              texttableentry: 'MixerOneCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '764',
              texttableentry: 'MixerOneCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '765',
              texttableentry: 'MixerOneCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '766',
              texttableentry: 'MixerOneCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '767',
              texttableentry: 'MixerOneCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '768',
              texttableentry: 'MixerTwoCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '769',
              texttableentry: 'MixerTwoCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '770',
              texttableentry: 'MixerTwoCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '771',
              texttableentry: 'MixerTwoCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '772',
              texttableentry: 'MixerTwoCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '773',
              texttableentry: 'MixerTwoCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '774',
              texttableentry: 'MixerTwoCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '775',
              texttableentry: 'MixerThreeCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '776',
              texttableentry: 'MixerThreeCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '777',
              texttableentry: 'MixerThreeCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '778',
              texttableentry: 'MixerThreeCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '779',
              texttableentry: 'MixerThreeCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '780',
              texttableentry: 'MixerThreeCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '781',
              texttableentry: 'MixerThreeCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '782',
              texttableentry: 'MixerFourCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '783',
              texttableentry: 'MixerFourCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '784',
              texttableentry: 'MixerFourCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '785',
              texttableentry: 'MixerFourCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '786',
              texttableentry: 'MixerFourCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '787',
              texttableentry: 'MixerFourCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '788',
              texttableentry: 'MixerFourCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '789',
              texttableentry: 'MixerFiveCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '790',
              texttableentry: 'MixerFiveCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '791',
              texttableentry: 'MixerFiveCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '792',
              texttableentry: 'MixerFiveCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '793',
              texttableentry: 'MixerFiveCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '794',
              texttableentry: 'MixerFiveCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '795',
              texttableentry: 'MixerFiveCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '796',
              texttableentry: 'MixerSixCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '797',
              texttableentry: 'MixerSixCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '798',
              texttableentry: 'MixerSixCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '799',
              texttableentry: 'MixerSixCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '800',
              texttableentry: 'MixerSixCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '801',
              texttableentry: 'MixerSixCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '802',
              texttableentry: 'MixerSixCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '803',
              texttableentry: 'MixerSevenCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '804',
              texttableentry: 'MixerSevenCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '805',
              texttableentry: 'MixerSevenCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '806',
              texttableentry: 'MixerSevenCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '807',
              texttableentry: 'MixerSevenCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '808',
              texttableentry: 'MixerSevenCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '809',
              texttableentry: 'MixerSevenCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '810',
              texttableentry: 'MixerEightCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '811',
              texttableentry: 'MixerEightCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '812',
              texttableentry: 'MixerEightCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '813',
              texttableentry: 'MixerEightCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '814',
              texttableentry: 'MixerEightCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '815',
              texttableentry: 'MixerEightCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '816',
              texttableentry: 'MixerEightCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '817',
              texttableentry: 'MixerNineCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '818',
              texttableentry: 'MixerNineCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '819',
              texttableentry: 'MixerNineCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '820',
              texttableentry: 'MixerNineCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '821',
              texttableentry: 'MixerNineCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '822',
              texttableentry: 'MixerNineCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '823',
              texttableentry: 'MixerNineCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '824',
              texttableentry: 'MixerTenCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '825',
              texttableentry: 'MixerTenCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '826',
              texttableentry: 'MixerTenCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '827',
              texttableentry: 'MixerTenCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '828',
              texttableentry: 'MixerTenCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '829',
              texttableentry: 'MixerTenCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '830',
              texttableentry: 'MixerTenCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '831',
              texttableentry: 'MixerElevenCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '832',
              texttableentry: 'MixerElevenCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '833',
              texttableentry: 'MixerElevenCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '834',
              texttableentry: 'MixerElevenCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '835',
              texttableentry: 'MixerElevenCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '836',
              texttableentry: 'MixerElevenCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '837',
              texttableentry: 'MixerElevenCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '838',
              texttableentry: 'MixerTwelveCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '839',
              texttableentry: 'MixerTwelveCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '840',
              texttableentry: 'MixerTwelveCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '841',
              texttableentry: 'MixerTwelveCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '842',
              texttableentry: 'MixerTwelveCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '843',
              texttableentry: 'MixerTwelveCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '844',
              texttableentry: 'MixerTwelveCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '845',
              texttableentry: 'MixerThirteenCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '846',
              texttableentry: 'MixerThirteenCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '847',
              texttableentry: 'MixerThirteenCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '848',
              texttableentry: 'MixerThirteenCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '849',
              texttableentry: 'MixerThirteenCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '850',
              texttableentry: 'MixerThirteenCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '851',
              texttableentry: 'MixerThirteenCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '852',
              texttableentry: 'MixerFourteenCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '853',
              texttableentry: 'MixerFourteenCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '854',
              texttableentry: 'MixerFourteenCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '855',
              texttableentry: 'MixerFourteenCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '856',
              texttableentry: 'MixerFourteenCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '857',
              texttableentry: 'MixerFourteenCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '858',
              texttableentry: 'MixerFourteenCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '859',
              texttableentry: 'MixerFifteenCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '860',
              texttableentry: 'MixerFifteenCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '861',
              texttableentry: 'MixerFifteenCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '862',
              texttableentry: 'MixerFifteenCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '863',
              texttableentry: 'MixerFifteenCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '864',
              texttableentry: 'MixerFifteenCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '865',
              texttableentry: 'MixerFifteenCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '866',
              texttableentry: 'MixerSixteenCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '867',
              texttableentry: 'MixerSixteenCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '868',
              texttableentry: 'MixerSixteenCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '869',
              texttableentry: 'MixerSixteenCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '870',
              texttableentry: 'MixerSixteenCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '871',
              texttableentry: 'MixerSixteenCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '872',
              texttableentry: 'MixerSixteenCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionActivation',
              isRead: 'true',
              interval: '873',
              texttableentry: 'LegionellaProtectionActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '874',
              texttableentry: 'LegionellaProtectionTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionStartTime',
              isRead: 'true',
              interval: '875',
              texttableentry: 'LegionellaProtectionStartTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionWeekday',
              isRead: 'true',
              interval: '876',
              texttableentry: 'LegionellaProtectionWeekday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionLastSuccessfulStartTime',
              isRead: 'true',
              interval: '877',
              texttableentry: 'LegionellaProtectionLastSuccessfulStartTime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionLastSuccessfulWeekday',
              isRead: 'true',
              interval: '878',
              texttableentry: 'LegionellaProtectionLastSuccessfulWeekday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingCurve',
              isRead: 'true',
              interval: '879',
              texttableentry: 'CentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '880',
              texttableentry: 'MixerOneCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '881',
              texttableentry: 'MixerTwoCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '882',
              texttableentry: 'MixerThreeCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '883',
              texttableentry: 'MixerFourCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '884',
              texttableentry: 'MixerFiveCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '885',
              texttableentry: 'MixerSixCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '886',
              texttableentry: 'MixerSevenCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '887',
              texttableentry: 'MixerEightCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '888',
              texttableentry: 'MixerNineCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '889',
              texttableentry: 'MixerTenCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '890',
              texttableentry: 'MixerElevenCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '891',
              texttableentry: 'MixerTwelveCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '892',
              texttableentry: 'MixerThirteenCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '893',
              texttableentry: 'MixerFourteenCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '894',
              texttableentry: 'MixerFifteenCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '895',
              texttableentry: 'MixerSixteenCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureOffset',
              isRead: 'true',
              interval: '896',
              texttableentry: 'OutsideTemperatureOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ScreedDryingProfileActivation',
              isRead: 'true',
              interval: '897',
              texttableentry: 'ScreedDryingProfileActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemainingFloorDryingDays',
              isRead: 'true',
              interval: '898',
              texttableentry: 'RemainingFloorDryingDays',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiagnosticMenuPassword',
              isRead: 'true',
              interval: '899',
              texttableentry: 'DiagnosticMenuPassword',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSignalStrength',
              isRead: 'true',
              interval: '900',
              texttableentry: 'GatewayRemoteSignalStrength',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceManagerIsRequired',
              isRead: 'true',
              interval: '901',
              texttableentry: 'ServiceManagerIsRequired',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MalfunctionIdentification',
              isRead: 'true',
              interval: '902',
              texttableentry: 'MalfunctionIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplaySettings',
              isRead: 'true',
              interval: '903',
              texttableentry: 'DisplaySettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyType',
              isRead: 'true',
              interval: '904',
              texttableentry: 'EnergyType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPostHeater',
              isRead: 'true',
              interval: '905',
              texttableentry: 'ElectricalPostHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExhaustFlap',
              isRead: 'true',
              interval: '906',
              texttableentry: 'ExhaustFlap',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UserInterfaceDefaultHomeScreen',
              isRead: 'true',
              interval: '907',
              texttableentry: 'UserInterfaceDefaultHomeScreen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalFaultSignal',
              isRead: 'true',
              interval: '908',
              texttableentry: 'ExternalFaultSignal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalFaultSignalInput',
              isRead: 'true',
              interval: '909',
              texttableentry: 'ExternalFaultSignalInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalFuelValve',
              isRead: 'true',
              interval: '910',
              texttableentry: 'ExternalFuelValve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FeedbackExternalFuelValve',
              isRead: 'true',
              interval: '911',
              texttableentry: 'FeedbackExternalFuelValve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DaylightSavingTimeActive',
              isRead: 'true',
              interval: '912',
              texttableentry: 'DaylightSavingTimeActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentMemoryCecksum',
              isRead: 'true',
              interval: '913',
              texttableentry: 'PersistentMemoryCecksum',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentMemoryLastUpdate',
              isRead: 'true',
              interval: '914',
              texttableentry: 'PersistentMemoryLastUpdate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LastBackupDate',
              isRead: 'true',
              interval: '915',
              texttableentry: 'LastBackupDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LastRestoreDate',
              isRead: 'true',
              interval: '916',
              texttableentry: 'LastRestoreDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteWeatherService',
              isRead: 'true',
              interval: '917',
              texttableentry: 'RemoteWeatherService',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TradeFairMode',
              isRead: 'true',
              interval: '918',
              texttableentry: 'TradeFairMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureDampingFactor',
              isRead: 'true',
              interval: '919',
              texttableentry: 'OutsideTemperatureDampingFactor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreeAxisAccelerationSensor',
              isRead: 'true',
              interval: '920',
              texttableentry: 'ThreeAxisAccelerationSensor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalAccessInProgress',
              isRead: 'true',
              interval: '921',
              texttableentry: 'ExternalAccessInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionTraceabilityByte',
              isRead: 'true',
              interval: '922',
              texttableentry: 'ProductionTraceabilityByte',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RealTimeClockStatus',
              isRead: 'true',
              interval: '923',
              texttableentry: 'RealTimeClockStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StartUpWizard',
              isRead: 'true',
              interval: '924',
              texttableentry: 'StartUpWizard',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FillingVenting',
              isRead: 'true',
              interval: '925',
              texttableentry: 'FillingVenting',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyCockpitVisible',
              isRead: 'true',
              interval: '926',
              texttableentry: 'EnergyCockpitVisible',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BuildingType',
              isRead: 'true',
              interval: '927',
              texttableentry: 'BuildingType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasType',
              isRead: 'true',
              interval: '929',
              texttableentry: 'GasType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalTargetCentralHeatingFlowSetpointMetaData',
              isRead: 'true',
              interval: '930',
              texttableentry: 'ExternalTargetCentralHeatingFlowSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterFlowSetpointMetaData',
              isRead: 'true',
              interval: '931',
              texttableentry: 'DomesticHotWaterFlowSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoolingFlowSetpointMetaData',
              isRead: 'true',
              interval: '932',
              texttableentry: 'CoolingFlowSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitProperty',
              isRead: 'true',
              interval: '933',
              texttableentry: 'MixerOneCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitProperty',
              isRead: 'true',
              interval: '934',
              texttableentry: 'MixerTwoCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitProperty',
              isRead: 'true',
              interval: '935',
              texttableentry: 'MixerThreeCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitProperty',
              isRead: 'true',
              interval: '936',
              texttableentry: 'MixerFourCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitProperty',
              isRead: 'true',
              interval: '937',
              texttableentry: 'MixerFiveCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitProperty',
              isRead: 'true',
              interval: '938',
              texttableentry: 'MixerSixCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitProperty',
              isRead: 'true',
              interval: '939',
              texttableentry: 'MixerSevenCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitProperty',
              isRead: 'true',
              interval: '940',
              texttableentry: 'MixerEightCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitProperty',
              isRead: 'true',
              interval: '941',
              texttableentry: 'MixerNineCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitProperty',
              isRead: 'true',
              interval: '942',
              texttableentry: 'MixerTenCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitProperty',
              isRead: 'true',
              interval: '943',
              texttableentry: 'MixerElevenCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitProperty',
              isRead: 'true',
              interval: '944',
              texttableentry: 'MixerTwelveCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitProperty',
              isRead: 'true',
              interval: '945',
              texttableentry: 'MixerThirteenCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitProperty',
              isRead: 'true',
              interval: '946',
              texttableentry: 'MixerFourteenCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitProperty',
              isRead: 'true',
              interval: '947',
              texttableentry: 'MixerFifteenCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitProperty',
              isRead: 'true',
              interval: '948',
              texttableentry: 'MixerSixteenCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ScreedDryingDocumentation',
              isRead: 'true',
              interval: '949',
              texttableentry: 'ScreedDryingDocumentation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitWaterFlowRate',
              isRead: 'true',
              interval: '950',
              texttableentry: 'SolarCircuitWaterFlowRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitExtendedFunctions',
              isRead: 'true',
              interval: '951',
              texttableentry: 'SolarCircuitExtendedFunctions',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HydraulicMatrix',
              isRead: 'true',
              interval: '952',
              texttableentry: 'HydraulicMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarEnergyYield',
              isRead: 'true',
              interval: '953',
              texttableentry: 'SolarEnergyYield',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrix',
              isRead: 'true',
              interval: '954',
              texttableentry: 'BusTopologyMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceNotificationType',
              isRead: 'true',
              interval: '955',
              texttableentry: 'ServiceNotificationType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BackLightRemainingTime',
              isRead: 'true',
              interval: '956',
              texttableentry: 'BackLightRemainingTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EmergencyProgramActivation',
              isRead: 'true',
              interval: '957',
              texttableentry: 'EmergencyProgramActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InternalBoilerSensorOne',
              isRead: 'true',
              interval: '958',
              texttableentry: 'InternalBoilerSensorOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InternalBoilerSensorTwo',
              isRead: 'true',
              interval: '959',
              texttableentry: 'InternalBoilerSensorTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExhaustPipeType',
              isRead: 'true',
              interval: '960',
              texttableentry: 'ExhaustPipeType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecurityAlgorithmNumber',
              isRead: 'true',
              interval: '961',
              texttableentry: 'SecurityAlgorithmNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SparePartNumber',
              isRead: 'true',
              interval: '963',
              texttableentry: 'SparePartNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ProgrammingDateTime',
              isRead: 'true',
              interval: '965',
              texttableentry: 'ProgrammingDateTime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ProgrammingEquipmentNumber',
              isRead: 'true',
              interval: '966',
              texttableentry: 'ProgrammingEquipmentNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CalibrationDateTime',
              isRead: 'true',
              interval: '967',
              texttableentry: 'CalibrationDateTime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CalibrationEquipmentNumber',
              isRead: 'true',
              interval: '968',
              texttableentry: 'CalibrationEquipmentNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ProductionDateTime',
              isRead: 'true',
              interval: '969',
              texttableentry: 'ProductionDateTime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InstallationDateTime',
              isRead: 'true',
              interval: '970',
              texttableentry: 'InstallationDateTime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '971',
              texttableentry: 'MixerOneCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '972',
              texttableentry: 'MixerTwoCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '973',
              texttableentry: 'MixerThreeCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '974',
              texttableentry: 'MixerFourCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '975',
              texttableentry: 'MixerFiveCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '976',
              texttableentry: 'MixerSixCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '977',
              texttableentry: 'MixerSevenCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '978',
              texttableentry: 'MixerEightCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '979',
              texttableentry: 'MixerNineCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '980',
              texttableentry: 'MixerTenCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '981',
              texttableentry: 'MixerElevenCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '982',
              texttableentry: 'MixerTwelveCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '983',
              texttableentry: 'MixerThirteenCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '984',
              texttableentry: 'MixerFourteenCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '985',
              texttableentry: 'MixerFifteenCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitCentralHeatingStatus',
              isRead: 'true',
              interval: '986',
              texttableentry: 'MixerSixteenCircuitCentralHeatingStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '987',
              texttableentry: 'MixerOneCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '988',
              texttableentry: 'MixerTwoCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '989',
              texttableentry: 'MixerThreeCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '990',
              texttableentry: 'MixerFourCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '991',
              texttableentry: 'MixerFiveCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '992',
              texttableentry: 'MixerSixCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '993',
              texttableentry: 'MixerSevenCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '994',
              texttableentry: 'MixerEightCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '995',
              texttableentry: 'MixerNineCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '996',
              texttableentry: 'MixerTenCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '997',
              texttableentry: 'MixerElevenCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '998',
              texttableentry: 'MixerTwelveCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '999',
              texttableentry: 'MixerThirteenCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '1000',
              texttableentry: 'MixerFourteenCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '1001',
              texttableentry: 'MixerFifteenCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '1002',
              texttableentry: 'MixerSixteenCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TestOperationMode',
              isRead: 'true',
              interval: '1003',
              texttableentry: 'TestOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingRegulationMode',
              isRead: 'true',
              interval: '1004',
              texttableentry: 'CentralHeatingRegulationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusIdentificationMode',
              isRead: 'true',
              interval: '1005',
              texttableentry: 'BusIdentificationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TargetQuickMode',
              isRead: 'true',
              interval: '1006',
              texttableentry: 'TargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentQuickMode',
              isRead: 'true',
              interval: '1007',
              texttableentry: 'CurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1008',
              texttableentry: 'MixerOneCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1009',
              texttableentry: 'MixerTwoCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1010',
              texttableentry: 'MixerThreeCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1011',
              texttableentry: 'MixerFourCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1012',
              texttableentry: 'MixerFiveCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1013',
              texttableentry: 'MixerSixCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1014',
              texttableentry: 'MixerSevenCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1015',
              texttableentry: 'MixerEightCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1016',
              texttableentry: 'MixerNineCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1017',
              texttableentry: 'MixerTenCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1018',
              texttableentry: 'MixerElevenCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1019',
              texttableentry: 'MixerTwelveCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1020',
              texttableentry: 'MixerThirteenCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1021',
              texttableentry: 'MixerFourteenCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1022',
              texttableentry: 'MixerFifteenCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1023',
              texttableentry: 'MixerSixteenCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1024',
              texttableentry: 'MixerOneCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1025',
              texttableentry: 'MixerTwoCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1026',
              texttableentry: 'MixerThreeCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1027',
              texttableentry: 'MixerFourCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1028',
              texttableentry: 'MixerFiveCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1029',
              texttableentry: 'MixerSixCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1030',
              texttableentry: 'MixerSevenCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1031',
              texttableentry: 'MixerEightCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1032',
              texttableentry: 'MixerNineCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1033',
              texttableentry: 'MixerTenCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1034',
              texttableentry: 'MixerElevenCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1035',
              texttableentry: 'MixerTwelveCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1036',
              texttableentry: 'MixerThirteenCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1037',
              texttableentry: 'MixerFourteenCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1038',
              texttableentry: 'MixerFifteenCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1039',
              texttableentry: 'MixerSixteenCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupplyAirFan',
              isRead: 'true',
              interval: '1040',
              texttableentry: 'SupplyAirFan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirFan',
              isRead: 'true',
              interval: '1041',
              texttableentry: 'ExhaustAirFan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerTemperatureSensor',
              isRead: 'true',
              interval: '1042',
              texttableentry: 'PrimaryHeatExchangerTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AllengraSensor',
              isRead: 'true',
              interval: '1043',
              texttableentry: 'AllengraSensor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryCentralHeatingPump',
              isRead: 'true',
              interval: '1044',
              texttableentry: 'SecondaryCentralHeatingPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceIndividualisationPartOne',
              isRead: 'true',
              interval: '1045',
              texttableentry: 'DeviceIndividualisationPartOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceIndividualisationPartTwo',
              isRead: 'true',
              interval: '1046',
              texttableentry: 'DeviceIndividualisationPartTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlowTemperatureSensor',
              isRead: 'true',
              interval: '1047',
              texttableentry: 'TimeSeriesRecordedFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedReturnTemperatureSensor',
              isRead: 'true',
              interval: '1048',
              texttableentry: 'TimeSeriesRecordedReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedWaterFlowSensor',
              isRead: 'true',
              interval: '1049',
              texttableentry: 'TimeSeriesRecordedWaterFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedDomesticHotWaterSensor',
              isRead: 'true',
              interval: '1050',
              texttableentry: 'TimeSeriesRecordedDomesticHotWaterSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedDomesticHotWaterFlowSensor',
              isRead: 'true',
              interval: '1051',
              texttableentry: 'TimeSeriesRecordedDomesticHotWaterFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedSolarRoofTemperatureSensor',
              isRead: 'true',
              interval: '1052',
              texttableentry: 'TimeSeriesRecordedSolarRoofTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedOutsideTemperatureSensor',
              isRead: 'true',
              interval: '1053',
              texttableentry: 'TimeSeriesRecordedOutsideTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedSolarBottomTemperatureSensor',
              isRead: 'true',
              interval: '1054',
              texttableentry: 'TimeSeriesRecordedSolarBottomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedSolarTopTemperatureSensor',
              isRead: 'true',
              interval: '1055',
              texttableentry: 'TimeSeriesRecordedSolarTopTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedBufferBottomTemperatureSensor',
              isRead: 'true',
              interval: '1056',
              texttableentry: 'TimeSeriesRecordedBufferBottomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedBufferMidBottomTemperatureSensor',
              isRead: 'true',
              interval: '1057',
              texttableentry: 'TimeSeriesRecordedBufferMidBottomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedBufferMidTemperatureSensor',
              isRead: 'true',
              interval: '1058',
              texttableentry: 'TimeSeriesRecordedBufferMidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedBufferMidTopTemperatureSensor',
              isRead: 'true',
              interval: '1059',
              texttableentry: 'TimeSeriesRecordedBufferMidTopTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedBufferTopTemperatureSensor',
              isRead: 'true',
              interval: '1060',
              texttableentry: 'TimeSeriesRecordedBufferTopTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedHydraulicSeparatorTemperatureSensor',
              isRead: 'true',
              interval: '1061',
              texttableentry: 'TimeSeriesRecordedHydraulicSeparatorTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedHydraulicSeparatorReturnTemperatureSensor',
              isRead: 'true',
              interval: '1062',
              texttableentry: 'TimeSeriesRecordedHydraulicSeparatorReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedBrineInletTemperatureSensor',
              isRead: 'true',
              interval: '1063',
              texttableentry: 'TimeSeriesRecordedBrineInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedBrineOutletTemperatureSensor',
              isRead: 'true',
              interval: '1064',
              texttableentry: 'TimeSeriesRecordedBrineOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedWaterPressureSensor',
              isRead: 'true',
              interval: '1065',
              texttableentry: 'TimeSeriesRecordedWaterPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedBrinePresssureSensor',
              isRead: 'true',
              interval: '1066',
              texttableentry: 'TimeSeriesRecordedBrinePresssureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedPrimaryHeatExchangerLiquidTemperatureSensor',
              isRead: 'true',
              interval: '1067',
              texttableentry: 'TimeSeriesRecordedPrimaryHeatExchangerLiquidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCompressorInletTemperatureSensor',
              isRead: 'true',
              interval: '1068',
              texttableentry: 'TimeSeriesRecordedCompressorInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCompressorInletPressureSensor',
              isRead: 'true',
              interval: '1069',
              texttableentry: 'TimeSeriesRecordedCompressorInletPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedEnhancedVapourInjectionTemperatureSensor',
              isRead: 'true',
              interval: '1070',
              texttableentry: 'TimeSeriesRecordedEnhancedVapourInjectionTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCompressorOutletTemperatureSensor',
              isRead: 'true',
              interval: '1071',
              texttableentry: 'TimeSeriesRecordedCompressorOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCompressorOutletPressureSensor',
              isRead: 'true',
              interval: '1072',
              texttableentry: 'TimeSeriesRecordedCompressorOutletPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedDischargeTwoTemperatureSensor',
              isRead: 'true',
              interval: '1073',
              texttableentry: 'TimeSeriesRecordedDischargeTwoTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedOutsideSupplyAirTemperatureSensor',
              isRead: 'true',
              interval: '1074',
              texttableentry: 'TimeSeriesRecordedOutsideSupplyAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedIncomingAirTemperatureSensor',
              isRead: 'true',
              interval: '1075',
              texttableentry: 'TimeSeriesRecordedIncomingAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedOutcomingAirTemperatureSensor',
              isRead: 'true',
              interval: '1076',
              texttableentry: 'TimeSeriesRecordedOutcomingAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedUsedAirTemperatureSensor',
              isRead: 'true',
              interval: '1077',
              texttableentry: 'TimeSeriesRecordedUsedAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlueGasTemperatureSensor',
              isRead: 'true',
              interval: '1078',
              texttableentry: 'TimeSeriesRecordedFlueGasTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCoSensor',
              isRead: 'true',
              interval: '1079',
              texttableentry: 'TimeSeriesRecordedCoSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedRoomTemperatureSensor',
              isRead: 'true',
              interval: '1080',
              texttableentry: 'TimeSeriesRecordedRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FreezeFrame',
              isRead: 'true',
              interval: '1081',
              texttableentry: 'FreezeFrame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ShadowFreezeFrame',
              isRead: 'true',
              interval: '1082',
              texttableentry: 'ShadowFreezeFrame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpPostRuntime',
              isRead: 'true',
              interval: '1083',
              texttableentry: 'CentralHeatingPumpPostRuntime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1084',
              texttableentry: 'FlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterHysteresis',
              isRead: 'true',
              interval: '1085',
              texttableentry: 'DomesticHotWaterHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingHysteresis',
              isRead: 'true',
              interval: '1086',
              texttableentry: 'CentralHeatingHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MaximumDomesticHotWaterLoadingTime',
              isRead: 'true',
              interval: '1087',
              texttableentry: 'MaximumDomesticHotWaterLoadingTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutsideAirBypass',
              isRead: 'true',
              interval: '1088',
              texttableentry: 'OutsideAirBypass',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InsideAirBypass',
              isRead: 'true',
              interval: '1089',
              texttableentry: 'InsideAirBypass',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnvironmentAirQuality',
              isRead: 'true',
              interval: '1090',
              texttableentry: 'EnvironmentAirQuality',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PossibleEnergySaving',
              isRead: 'true',
              interval: '1091',
              texttableentry: 'PossibleEnergySaving',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CalculatedEnergySavings',
              isRead: 'true',
              interval: '1092',
              texttableentry: 'CalculatedEnergySavings',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExhaustPipeLength',
              isRead: 'true',
              interval: '1093',
              texttableentry: 'ExhaustPipeLength',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyBalance',
              isRead: 'true',
              interval: '1094',
              texttableentry: 'ElectricalEnergyBalance',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OptimizationRecommendations',
              isRead: 'true',
              interval: '1095',
              texttableentry: 'OptimizationRecommendations',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetEnergyManagerDataCollector',
              isRead: 'true',
              interval: '1096',
              texttableentry: 'ResetEnergyManagerDataCollector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPrice',
              isRead: 'true',
              interval: '1097',
              texttableentry: 'ElectricityPrice',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasProperties',
              isRead: 'true',
              interval: '1098',
              texttableentry: 'GasProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarPumpMinimumPreRunTime',
              isRead: 'true',
              interval: '1099',
              texttableentry: 'SolarPumpMinimumPreRunTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1100',
              texttableentry: 'CentralHeatingPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1101',
              texttableentry: 'DomesticHotWaterPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1102',
              texttableentry: 'MixerOneCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1103',
              texttableentry: 'MixerTwoCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1104',
              texttableentry: 'MixerThreeCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1105',
              texttableentry: 'MixerFourCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1106',
              texttableentry: 'MixerFiveCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1107',
              texttableentry: 'MixerSixCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1108',
              texttableentry: 'MixerSevenCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1109',
              texttableentry: 'MixerEightCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1110',
              texttableentry: 'MixerNineCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1111',
              texttableentry: 'MixerTenCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1112',
              texttableentry: 'MixerElevenCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1113',
              texttableentry: 'MixerTwelveCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1114',
              texttableentry: 'MixerThirteenCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1115',
              texttableentry: 'MixerFourteenCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1116',
              texttableentry: 'MixerFifteenCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1117',
              texttableentry: 'MixerSixteenCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1118',
              texttableentry: 'SolarCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1119',
              texttableentry: 'DomesticHotWaterCirculationPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitOneMinimumMaximumLimit',
              isRead: 'true',
              interval: '1120',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitOneMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitTwoMinimumMaximumLimit',
              isRead: 'true',
              interval: '1121',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitTwoMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry:
                'TI_DomesticHotWaterCirculationPumpCircuitThreeMinimumMaximumLimit',
              isRead: 'true',
              interval: '1122',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitThreeMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitFourMinimumMaximumLimit',
              isRead: 'true',
              interval: '1123',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitFourMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryCentralHeatingPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1124',
              texttableentry: 'SecondaryCentralHeatingPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarMaximumLoadingTemperature',
              isRead: 'true',
              interval: '1125',
              texttableentry: 'SolarMaximumLoadingTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarMinimumMaximumCollectorTemperature',
              isRead: 'true',
              interval: '1126',
              texttableentry: 'SolarMinimumMaximumCollectorTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCollectorFrostprotection',
              isRead: 'true',
              interval: '1127',
              texttableentry: 'SolarCollectorFrostprotection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarStagnationHours',
              isRead: 'true',
              interval: '1128',
              texttableentry: 'SolarStagnationHours',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarAlternatelyCharge',
              isRead: 'true',
              interval: '1129',
              texttableentry: 'SolarAlternatelyCharge',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarAlternatelyChargeMaximumLoadingTime',
              isRead: 'true',
              interval: '1130',
              texttableentry: 'SolarAlternatelyChargeMaximumLoadingTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersion',
              isRead: 'true',
              interval: '1131',
              texttableentry: 'ParameterIdentificationVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumberListInternal',
              isRead: 'true',
              interval: '1132',
              texttableentry: 'ViessmannIdentificationNumberListInternal',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductIntegrationVersion',
              isRead: 'true',
              interval: '1133',
              texttableentry: 'ProductIntegrationVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumberCascadeSystemOne',
              isRead: 'true',
              interval: '1134',
              texttableentry: 'ViessmannIdentificationNumberCascadeSystemOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ItemNumber',
              isRead: 'true',
              interval: '1135',
              texttableentry: 'ItemNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarProperty',
              isRead: 'true',
              interval: '1136',
              texttableentry: 'SolarProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceModeActivation',
              isRead: 'true',
              interval: '1137',
              texttableentry: 'ServiceModeActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccentLedBar',
              isRead: 'true',
              interval: '1138',
              texttableentry: 'AccentLedBar',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingCurveAdaptionParameter',
              isRead: 'true',
              interval: '1139',
              texttableentry: 'CentralHeatingCurveAdaptionParameter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcSnapshot',
              isRead: 'true',
              interval: '1140',
              texttableentry: 'ErrorDtcSnapshot',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerIndividualParameters',
              isRead: 'true',
              interval: '1141',
              texttableentry: 'CustomerIndividualParameters',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomTemperatureOffset',
              isRead: 'true',
              interval: '1142',
              texttableentry: 'RoomTemperatureOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitSix',
              isRead: 'true',
              interval: '1143',
              texttableentry: 'HolidayPhaseCircuitSix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitSix',
              isRead: 'true',
              interval: '1144',
              texttableentry: 'HolidayAtHomePhaseCircuitSix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitSeven',
              isRead: 'true',
              interval: '1145',
              texttableentry: 'HolidayPhaseCircuitSeven',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitSeven',
              isRead: 'true',
              interval: '1146',
              texttableentry: 'HolidayAtHomePhaseCircuitSeven',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitEight',
              isRead: 'true',
              interval: '1147',
              texttableentry: 'HolidayPhaseCircuitEight',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitEight',
              isRead: 'true',
              interval: '1148',
              texttableentry: 'HolidayAtHomePhaseCircuitEight',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitNine',
              isRead: 'true',
              interval: '1149',
              texttableentry: 'HolidayPhaseCircuitNine',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitNine',
              isRead: 'true',
              interval: '1150',
              texttableentry: 'HolidayAtHomePhaseCircuitNine',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitTen',
              isRead: 'true',
              interval: '1151',
              texttableentry: 'HolidayPhaseCircuitTen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitTen',
              isRead: 'true',
              interval: '1152',
              texttableentry: 'HolidayAtHomePhaseCircuitTen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitEleven',
              isRead: 'true',
              interval: '1153',
              texttableentry: 'HolidayPhaseCircuitEleven',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitEleven',
              isRead: 'true',
              interval: '1154',
              texttableentry: 'HolidayAtHomePhaseCircuitEleven',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitTwelve',
              isRead: 'true',
              interval: '1155',
              texttableentry: 'HolidayPhaseCircuitTwelve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitTwelve',
              isRead: 'true',
              interval: '1156',
              texttableentry: 'HolidayAtHomePhaseCircuitTwelve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitThirteen',
              isRead: 'true',
              interval: '1157',
              texttableentry: 'HolidayPhaseCircuitThirteen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitThirteen',
              isRead: 'true',
              interval: '1158',
              texttableentry: 'HolidayAtHomePhaseCircuitThirteen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitFourteen',
              isRead: 'true',
              interval: '1159',
              texttableentry: 'HolidayPhaseCircuitFourteen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitFourteen',
              isRead: 'true',
              interval: '1160',
              texttableentry: 'HolidayAtHomePhaseCircuitFourteen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitFifteen',
              isRead: 'true',
              interval: '1161',
              texttableentry: 'HolidayPhaseCircuitFifteen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitFifteen',
              isRead: 'true',
              interval: '1162',
              texttableentry: 'HolidayAtHomePhaseCircuitFifteen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitSixteen',
              isRead: 'true',
              interval: '1163',
              texttableentry: 'HolidayPhaseCircuitSixteen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitSixteen',
              isRead: 'true',
              interval: '1164',
              texttableentry: 'HolidayAtHomePhaseCircuitSixteen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BackendConnectionStatus',
              isRead: 'true',
              interval: '1165',
              texttableentry: 'BackendConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetDtcHistory',
              isRead: 'true',
              interval: '1166',
              texttableentry: 'ResetDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalDomesticHotWaterTemperatureSetpoint',
              isRead: 'true',
              interval: '1167',
              texttableentry: 'ExternalDomesticHotWaterTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoTwoSensor',
              isRead: 'true',
              interval: '1168',
              texttableentry: 'CoTwoSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCoTwoSensor',
              isRead: 'true',
              interval: '1169',
              texttableentry: 'TimeSeriesRecordedCoTwoSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedPrimaryHeatExchangerTemperatureSensor',
              isRead: 'true',
              interval: '1170',
              texttableentry: 'TimeSeriesRecordedPrimaryHeatExchangerTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterRegulationMode',
              isRead: 'true',
              interval: '1171',
              texttableentry: 'DomesticHotWaterRegulationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPumpStatistical',
              isRead: 'true',
              interval: '1172',
              texttableentry: 'SolarCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PreCentralHeatingTimeOffset',
              isRead: 'true',
              interval: '1173',
              texttableentry: 'PreCentralHeatingTimeOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PostCentralHeatingTimeOffset',
              isRead: 'true',
              interval: '1174',
              texttableentry: 'PostCentralHeatingTimeOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeInfoAlarmMessage',
              isRead: 'true',
              interval: '1175',
              texttableentry: 'AcknowledgeInfoAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeWarningAlarmMessage',
              isRead: 'true',
              interval: '1176',
              texttableentry: 'AcknowledgeWarningAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeServiceAlarmMessage',
              isRead: 'true',
              interval: '1177',
              texttableentry: 'AcknowledgeServiceAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeErrorAlarmMessage',
              isRead: 'true',
              interval: '1178',
              texttableentry: 'AcknowledgeErrorAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericInputOutputControl',
              isRead: 'true',
              interval: '1179',
              texttableentry: 'GenericInputOutputControl',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplayPowerSavingMode',
              isRead: 'true',
              interval: '1180',
              texttableentry: 'DisplayPowerSavingMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplayTestMode',
              isRead: 'true',
              interval: '1181',
              texttableentry: 'DisplayTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplayTouchTwoDimensionalCoordinates',
              isRead: 'true',
              interval: '1182',
              texttableentry: 'DisplayTouchTwoDimensionalCoordinates',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasPressureSwitch',
              isRead: 'true',
              interval: '1183',
              texttableentry: 'GasPressureSwitch',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PersistentStorageSupplier',
              isRead: 'true',
              interval: '1184',
              texttableentry: 'PersistentStorageSupplier',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentMemoryEndOfLine',
              isRead: 'true',
              interval: '1185',
              texttableentry: 'PersistentMemoryEndOfLine',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarPrimaryInletTemperatureSensor',
              isRead: 'true',
              interval: '1186',
              texttableentry: 'SolarPrimaryInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarPrimaryOutletTemperatureSensor',
              isRead: 'true',
              interval: '1187',
              texttableentry: 'SolarPrimaryOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarSecondaryInletTemperatureSensor',
              isRead: 'true',
              interval: '1188',
              texttableentry: 'SolarSecondaryInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarSecondaryOutletTemperatureSensor',
              isRead: 'true',
              interval: '1189',
              texttableentry: 'SolarSecondaryOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ThermalPower',
              isRead: 'true',
              interval: '1190',
              texttableentry: 'ThermalPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellStatus',
              isRead: 'true',
              interval: '1191',
              texttableentry: 'FuelCellStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1192',
              texttableentry: 'MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1193',
              texttableentry: 'MixerTwoCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1194',
              texttableentry: 'MixerThreeCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1195',
              texttableentry: 'MixerFourCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1196',
              texttableentry: 'MixerFiveCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1197',
              texttableentry: 'MixerSixCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1198',
              texttableentry: 'MixerSevenCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1199',
              texttableentry: 'MixerEightCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1200',
              texttableentry: 'MixerNineCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1201',
              texttableentry: 'MixerTenCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1202',
              texttableentry: 'MixerElevenCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1203',
              texttableentry: 'MixerTwelveCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1204',
              texttableentry: 'MixerThirteenCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1205',
              texttableentry: 'MixerFourteenCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1206',
              texttableentry: 'MixerFifteenCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1207',
              texttableentry: 'MixerSixteenCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlameIonisationConfiguration',
              isRead: 'true',
              interval: '1208',
              texttableentry: 'FlameIonisationConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AirVolumeFlowConfiguration',
              isRead: 'true',
              interval: '1209',
              texttableentry: 'AirVolumeFlowConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellStatistical',
              isRead: 'true',
              interval: '1210',
              texttableentry: 'FuelCellStatistical',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedCentralHeatingOutput',
              isRead: 'true',
              interval: '1211',
              texttableentry: 'GeneratedCentralHeatingOutput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MassFlowSensorCorrectionFactor',
              isRead: 'true',
              interval: '1212',
              texttableentry: 'MassFlowSensorCorrectionFactor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationNumber',
              isRead: 'true',
              interval: '1213',
              texttableentry: 'ParameterIdentificationNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalPowerOutput',
              isRead: 'true',
              interval: '1214',
              texttableentry: 'ElectricalPowerOutput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellState',
              isRead: 'true',
              interval: '1215',
              texttableentry: 'FuelCellState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellStateTwo',
              isRead: 'true',
              interval: '1216',
              texttableentry: 'FuelCellStateTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGenerationMode',
              isRead: 'true',
              interval: '1217',
              texttableentry: 'FuelCellGenerationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellInstruction',
              isRead: 'true',
              interval: '1218',
              texttableentry: 'FuelCellInstruction',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellChimneySweeperMode',
              isRead: 'true',
              interval: '1219',
              texttableentry: 'FuelCellChimneySweeperMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellMode',
              isRead: 'true',
              interval: '1220',
              texttableentry: 'FuelCellMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellModeResult',
              isRead: 'true',
              interval: '1221',
              texttableentry: 'FuelCellModeResult',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellRunRequest',
              isRead: 'true',
              interval: '1222',
              texttableentry: 'FuelCellRunRequest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellRunRequestResult',
              isRead: 'true',
              interval: '1223',
              texttableentry: 'FuelCellRunRequestResult',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellStopRequest',
              isRead: 'true',
              interval: '1224',
              texttableentry: 'FuelCellStopRequest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellStopRequestResult',
              isRead: 'true',
              interval: '1225',
              texttableentry: 'FuelCellStopRequestResult',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellProcessNumber',
              isRead: 'true',
              interval: '1226',
              texttableentry: 'FuelCellProcessNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellRequestAction',
              isRead: 'true',
              interval: '1227',
              texttableentry: 'FuelCellRequestAction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellCompletionNotification',
              isRead: 'true',
              interval: '1228',
              texttableentry: 'FuelCellCompletionNotification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGasTypeSetting',
              isRead: 'true',
              interval: '1229',
              texttableentry: 'FuelCellGasTypeSetting',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellCountrySetting',
              isRead: 'true',
              interval: '1230',
              texttableentry: 'FuelCellCountrySetting',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellPrimaryPump',
              isRead: 'true',
              interval: '1231',
              texttableentry: 'FuelCellPrimaryPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardOne',
              isRead: 'true',
              interval: '1232',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleOneTwo',
              isRead: 'true',
              interval: '1233',
              texttableentry: 'GatewayRemoteVisibleOneTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleThreeFour',
              isRead: 'true',
              interval: '1234',
              texttableentry: 'GatewayRemoteVisibleThreeFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleFiveSix',
              isRead: 'true',
              interval: '1235',
              texttableentry: 'GatewayRemoteVisibleFiveSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleSevenEight',
              isRead: 'true',
              interval: '1236',
              texttableentry: 'GatewayRemoteVisibleSevenEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleNineTen',
              isRead: 'true',
              interval: '1237',
              texttableentry: 'GatewayRemoteVisibleNineTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AvailableActorSensorComponents',
              isRead: 'true',
              interval: '1238',
              texttableentry: 'AvailableActorSensorComponents',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActorSensorTest',
              isRead: 'true',
              interval: '1239',
              texttableentry: 'ActorSensorTest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpMode',
              isRead: 'true',
              interval: '1240',
              texttableentry: 'CentralHeatingPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpMode',
              isRead: 'true',
              interval: '1241',
              texttableentry: 'MixerOneCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpMode',
              isRead: 'true',
              interval: '1242',
              texttableentry: 'MixerTwoCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpMode',
              isRead: 'true',
              interval: '1243',
              texttableentry: 'MixerThreeCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpMode',
              isRead: 'true',
              interval: '1244',
              texttableentry: 'MixerFourCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitPumpMode',
              isRead: 'true',
              interval: '1245',
              texttableentry: 'MixerFiveCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitPumpMode',
              isRead: 'true',
              interval: '1246',
              texttableentry: 'MixerSixCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitPumpMode',
              isRead: 'true',
              interval: '1247',
              texttableentry: 'MixerSevenCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitPumpMode',
              isRead: 'true',
              interval: '1248',
              texttableentry: 'MixerEightCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitPumpMode',
              isRead: 'true',
              interval: '1249',
              texttableentry: 'MixerNineCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitPumpMode',
              isRead: 'true',
              interval: '1250',
              texttableentry: 'MixerTenCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitPumpMode',
              isRead: 'true',
              interval: '1251',
              texttableentry: 'MixerElevenCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitPumpMode',
              isRead: 'true',
              interval: '1252',
              texttableentry: 'MixerTwelveCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitPumpMode',
              isRead: 'true',
              interval: '1253',
              texttableentry: 'MixerThirteenCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitPumpMode',
              isRead: 'true',
              interval: '1254',
              texttableentry: 'MixerFourteenCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitPumpMode',
              isRead: 'true',
              interval: '1255',
              texttableentry: 'MixerFifteenCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitPumpMode',
              isRead: 'true',
              interval: '1256',
              texttableentry: 'MixerSixteenCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasBlowerSystemInfo',
              isRead: 'true',
              interval: '1257',
              texttableentry: 'GasBlowerSystemInfo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GasBlowerSystemAirTemperatureSensor',
              isRead: 'true',
              interval: '1258',
              texttableentry: 'GasBlowerSystemAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GasBlowerSystemStatus',
              isRead: 'true',
              interval: '1259',
              texttableentry: 'GasBlowerSystemStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicIdHydraulicSeparator',
              isRead: 'true',
              interval: '1260',
              texttableentry: 'HydraulicIdHydraulicSeparator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicIdDomesticHotWaterCylinder',
              isRead: 'true',
              interval: '1261',
              texttableentry: 'HydraulicIdDomesticHotWaterCylinder',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicIdCentralHeatingCircuit',
              isRead: 'true',
              interval: '1262',
              texttableentry: 'HydraulicIdCentralHeatingCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiverterValveBoilerHydraulicTower',
              isRead: 'true',
              interval: '1263',
              texttableentry: 'DiverterValveBoilerHydraulicTower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveFuelCellHydraulicTower',
              isRead: 'true',
              interval: '1264',
              texttableentry: 'DiverterValveFuelCellHydraulicTower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FanTargetSpeedMeta',
              isRead: 'true',
              interval: '1265',
              texttableentry: 'FanTargetSpeedMeta',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveStatistical',
              isRead: 'true',
              interval: '1266',
              texttableentry: 'DiverterValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1267',
              texttableentry: 'MixerOneCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1268',
              texttableentry: 'MixerTwoCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1269',
              texttableentry: 'MixerThreeCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1270',
              texttableentry: 'MixerFourCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1271',
              texttableentry: 'MixerFiveCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1272',
              texttableentry: 'MixerSixCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1273',
              texttableentry: 'MixerSevenCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1274',
              texttableentry: 'MixerEightCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1275',
              texttableentry: 'MixerNineCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1276',
              texttableentry: 'MixerTenCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1277',
              texttableentry: 'MixerElevenCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1278',
              texttableentry: 'MixerTwelveCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1279',
              texttableentry: 'MixerThirteenCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1280',
              texttableentry: 'MixerFourteenCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1281',
              texttableentry: 'MixerFifteenCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitThreeWayValveStatistical',
              isRead: 'true',
              interval: '1282',
              texttableentry: 'MixerSixteenCircuitThreeWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatEnginePerformanceParameter',
              isRead: 'true',
              interval: '1283',
              texttableentry: 'HeatEnginePerformanceParameter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitFive',
              isRead: 'true',
              interval: '1284',
              texttableentry: 'HolidayPhaseCircuitFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitFive',
              isRead: 'true',
              interval: '1285',
              texttableentry: 'HolidayAtHomePhaseCircuitFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixTwo',
              isRead: 'true',
              interval: '1286',
              texttableentry: 'BusTopologyMatrixTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixThree',
              isRead: 'true',
              interval: '1287',
              texttableentry: 'BusTopologyMatrixThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFour',
              isRead: 'true',
              interval: '1288',
              texttableentry: 'BusTopologyMatrixFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFive',
              isRead: 'true',
              interval: '1289',
              texttableentry: 'BusTopologyMatrixFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadPump',
              isRead: 'true',
              interval: '1290',
              texttableentry: 'DomesticHotWaterShiftLoadPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadPumpStatistical',
              isRead: 'true',
              interval: '1291',
              texttableentry: 'DomesticHotWaterShiftLoadPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CombustionAirInletTemperature',
              isRead: 'true',
              interval: '1292',
              texttableentry: 'CombustionAirInletTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelValveParameter',
              isRead: 'true',
              interval: '1293',
              texttableentry: 'FuelValveParameter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrix',
              isRead: 'true',
              interval: '1294',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerOneCircuit',
              isRead: 'true',
              interval: '1295',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerOneCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerTwoCircuit',
              isRead: 'true',
              interval: '1296',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerTwoCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerThreeCircuit',
              isRead: 'true',
              interval: '1297',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerThreeCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerFourCircuit',
              isRead: 'true',
              interval: '1298',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerFourCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerFiveCircuit',
              isRead: 'true',
              interval: '1299',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerFiveCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerSixCircuit',
              isRead: 'true',
              interval: '1300',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerSixCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerSevenCircuit',
              isRead: 'true',
              interval: '1301',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerSevenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerEightCircuit',
              isRead: 'true',
              interval: '1302',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerEightCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerNineCircuit',
              isRead: 'true',
              interval: '1303',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerNineCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerTenCircuit',
              isRead: 'true',
              interval: '1304',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerTenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerElevenCircuit',
              isRead: 'true',
              interval: '1305',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerElevenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerTwelveCircuit',
              isRead: 'true',
              interval: '1306',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerTwelveCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry:
                'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerThirteenCircuit',
              isRead: 'true',
              interval: '1307',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerThirteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry:
                'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerFourteenCircuit',
              isRead: 'true',
              interval: '1308',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerFourteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerFifteenCircuit',
              isRead: 'true',
              interval: '1309',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerFifteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixMixerSixteenCircuit',
              isRead: 'true',
              interval: '1310',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixMixerSixteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterMonthMatrix',
              isRead: 'true',
              interval: '1311',
              texttableentry: 'EnergyConsumptionDomesticHotWaterMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCoolingMonthMatrix',
              isRead: 'true',
              interval: '1312',
              texttableentry: 'EnergyConsumptionCoolingMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedElectricityMonthMatrix',
              isRead: 'true',
              interval: '1313',
              texttableentry: 'GeneratedElectricityMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarEnergyYieldMonthMatrix',
              isRead: 'true',
              interval: '1314',
              texttableentry: 'SolarEnergyYieldMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedCentralHeatingOutputMonthMatrix',
              isRead: 'true',
              interval: '1315',
              texttableentry: 'GeneratedCentralHeatingOutputMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrix',
              isRead: 'true',
              interval: '1316',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerOneCircuit',
              isRead: 'true',
              interval: '1317',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerOneCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerTwoCircuit',
              isRead: 'true',
              interval: '1318',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerTwoCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerThreeCircuit',
              isRead: 'true',
              interval: '1319',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerThreeCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerFourCircuit',
              isRead: 'true',
              interval: '1320',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerFourCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerFiveCircuit',
              isRead: 'true',
              interval: '1321',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerFiveCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerSixCircuit',
              isRead: 'true',
              interval: '1322',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerSixCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerSevenCircuit',
              isRead: 'true',
              interval: '1323',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerSevenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerEightCircuit',
              isRead: 'true',
              interval: '1324',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerEightCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerNineCircuit',
              isRead: 'true',
              interval: '1325',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerNineCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerTenCircuit',
              isRead: 'true',
              interval: '1326',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerTenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerElevenCircuit',
              isRead: 'true',
              interval: '1327',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerElevenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerTwelveCircuit',
              isRead: 'true',
              interval: '1328',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerTwelveCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerThirteenCircuit',
              isRead: 'true',
              interval: '1329',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerThirteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerFourteenCircuit',
              isRead: 'true',
              interval: '1330',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerFourteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerFifteenCircuit',
              isRead: 'true',
              interval: '1331',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerFifteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixMixerSixteenCircuit',
              isRead: 'true',
              interval: '1332',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixMixerSixteenCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterYearMatrix',
              isRead: 'true',
              interval: '1333',
              texttableentry: 'EnergyConsumptionDomesticHotWaterYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCoolingYearMatrix',
              isRead: 'true',
              interval: '1334',
              texttableentry: 'EnergyConsumptionCoolingYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedElectricityYearMatrix',
              isRead: 'true',
              interval: '1335',
              texttableentry: 'GeneratedElectricityYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarEnergyYieldYearMatrix',
              isRead: 'true',
              interval: '1336',
              texttableentry: 'SolarEnergyYieldYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedCentralHeatingOutputYearMatrix',
              isRead: 'true',
              interval: '1337',
              texttableentry: 'GeneratedCentralHeatingOutputYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ScreedDryingProfileDefinition',
              isRead: 'true',
              interval: '1338',
              texttableentry: 'ScreedDryingProfileDefinition',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MalfunctionHeatingUnitBlocked',
              isRead: 'true',
              interval: '1339',
              texttableentry: 'MalfunctionHeatingUnitBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellGeneratedHeatOutputMonthMatrix',
              isRead: 'true',
              interval: '1340',
              texttableentry: 'FuelCellGeneratedHeatOutputMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGeneratedHeatOutputYearMatrix',
              isRead: 'true',
              interval: '1341',
              texttableentry: 'FuelCellGeneratedHeatOutputYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionCentralHeatingMonthMatrix',
              isRead: 'true',
              interval: '1342',
              texttableentry: 'GasConsumptionCentralHeatingMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionCentralHeatingYearMatrix',
              isRead: 'true',
              interval: '1343',
              texttableentry: 'GasConsumptionCentralHeatingYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionDomesticHotWaterMonthMatrix',
              isRead: 'true',
              interval: '1344',
              texttableentry: 'GasConsumptionDomesticHotWaterMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionDomesticHotWaterYearMatrix',
              isRead: 'true',
              interval: '1345',
              texttableentry: 'GasConsumptionDomesticHotWaterYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatEngineStatistical',
              isRead: 'true',
              interval: '1346',
              texttableentry: 'HeatEngineStatistical',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectElectricalEnergyStatus',
              isRead: 'true',
              interval: '1347',
              texttableentry: 'ObjectElectricalEnergyStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellGasConsumption',
              isRead: 'true',
              interval: '1348',
              texttableentry: 'FuelCellGasConsumption',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGasConsumptionMonthMatrix',
              isRead: 'true',
              interval: '1349',
              texttableentry: 'FuelCellGasConsumptionMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGasConsumptionYearMatrix',
              isRead: 'true',
              interval: '1350',
              texttableentry: 'FuelCellGasConsumptionYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FeedInEnergy',
              isRead: 'true',
              interval: '1351',
              texttableentry: 'FeedInEnergy',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FeedInEnergyMonthMatrix',
              isRead: 'true',
              interval: '1352',
              texttableentry: 'FeedInEnergyMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FeedInEnergyYearMatrix',
              isRead: 'true',
              interval: '1353',
              texttableentry: 'FeedInEnergyYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionCoverageRate',
              isRead: 'true',
              interval: '1354',
              texttableentry: 'ProductionCoverageRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionCoverageRateMonthMatrix',
              isRead: 'true',
              interval: '1355',
              texttableentry: 'ProductionCoverageRateMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionCoverageRateYearMatrix',
              isRead: 'true',
              interval: '1356',
              texttableentry: 'ProductionCoverageRateYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellOperationTime',
              isRead: 'true',
              interval: '1357',
              texttableentry: 'FuelCellOperationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellOperationTimeMonthMatrix',
              isRead: 'true',
              interval: '1358',
              texttableentry: 'FuelCellOperationTimeMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellOperationTimeYearMatrix',
              isRead: 'true',
              interval: '1359',
              texttableentry: 'FuelCellOperationTimeYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellRunTime',
              isRead: 'true',
              interval: '1360',
              texttableentry: 'FuelCellRunTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellRunTimeMonthMatrix',
              isRead: 'true',
              interval: '1361',
              texttableentry: 'FuelCellRunTimeMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellRunTimeYearMatrix',
              isRead: 'true',
              interval: '1362',
              texttableentry: 'FuelCellRunTimeYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellTargetOperationMode',
              isRead: 'true',
              interval: '1363',
              texttableentry: 'FuelCellTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericSdioAccessoryOneModulFunction',
              isRead: 'true',
              interval: '1364',
              texttableentry: 'GenericSdioAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericSdioAccessoryTwoModulFunction',
              isRead: 'true',
              interval: '1365',
              texttableentry: 'GenericSdioAccessoryTwoModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericSdioAccessoryThreeModulFunction',
              isRead: 'true',
              interval: '1366',
              texttableentry: 'GenericSdioAccessoryThreeModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellThermalPower',
              isRead: 'true',
              interval: '1367',
              texttableentry: 'FuelCellThermalPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellServiceCounter',
              isRead: 'true',
              interval: '1368',
              texttableentry: 'FuelCellServiceCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellOverhaulCounter',
              isRead: 'true',
              interval: '1369',
              texttableentry: 'FuelCellOverhaulCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellEndOfLifeCounter',
              isRead: 'true',
              interval: '1370',
              texttableentry: 'FuelCellEndOfLifeCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DemandCoverageRate',
              isRead: 'true',
              interval: '1371',
              texttableentry: 'DemandCoverageRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DemandCoverageRateMonthMatrix',
              isRead: 'true',
              interval: '1372',
              texttableentry: 'DemandCoverageRateMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DemandCoverageRateYearMatrix',
              isRead: 'true',
              interval: '1373',
              texttableentry: 'DemandCoverageRateYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TroubleFreeRate',
              isRead: 'true',
              interval: '1374',
              texttableentry: 'TroubleFreeRate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TroubleFreeRateMonthMatrix',
              isRead: 'true',
              interval: '1375',
              texttableentry: 'TroubleFreeRateMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TroubleFreeRateYearMatrix',
              isRead: 'true',
              interval: '1376',
              texttableentry: 'TroubleFreeRateYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellTroubleFreeRate',
              isRead: 'true',
              interval: '1377',
              texttableentry: 'FuelCellTroubleFreeRate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellTroubleFreeRateMonthMatrix',
              isRead: 'true',
              interval: '1378',
              texttableentry: 'FuelCellTroubleFreeRateMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellTroubleFreeRateYearMatrix',
              isRead: 'true',
              interval: '1379',
              texttableentry: 'FuelCellTroubleFreeRateYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BreakdownRate',
              isRead: 'true',
              interval: '1380',
              texttableentry: 'BreakdownRate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BreakdownRateMonthMatrix',
              isRead: 'true',
              interval: '1381',
              texttableentry: 'BreakdownRateMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BreakdownRateYearMatrix',
              isRead: 'true',
              interval: '1382',
              texttableentry: 'BreakdownRateYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellBreakdownRate',
              isRead: 'true',
              interval: '1383',
              texttableentry: 'FuelCellBreakdownRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellBreakdownRateMonthMatrix',
              isRead: 'true',
              interval: '1384',
              texttableentry: 'FuelCellBreakdownRateMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellBreakdownRateYearMatrix',
              isRead: 'true',
              interval: '1385',
              texttableentry: 'FuelCellBreakdownRateYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionFuelCell',
              isRead: 'true',
              interval: '1386',
              texttableentry: 'EnergyConsumptionFuelCell',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionFuelCellYearMatrix',
              isRead: 'true',
              interval: '1387',
              texttableentry: 'EnergyConsumptionFuelCellYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionFuelCellMonthMatrix',
              isRead: 'true',
              interval: '1388',
              texttableentry: 'EnergyConsumptionFuelCellMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CoTwoSavingsMonthMatrix',
              isRead: 'true',
              interval: '1389',
              texttableentry: 'CoTwoSavingsMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoTwoSavingsYearMatrix',
              isRead: 'true',
              interval: '1390',
              texttableentry: 'CoTwoSavingsYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedDomesticHotWaterOutput',
              isRead: 'true',
              interval: '1391',
              texttableentry: 'GeneratedDomesticHotWaterOutput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedDomesticHotWaterOutputMonthMatrix',
              isRead: 'true',
              interval: '1392',
              texttableentry: 'GeneratedDomesticHotWaterOutputMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedDomesticHotWaterOutputYearMatrix',
              isRead: 'true',
              interval: '1393',
              texttableentry: 'GeneratedDomesticHotWaterOutputYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarChargingDomesticHotWaterSetpoint',
              isRead: 'true',
              interval: '1394',
              texttableentry: 'SolarChargingDomesticHotWaterSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1395',
              texttableentry: 'MixerOneCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1396',
              texttableentry: 'MixerTwoCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1397',
              texttableentry: 'MixerThreeCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1398',
              texttableentry: 'MixerFourCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1399',
              texttableentry: 'MixerFiveCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1400',
              texttableentry: 'MixerSixCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1401',
              texttableentry: 'MixerSevenCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1402',
              texttableentry: 'MixerEightCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1403',
              texttableentry: 'MixerNineCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1404',
              texttableentry: 'MixerTenCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1405',
              texttableentry: 'MixerElevenCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1406',
              texttableentry: 'MixerTwelveCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1407',
              texttableentry: 'MixerThirteenCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1408',
              texttableentry: 'MixerFourteenCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1409',
              texttableentry: 'MixerFifteenCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1410',
              texttableentry: 'MixerSixteenCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetServiceInterval',
              isRead: 'true',
              interval: '1411',
              texttableentry: 'ResetServiceInterval',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasAirRatioCalibrationRequest',
              isRead: 'true',
              interval: '1412',
              texttableentry: 'GasAirRatioCalibrationRequest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasAirRatioCyclicCalibrationSettings',
              isRead: 'true',
              interval: '1413',
              texttableentry: 'GasAirRatioCyclicCalibrationSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VolumeFlowControlActivation',
              isRead: 'true',
              interval: '1414',
              texttableentry: 'VolumeFlowControlActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitOperationState',
              isRead: 'true',
              interval: '1415',
              texttableentry: 'MixerOneCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitOperationState',
              isRead: 'true',
              interval: '1416',
              texttableentry: 'MixerTwoCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitOperationState',
              isRead: 'true',
              interval: '1417',
              texttableentry: 'MixerThreeCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitOperationState',
              isRead: 'true',
              interval: '1418',
              texttableentry: 'MixerFourCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitOperationState',
              isRead: 'true',
              interval: '1419',
              texttableentry: 'MixerFiveCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitOperationState',
              isRead: 'true',
              interval: '1420',
              texttableentry: 'MixerSixCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitOperationState',
              isRead: 'true',
              interval: '1421',
              texttableentry: 'MixerSevenCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitOperationState',
              isRead: 'true',
              interval: '1422',
              texttableentry: 'MixerEightCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitOperationState',
              isRead: 'true',
              interval: '1423',
              texttableentry: 'MixerNineCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitOperationState',
              isRead: 'true',
              interval: '1424',
              texttableentry: 'MixerTenCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitOperationState',
              isRead: 'true',
              interval: '1425',
              texttableentry: 'MixerElevenCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitOperationState',
              isRead: 'true',
              interval: '1426',
              texttableentry: 'MixerTwelveCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitOperationState',
              isRead: 'true',
              interval: '1427',
              texttableentry: 'MixerThirteenCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitOperationState',
              isRead: 'true',
              interval: '1428',
              texttableentry: 'MixerFourteenCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitOperationState',
              isRead: 'true',
              interval: '1429',
              texttableentry: 'MixerFifteenCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitOperationState',
              isRead: 'true',
              interval: '1430',
              texttableentry: 'MixerSixteenCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CarbonEmissionSettings',
              isRead: 'true',
              interval: '1431',
              texttableentry: 'CarbonEmissionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpPerformance',
              isRead: 'true',
              interval: '1432',
              texttableentry: 'CentralHeatingPumpPerformance',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatGeneratorBlockingMethod',
              isRead: 'true',
              interval: '1433',
              texttableentry: 'HeatGeneratorBlockingMethod',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetFuelCellStatistics',
              isRead: 'true',
              interval: '1434',
              texttableentry: 'ResetFuelCellStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellFlowTemperatureSensor',
              isRead: 'true',
              interval: '1435',
              texttableentry: 'FuelCellFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellReturnTemperatureSensor',
              isRead: 'true',
              interval: '1436',
              texttableentry: 'FuelCellReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GasPressureSensor',
              isRead: 'true',
              interval: '1437',
              texttableentry: 'GasPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitWaterFlowCheck',
              isRead: 'true',
              interval: '1438',
              texttableentry: 'PrimaryCircuitWaterFlowCheck',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleMonday',
              isRead: 'true',
              interval: '1439',
              texttableentry: 'NoiseReductionTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleTuesday',
              isRead: 'true',
              interval: '1440',
              texttableentry: 'NoiseReductionTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleWednesday',
              isRead: 'true',
              interval: '1441',
              texttableentry: 'NoiseReductionTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleThursday',
              isRead: 'true',
              interval: '1442',
              texttableentry: 'NoiseReductionTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleFriday',
              isRead: 'true',
              interval: '1443',
              texttableentry: 'NoiseReductionTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleSaturday',
              isRead: 'true',
              interval: '1444',
              texttableentry: 'NoiseReductionTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleSunday',
              isRead: 'true',
              interval: '1445',
              texttableentry: 'NoiseReductionTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemainingDaysFilterChange',
              isRead: 'true',
              interval: '1446',
              texttableentry: 'RemainingDaysFilterChange',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalOutputConfigurationSix',
              isRead: 'true',
              interval: '1447',
              texttableentry: 'GenericDigitalOutputConfigurationSix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalOutputConfigurationSeven',
              isRead: 'true',
              interval: '1448',
              texttableentry: 'GenericDigitalOutputConfigurationSeven',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplayStatistics',
              isRead: 'true',
              interval: '1449',
              texttableentry: 'DisplayStatistics',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellGeneratedHeatOutput',
              isRead: 'true',
              interval: '1450',
              texttableentry: 'FuelCellGeneratedHeatOutput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApplicationChecksum',
              isRead: 'true',
              interval: '1451',
              texttableentry: 'ApplicationChecksum',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputOneValue',
              isRead: 'true',
              interval: '1452',
              texttableentry: 'DeviceDigitalInputOneValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputTwoValue',
              isRead: 'true',
              interval: '1453',
              texttableentry: 'DeviceDigitalInputTwoValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputThreeValue',
              isRead: 'true',
              interval: '1454',
              texttableentry: 'DeviceDigitalInputThreeValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputFourValue',
              isRead: 'true',
              interval: '1455',
              texttableentry: 'DeviceDigitalInputFourValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputOneValue',
              isRead: 'true',
              interval: '1456',
              texttableentry: 'DeviceDigitalOutputOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTwoValue',
              isRead: 'true',
              interval: '1457',
              texttableentry: 'DeviceDigitalOutputTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputThreeValue',
              isRead: 'true',
              interval: '1458',
              texttableentry: 'DeviceDigitalOutputThreeValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputFourValue',
              isRead: 'true',
              interval: '1459',
              texttableentry: 'DeviceDigitalOutputFourValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputFiveValue',
              isRead: 'true',
              interval: '1460',
              texttableentry: 'DeviceDigitalOutputFiveValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputSixValue',
              isRead: 'true',
              interval: '1461',
              texttableentry: 'DeviceDigitalOutputSixValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmOutputOneValue',
              isRead: 'true',
              interval: '1462',
              texttableentry: 'DevicePwmOutputOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmOutputTwoValue',
              isRead: 'true',
              interval: '1463',
              texttableentry: 'DevicePwmOutputTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AnalogInputZeroToTenOneValue',
              isRead: 'true',
              interval: '1464',
              texttableentry: 'AnalogInputZeroToTenOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AnalogOutputZeroToTenOneValue',
              isRead: 'true',
              interval: '1465',
              texttableentry: 'AnalogOutputZeroToTenOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AnalogAdcInputValues',
              isRead: 'true',
              interval: '1466',
              texttableentry: 'AnalogAdcInputValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SafetyRelevantRemoteUnlock',
              isRead: 'true',
              interval: '1467',
              texttableentry: 'SafetyRelevantRemoteUnlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGasPressure',
              isRead: 'true',
              interval: '1468',
              texttableentry: 'FuelCellGasPressure',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupHeatEngine',
              isRead: 'true',
              interval: '1469',
              texttableentry: 'SensorActuatorTestGroupHeatEngine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupDomesticHotWater',
              isRead: 'true',
              interval: '1470',
              texttableentry: 'SensorActuatorTestGroupDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupFuelCell',
              isRead: 'true',
              interval: '1471',
              texttableentry: 'SensorActuatorTestGroupFuelCell',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupHeatingCircuit',
              isRead: 'true',
              interval: '1472',
              texttableentry: 'SensorActuatorTestGroupHeatingCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupSolar',
              isRead: 'true',
              interval: '1473',
              texttableentry: 'SensorActuatorTestGroupSolar',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PelletConsumptionCentralHeating',
              isRead: 'true',
              interval: '1474',
              texttableentry: 'PelletConsumptionCentralHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PelletConsumptionCentralHeatingMonthMatrix',
              isRead: 'true',
              interval: '1475',
              texttableentry: 'PelletConsumptionCentralHeatingMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PelletConsumptionCentralHeatingYearMatrix',
              isRead: 'true',
              interval: '1476',
              texttableentry: 'PelletConsumptionCentralHeatingYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PelletConsumptionDomesticHotWater',
              isRead: 'true',
              interval: '1477',
              texttableentry: 'PelletConsumptionDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PelletConsumptionDomesticHotWaterMonthMatrix',
              isRead: 'true',
              interval: '1478',
              texttableentry: 'PelletConsumptionDomesticHotWaterMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PelletConsumptionDomesticHotWaterYearMatrix',
              isRead: 'true',
              interval: '1479',
              texttableentry: 'PelletConsumptionDomesticHotWaterYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OxygenSensor',
              isRead: 'true',
              interval: '1480',
              texttableentry: 'OxygenSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedOxygenSensor',
              isRead: 'true',
              interval: '1481',
              texttableentry: 'TimeSeriesRecordedOxygenSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BurnerChamberDoor',
              isRead: 'true',
              interval: '1482',
              texttableentry: 'BurnerChamberDoor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AshRustMotor',
              isRead: 'true',
              interval: '1483',
              texttableentry: 'AshRustMotor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PelletScrewConveyor',
              isRead: 'true',
              interval: '1484',
              texttableentry: 'PelletScrewConveyor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DepressionSensor',
              isRead: 'true',
              interval: '1485',
              texttableentry: 'DepressionSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeashingEndPosition',
              isRead: 'true',
              interval: '1486',
              texttableentry: 'DeashingEndPosition',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PelletStorageTankLevel',
              isRead: 'true',
              interval: '1487',
              texttableentry: 'PelletStorageTankLevel',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OverfillPelletScrew',
              isRead: 'true',
              interval: '1488',
              texttableentry: 'OverfillPelletScrew',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatExchangerDeashing',
              isRead: 'true',
              interval: '1489',
              texttableentry: 'HeatExchangerDeashing',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PelletSuctionTurbinePressure',
              isRead: 'true',
              interval: '1490',
              texttableentry: 'PelletSuctionTurbinePressure',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MotorizedIntakeFlap',
              isRead: 'true',
              interval: '1491',
              texttableentry: 'MotorizedIntakeFlap',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPumpHysteresis',
              isRead: 'true',
              interval: '1492',
              texttableentry: 'SolarCircuitPumpHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatEnginePerformanceStatistics',
              isRead: 'true',
              interval: '1493',
              texttableentry: 'HeatEnginePerformanceStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OemProductVersion',
              isRead: 'true',
              interval: '1494',
              texttableentry: 'OemProductVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_StepperMotorOutputOne',
              isRead: 'true',
              interval: '1495',
              texttableentry: 'StepperMotorOutputOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_StepperMotorOutputTwo',
              isRead: 'true',
              interval: '1496',
              texttableentry: 'StepperMotorOutputTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputOneValue',
              isRead: 'true',
              interval: '1497',
              texttableentry: 'DeviceAnalogInputOneValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputTwoValue',
              isRead: 'true',
              interval: '1498',
              texttableentry: 'DeviceAnalogInputTwoValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputThreeValue',
              isRead: 'true',
              interval: '1499',
              texttableentry: 'DeviceAnalogInputThreeValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputFourValue',
              isRead: 'true',
              interval: '1500',
              texttableentry: 'DeviceAnalogInputFourValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputFiveValue',
              isRead: 'true',
              interval: '1501',
              texttableentry: 'DeviceAnalogInputFiveValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MinimumLoadKw',
              isRead: 'true',
              interval: '1502',
              texttableentry: 'MinimumLoadKw',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MinimumLoadPercent',
              isRead: 'true',
              interval: '1503',
              texttableentry: 'MinimumLoadPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeSettingSource',
              isRead: 'true',
              interval: '1504',
              texttableentry: 'TimeSettingSource',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarStagnationTemperatureOffset',
              isRead: 'true',
              interval: '1505',
              texttableentry: 'SolarStagnationTemperatureOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneTargetPositionPercent',
              isRead: 'true',
              interval: '1506',
              texttableentry: 'AccessoryValveOneTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneCurrentPositionPercent',
              isRead: 'true',
              interval: '1507',
              texttableentry: 'AccessoryValveOneCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneMinMaxLimit',
              isRead: 'true',
              interval: '1508',
              texttableentry: 'AccessoryValveOneMinMaxLimit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveTwoTargetPositionPercent',
              isRead: 'true',
              interval: '1509',
              texttableentry: 'AccessoryValveTwoTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveTwoCurrentPositionPercent',
              isRead: 'true',
              interval: '1510',
              texttableentry: 'AccessoryValveTwoCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveTwoMinMaxLimit',
              isRead: 'true',
              interval: '1511',
              texttableentry: 'AccessoryValveTwoMinMaxLimit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpOneValue',
              isRead: 'true',
              interval: '1512',
              texttableentry: 'AccessoryPumpOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpTwoValue',
              isRead: 'true',
              interval: '1513',
              texttableentry: 'AccessoryPumpTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpThreeValue',
              isRead: 'true',
              interval: '1514',
              texttableentry: 'AccessoryPumpThreeValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpFourValue',
              isRead: 'true',
              interval: '1515',
              texttableentry: 'AccessoryPumpFourValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpFiveValue',
              isRead: 'true',
              interval: '1516',
              texttableentry: 'AccessoryPumpFiveValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpSixValue',
              isRead: 'true',
              interval: '1517',
              texttableentry: 'AccessoryPumpSixValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpOneStatistical',
              isRead: 'true',
              interval: '1518',
              texttableentry: 'AccessoryPumpOneStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpTwoStatistical',
              isRead: 'true',
              interval: '1519',
              texttableentry: 'AccessoryPumpTwoStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpThreeStatistical',
              isRead: 'true',
              interval: '1520',
              texttableentry: 'AccessoryPumpThreeStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpFourStatistical',
              isRead: 'true',
              interval: '1521',
              texttableentry: 'AccessoryPumpFourStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpFiveStatistical',
              isRead: 'true',
              interval: '1522',
              texttableentry: 'AccessoryPumpFiveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpSixStatistical',
              isRead: 'true',
              interval: '1523',
              texttableentry: 'AccessoryPumpSixStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryMixerOneOperationMode',
              isRead: 'true',
              interval: '1524',
              texttableentry: 'AccessoryMixerOneOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryMixerTwoOperationMode',
              isRead: 'true',
              interval: '1525',
              texttableentry: 'AccessoryMixerTwoOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryNextErrorDtc',
              isRead: 'true',
              interval: '1526',
              texttableentry: 'AccessoryNextErrorDtc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LastResetCause',
              isRead: 'true',
              interval: '1527',
              texttableentry: 'LastResetCause',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryStartupComplete',
              isRead: 'true',
              interval: '1528',
              texttableentry: 'AccessoryStartupComplete',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarRechargeSuppressionImpact',
              isRead: 'true',
              interval: '1529',
              texttableentry: 'SolarRechargeSuppressionImpact',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveFuelCellHydraulicTowerStatistical',
              isRead: 'true',
              interval: '1530',
              texttableentry: 'DiverterValveFuelCellHydraulicTowerStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiverterValveBoilerHydraulicTowerStatistical',
              isRead: 'true',
              interval: '1531',
              texttableentry: 'DiverterValveBoilerHydraulicTowerStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PlusBusAuthentication',
              isRead: 'true',
              interval: '1532',
              texttableentry: 'PlusBusAuthentication',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InstallationWizardInProgress',
              isRead: 'true',
              interval: '1533',
              texttableentry: 'InstallationWizardInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputTwoFunctionSelector',
              isRead: 'true',
              interval: '1534',
              texttableentry: 'DeviceAnalogInputTwoFunctionSelector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlueGasSensorTestMode',
              isRead: 'true',
              interval: '1535',
              texttableentry: 'FlueGasSensorTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitWaterFlowTestMode',
              isRead: 'true',
              interval: '1536',
              texttableentry: 'PrimaryCircuitWaterFlowTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ChimneySweeperTestMode',
              isRead: 'true',
              interval: '1537',
              texttableentry: 'ChimneySweeperTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeEnable',
              isRead: 'true',
              interval: '1538',
              texttableentry: 'ZigbeeEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeStatus',
              isRead: 'true',
              interval: '1539',
              texttableentry: 'ZigbeeStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigbeeIdentification',
              isRead: 'true',
              interval: '1540',
              texttableentry: 'ZigbeeIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionPump',
              isRead: 'true',
              interval: '1541',
              texttableentry: 'LegionellaProtectionPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputOneFunctionSelector',
              isRead: 'true',
              interval: '1542',
              texttableentry: 'DeviceAnalogInputOneFunctionSelector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputThreeFunctionSelector',
              isRead: 'true',
              interval: '1543',
              texttableentry: 'DeviceAnalogInputThreeFunctionSelector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputFourFunctionSelector',
              isRead: 'true',
              interval: '1544',
              texttableentry: 'DeviceAnalogInputFourFunctionSelector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputFiveFunctionSelector',
              isRead: 'true',
              interval: '1545',
              texttableentry: 'DeviceAnalogInputFiveFunctionSelector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryApplicationChecksum',
              isRead: 'true',
              interval: '1546',
              texttableentry: 'SecondaryApplicationChecksum',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FluegasSensorCheckManufacturingDisable',
              isRead: 'true',
              interval: '1547',
              texttableentry: 'FluegasSensorCheckManufacturingDisable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InternalComponentUsage',
              isRead: 'true',
              interval: '1548',
              texttableentry: 'InternalComponentUsage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicMatrixConfiguration',
              isRead: 'true',
              interval: '1549',
              texttableentry: 'HydraulicMatrixConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FunctionMatrix',
              isRead: 'true',
              interval: '1550',
              texttableentry: 'FunctionMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellExternalControl',
              isRead: 'true',
              interval: '1551',
              texttableentry: 'FuelCellExternalControl',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageOperationState',
              isRead: 'true',
              interval: '1552',
              texttableentry: 'ElectricalEnergyStorageOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOdxVersion',
              isRead: 'true',
              interval: '1553',
              texttableentry: 'ElectronicControlUnitOdxVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingSupport',
              isRead: 'true',
              interval: '1554',
              texttableentry: 'HeatingSupport',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1555',
              texttableentry: 'MixerOneCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1556',
              texttableentry: 'MixerTwoCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1557',
              texttableentry: 'MixerThreeCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1558',
              texttableentry: 'MixerFourCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1559',
              texttableentry: 'MixerFiveCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1560',
              texttableentry: 'MixerSixCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1561',
              texttableentry: 'MixerSevenCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1562',
              texttableentry: 'MixerEightCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1563',
              texttableentry: 'MixerNineCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1564',
              texttableentry: 'MixerTenCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1565',
              texttableentry: 'MixerElevenCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1566',
              texttableentry: 'MixerTwelveCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1567',
              texttableentry: 'MixerThirteenCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1568',
              texttableentry: 'MixerFourteenCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1569',
              texttableentry: 'MixerFifteenCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1570',
              texttableentry: 'MixerSixteenCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SystemPerformence',
              isRead: 'true',
              interval: '1571',
              texttableentry: 'SystemPerformence',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SystemFlowTemperatureSensor',
              isRead: 'true',
              interval: '1572',
              texttableentry: 'SystemFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SystemReturnTemperatureSensor',
              isRead: 'true',
              interval: '1573',
              texttableentry: 'SystemReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumberCascadeSystemTwo',
              isRead: 'true',
              interval: '1574',
              texttableentry: 'ViessmannIdentificationNumberCascadeSystemTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SystemStatistical',
              isRead: 'true',
              interval: '1575',
              texttableentry: 'SystemStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputSixValue',
              isRead: 'true',
              interval: '1576',
              texttableentry: 'DeviceAnalogInputSixValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleOneOperatingData',
              isRead: 'true',
              interval: '1577',
              texttableentry: 'ElectricalEnergyStorageModuleOneOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleTwoOperatingData',
              isRead: 'true',
              interval: '1578',
              texttableentry: 'ElectricalEnergyStorageModuleTwoOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleThreeOperatingData',
              isRead: 'true',
              interval: '1579',
              texttableentry: 'ElectricalEnergyStorageModuleThreeOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleFourOperatingData',
              isRead: 'true',
              interval: '1580',
              texttableentry: 'ElectricalEnergyStorageModuleFourOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleFiveOperatingData',
              isRead: 'true',
              interval: '1581',
              texttableentry: 'ElectricalEnergyStorageModuleFiveOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleSixOperatingData',
              isRead: 'true',
              interval: '1582',
              texttableentry: 'ElectricalEnergyStorageModuleSixOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpTargetSpeedSetpoint',
              isRead: 'true',
              interval: '1583',
              texttableentry: 'CentralHeatingPumpTargetSpeedSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SystemFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1584',
              texttableentry: 'SystemFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_IncreasedReturnTemperatureSetpoint',
              isRead: 'true',
              interval: '1585',
              texttableentry: 'IncreasedReturnTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatCellCondensateDetection',
              isRead: 'true',
              interval: '1586',
              texttableentry: 'HeatCellCondensateDetection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalAlternatingCurrentPowerSetpointMetaData',
              isRead: 'true',
              interval: '1587',
              texttableentry: 'ExternalAlternatingCurrentPowerSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AlternatingCurrentPowerSetpoint',
              isRead: 'true',
              interval: '1588',
              texttableentry: 'AlternatingCurrentPowerSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AlternatingCurrentPowerSetpointMetaData',
              isRead: 'true',
              interval: '1589',
              texttableentry: 'AlternatingCurrentPowerSetpointMetaData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemOperationState',
              isRead: 'true',
              interval: '1590',
              texttableentry: 'ElectricalEnergySystemOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterOperationState',
              isRead: 'true',
              interval: '1591',
              texttableentry: 'ElectricalEnergyInverterOperationState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterPath',
              isRead: 'true',
              interval: '1592',
              texttableentry: 'ElectricalEnergyInverterPath',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferHysteresis',
              isRead: 'true',
              interval: '1593',
              texttableentry: 'BufferHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LastApplicationUpdate',
              isRead: 'true',
              interval: '1594',
              texttableentry: 'LastApplicationUpdate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersionFactory',
              isRead: 'true',
              interval: '1595',
              texttableentry: 'ParameterIdentificationVersionFactory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_IncreasedReturnTemperatureSensor',
              isRead: 'true',
              interval: '1596',
              texttableentry: 'IncreasedReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SystemReturnTemperatureSetpoint',
              isRead: 'true',
              interval: '1597',
              texttableentry: 'SystemReturnTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarStaticTemperatureControlHysteresis',
              isRead: 'true',
              interval: '1598',
              texttableentry: 'SolarStaticTemperatureControlHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarSecondaryDeltaTemperatureHysteresis',
              isRead: 'true',
              interval: '1599',
              texttableentry: 'SolarSecondaryDeltaTemperatureHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BufferDischargeFunctionThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '1600',
              texttableentry: 'BufferDischargeFunctionThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellCondition',
              isRead: 'true',
              interval: '1601',
              texttableentry: 'FuelCellCondition',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ButtonMonitoring',
              isRead: 'true',
              interval: '1602',
              texttableentry: 'ButtonMonitoring',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingPower',
              isRead: 'true',
              interval: '1603',
              texttableentry: 'PointOfCommonCouplingPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayExternalTargetFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1604',
              texttableentry: 'GatewayExternalTargetFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayExternalHeatEngineTargetOperationMode',
              isRead: 'true',
              interval: '1605',
              texttableentry: 'GatewayExternalHeatEngineTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_IntervalStrategyProperties',
              isRead: 'true',
              interval: '1606',
              texttableentry: 'IntervalStrategyProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MalfunctionUnitBlocked',
              isRead: 'true',
              interval: '1607',
              texttableentry: 'MalfunctionUnitBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DifferentialTemperatureControllerHeatSourceTemperatureSensor',
              isRead: 'true',
              interval: '1608',
              texttableentry: 'DifferentialTemperatureControllerHeatSourceTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DifferentialTemperatureControllerHeatSinkTemperatureSensor',
              isRead: 'true',
              interval: '1609',
              texttableentry: 'DifferentialTemperatureControllerHeatSinkTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingSupportBufferTemperatureSensor',
              isRead: 'true',
              interval: '1610',
              texttableentry: 'HeatingSupportBufferTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PreheatingReferenceTemperatureSensor',
              isRead: 'true',
              interval: '1611',
              texttableentry: 'PreheatingReferenceTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerTwoCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1612',
              texttableentry: 'ExternalMixerTwoCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerThreeCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1613',
              texttableentry: 'ExternalMixerThreeCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerFourCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1614',
              texttableentry: 'ExternalMixerFourCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerFiveCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1615',
              texttableentry: 'ExternalMixerFiveCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerSixCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1616',
              texttableentry: 'ExternalMixerSixCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerSevenCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1617',
              texttableentry: 'ExternalMixerSevenCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerEightCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1618',
              texttableentry: 'ExternalMixerEightCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerNineCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1619',
              texttableentry: 'ExternalMixerNineCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerTenCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1620',
              texttableentry: 'ExternalMixerTenCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerElevenCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1621',
              texttableentry: 'ExternalMixerElevenCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerTwelveCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1622',
              texttableentry: 'ExternalMixerTwelveCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerThirteenCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1623',
              texttableentry: 'ExternalMixerThirteenCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerFourteenCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1624',
              texttableentry: 'ExternalMixerFourteenCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerFifteenCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1625',
              texttableentry: 'ExternalMixerFifteenCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerSixteenCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1626',
              texttableentry: 'ExternalMixerSixteenCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerOneCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1627',
              texttableentry: 'ExternalMixerOneCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerTwoCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1628',
              texttableentry: 'ExternalMixerTwoCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerThreeCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1629',
              texttableentry: 'ExternalMixerThreeCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerFourCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1630',
              texttableentry: 'ExternalMixerFourCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerFiveCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1631',
              texttableentry: 'ExternalMixerFiveCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerSixCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1632',
              texttableentry: 'ExternalMixerSixCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerSevenCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1633',
              texttableentry: 'ExternalMixerSevenCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerEightCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1634',
              texttableentry: 'ExternalMixerEightCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerNineCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1635',
              texttableentry: 'ExternalMixerNineCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerTenCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1636',
              texttableentry: 'ExternalMixerTenCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerElevenCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1637',
              texttableentry: 'ExternalMixerElevenCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerTwelveCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1638',
              texttableentry: 'ExternalMixerTwelveCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry:
                'TI_ExternalMixerThirteenCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1639',
              texttableentry: 'ExternalMixerThirteenCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry:
                'TI_ExternalMixerFourteenCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1640',
              texttableentry: 'ExternalMixerFourteenCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry:
                'TI_ExternalMixerFifteenCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1641',
              texttableentry: 'ExternalMixerFifteenCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry:
                'TI_ExternalMixerSixteenCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1642',
              texttableentry: 'ExternalMixerSixteenCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1643',
              texttableentry: 'MixerOneCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1644',
              texttableentry: 'MixerTwoCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1645',
              texttableentry: 'MixerThreeCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1646',
              texttableentry: 'MixerFourCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1647',
              texttableentry: 'MixerFiveCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1648',
              texttableentry: 'MixerSixCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1649',
              texttableentry: 'MixerSevenCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1650',
              texttableentry: 'MixerEightCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1651',
              texttableentry: 'MixerNineCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1652',
              texttableentry: 'MixerTenCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1653',
              texttableentry: 'MixerElevenCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1654',
              texttableentry: 'MixerTwelveCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1655',
              texttableentry: 'MixerThirteenCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1656',
              texttableentry: 'MixerFourteenCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1657',
              texttableentry: 'MixerFifteenCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1658',
              texttableentry: 'MixerSixteenCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EndResultDomesticHotWaterTemperatureSetpoint',
              isRead: 'true',
              interval: '1659',
              texttableentry: 'EndResultDomesticHotWaterTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupportedFeatures',
              isRead: 'true',
              interval: '1660',
              texttableentry: 'SupportedFeatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarSecondaryTransferPump',
              isRead: 'true',
              interval: '1661',
              texttableentry: 'SolarSecondaryTransferPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatingSupportBufferThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '1662',
              texttableentry: 'HeatingSupportBufferThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TestStatus',
              isRead: 'true',
              interval: '1663',
              texttableentry: 'TestStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageStateOfCharge',
              isRead: 'true',
              interval: '1664',
              texttableentry: 'ElectricalEnergyStorageStateOfCharge',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1665',
              texttableentry: 'PrimaryCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageStateOfHealth',
              isRead: 'true',
              interval: '1666',
              texttableentry: 'ElectricalEnergyStorageStateOfHealth',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1667',
              texttableentry: 'MixerOneCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1668',
              texttableentry: 'MixerTwoCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1669',
              texttableentry: 'MixerThreeCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1670',
              texttableentry: 'MixerFourCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1671',
              texttableentry: 'MixerFiveCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1672',
              texttableentry: 'MixerSixCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1673',
              texttableentry: 'MixerSevenCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1674',
              texttableentry: 'MixerEightCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1675',
              texttableentry: 'MixerNineCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1676',
              texttableentry: 'MixerTenCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1677',
              texttableentry: 'MixerElevenCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1678',
              texttableentry: 'MixerTwelveCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1679',
              texttableentry: 'MixerThirteenCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1680',
              texttableentry: 'MixerFourteenCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1681',
              texttableentry: 'MixerFifteenCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1682',
              texttableentry: 'MixerSixteenCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FixedValueFlowTemperatureSetpointMetaData',
              isRead: 'true',
              interval: '1683',
              texttableentry: 'FixedValueFlowTemperatureSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AmbientTemperatureSensor',
              isRead: 'true',
              interval: '1684',
              texttableentry: 'AmbientTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDCConfiguration',
              isRead: 'true',
              interval: '1685',
              texttableentry: 'ElectricalEnergyInverterDCConfiguration',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemPhotovoltaicLimitation',
              isRead: 'true',
              interval: '1686',
              texttableentry: 'ElectricalEnergySystemPhotovoltaicLimitation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemPhotovoltaicConfiguration',
              isRead: 'true',
              interval: '1687',
              texttableentry: 'ElectricalEnergySystemPhotovoltaicConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ButtonMonitoringRawValues',
              isRead: 'true',
              interval: '1688',
              texttableentry: 'ButtonMonitoringRawValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryControllerSoftwareVersion',
              isRead: 'true',
              interval: '1689',
              texttableentry: 'SecondaryControllerSoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemPhotovoltaicStatus',
              isRead: 'true',
              interval: '1690',
              texttableentry: 'ElectricalEnergySystemPhotovoltaicStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyScanStatus',
              isRead: 'true',
              interval: '1691',
              texttableentry: 'BusTopologyScanStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeConfiguration',
              isRead: 'true',
              interval: '1692',
              texttableentry: 'PowerGridCodeConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GridOperatorConfigurationLock',
              isRead: 'true',
              interval: '1693',
              texttableentry: 'GridOperatorConfigurationLock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetEnable',
              isRead: 'true',
              interval: '1694',
              texttableentry: 'GatewayEthernetEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetConfig',
              isRead: 'true',
              interval: '1695',
              texttableentry: 'GatewayEthernetConfig',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetIp',
              isRead: 'true',
              interval: '1696',
              texttableentry: 'GatewayEthernetIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetNetworkStatus',
              isRead: 'true',
              interval: '1697',
              texttableentry: 'GatewayEthernetNetworkStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupportedFeaturesTelemetryControlUnit',
              isRead: 'true',
              interval: '1698',
              texttableentry: 'SupportedFeaturesTelemetryControlUnit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ActivatedFeaturesTelemetryControlUnit',
              isRead: 'true',
              interval: '1699',
              texttableentry: 'ActivatedFeaturesTelemetryControlUnit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceList',
              isRead: 'true',
              interval: '1700',
              texttableentry: 'EebusDeviceList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EebusOwnInfo',
              isRead: 'true',
              interval: '1701',
              texttableentry: 'EebusOwnInfo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusPartnerInfo',
              isRead: 'true',
              interval: '1702',
              texttableentry: 'EebusPartnerInfo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusConnectionStatus',
              isRead: 'true',
              interval: '1703',
              texttableentry: 'EebusConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TouchDisplayState',
              isRead: 'true',
              interval: '1704',
              texttableentry: 'TouchDisplayState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GenericMZIOAccessoryOneModuleFunction',
              isRead: 'true',
              interval: '1705',
              texttableentry: 'GenericMZIOAccessoryOneModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMZIOAccessoryTwoModuleFunction',
              isRead: 'true',
              interval: '1706',
              texttableentry: 'GenericMZIOAccessoryTwoModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMZIOAccessoryThreeModuleFunction',
              isRead: 'true',
              interval: '1707',
              texttableentry: 'GenericMZIOAccessoryThreeModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMZIOAccessoryFourModuleFunction',
              isRead: 'true',
              interval: '1708',
              texttableentry: 'GenericMZIOAccessoryFourModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMZIOAccessoryModuleFunction',
              isRead: 'true',
              interval: '1709',
              texttableentry: 'GenericMZIOAccessoryModuleFunction',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FunctionalSoftwareVersion',
              isRead: 'true',
              interval: '1710',
              texttableentry: 'FunctionalSoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputSevenValue',
              isRead: 'true',
              interval: '1711',
              texttableentry: 'DeviceAnalogInputSevenValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputEightValue',
              isRead: 'true',
              interval: '1712',
              texttableentry: 'DeviceAnalogInputEightValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputNineValue',
              isRead: 'true',
              interval: '1713',
              texttableentry: 'DeviceAnalogInputNineValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputTenValue',
              isRead: 'true',
              interval: '1714',
              texttableentry: 'DeviceAnalogInputTenValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputElevenValue',
              isRead: 'true',
              interval: '1715',
              texttableentry: 'DeviceAnalogInputElevenValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputTwelveValue',
              isRead: 'true',
              interval: '1716',
              texttableentry: 'DeviceAnalogInputTwelveValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputThirteenValue',
              isRead: 'true',
              interval: '1717',
              texttableentry: 'DeviceAnalogInputThirteenValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemConfiguration',
              isRead: 'true',
              interval: '1718',
              texttableentry: 'ElectricalEnergySystemConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarIntervalFunction',
              isRead: 'true',
              interval: '1719',
              texttableentry: 'SolarIntervalFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputFiveValue',
              isRead: 'true',
              interval: '1720',
              texttableentry: 'DeviceDigitalInputFiveValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterPressureConfiguration',
              isRead: 'true',
              interval: '1721',
              texttableentry: 'WaterPressureConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalOneCircuitOperationMode',
              isRead: 'true',
              interval: '1722',
              texttableentry: 'ThermostatTerminalOneCircuitOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalTwoCircuitOperationMode',
              isRead: 'true',
              interval: '1723',
              texttableentry: 'ThermostatTerminalTwoCircuitOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalThreeCircuitOperationMode',
              isRead: 'true',
              interval: '1724',
              texttableentry: 'ThermostatTerminalThreeCircuitOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalOneCircuitDemandInput',
              isRead: 'true',
              interval: '1725',
              texttableentry: 'ThermostatTerminalOneCircuitDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalTwoCircuitDemandInput',
              isRead: 'true',
              interval: '1726',
              texttableentry: 'ThermostatTerminalTwoCircuitDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalThreeCircuitDemandInput',
              isRead: 'true',
              interval: '1727',
              texttableentry: 'ThermostatTerminalThreeCircuitDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalOneCircuitPump',
              isRead: 'true',
              interval: '1728',
              texttableentry: 'ThermostatTerminalOneCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalTwoCircuitPump',
              isRead: 'true',
              interval: '1729',
              texttableentry: 'ThermostatTerminalTwoCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalThreeCircuitPump',
              isRead: 'true',
              interval: '1730',
              texttableentry: 'ThermostatTerminalThreeCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalLockActive',
              isRead: 'true',
              interval: '1731',
              texttableentry: 'ExternalLockActive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FixedRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1732',
              texttableentry: 'FixedRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1733',
              texttableentry: 'MixerOneCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1734',
              texttableentry: 'MixerTwoCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1735',
              texttableentry: 'MixerThreeCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1736',
              texttableentry: 'MixerFourCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1737',
              texttableentry: 'MixerFiveCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1738',
              texttableentry: 'MixerSixCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1739',
              texttableentry: 'MixerSevenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1740',
              texttableentry: 'MixerEightCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1741',
              texttableentry: 'MixerNineCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1742',
              texttableentry: 'MixerTenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1743',
              texttableentry: 'MixerElevenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1744',
              texttableentry: 'MixerTwelveCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1745',
              texttableentry: 'MixerThirteenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1746',
              texttableentry: 'MixerFourteenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1747',
              texttableentry: 'MixerFifteenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1748',
              texttableentry: 'MixerSixteenCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedModulationCurrentValueStepsAndDurationOne',
              isRead: 'true',
              interval: '1749',
              texttableentry: 'TimeSeriesRecordedModulationCurrentValueStepsAndDurationOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedModulationCurrentValueStepsAndDurationTwo',
              isRead: 'true',
              interval: '1750',
              texttableentry: 'TimeSeriesRecordedModulationCurrentValueStepsAndDurationTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedModulationCurrentValueStepsAndDurationThree',
              isRead: 'true',
              interval: '1751',
              texttableentry: 'TimeSeriesRecordedModulationCurrentValueStepsAndDurationThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationOne',
              isRead: 'true',
              interval: '1752',
              texttableentry: 'TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationTwo',
              isRead: 'true',
              interval: '1753',
              texttableentry: 'TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationThree',
              isRead: 'true',
              interval: '1754',
              texttableentry: 'TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PermanentMemorySafetySecurity',
              isRead: 'true',
              interval: '1755',
              texttableentry: 'PermanentMemorySafetySecurity',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PermanentMemoryHeatingCell',
              isRead: 'true',
              interval: '1756',
              texttableentry: 'PermanentMemoryHeatingCell',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PermanentMemoryCentralHeatingDomesticHotWaterComfort',
              isRead: 'true',
              interval: '1757',
              texttableentry: 'PermanentMemoryCentralHeatingDomesticHotWaterComfort',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PermanentMemoryHeatDistribution',
              isRead: 'true',
              interval: '1758',
              texttableentry: 'PermanentMemoryHeatDistribution',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedDomesticHotWaterOutletTemperature',
              isRead: 'true',
              interval: '1759',
              texttableentry: 'TimeSeriesRecordedDomesticHotWaterOutletTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCombustionAirInletTemperature',
              isRead: 'true',
              interval: '1760',
              texttableentry: 'TimeSeriesRecordedCombustionAirInletTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCentralHeatingPumpSpeed',
              isRead: 'true',
              interval: '1761',
              texttableentry: 'TimeSeriesRecordedCentralHeatingPumpSpeed',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LowWaterCutOffSignalInput',
              isRead: 'true',
              interval: '1762',
              texttableentry: 'LowWaterCutOffSignalInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LowGasPressureSignalInput',
              isRead: 'true',
              interval: '1763',
              texttableentry: 'LowGasPressureSignalInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HighGasPressureSignalInput',
              isRead: 'true',
              interval: '1764',
              texttableentry: 'HighGasPressureSignalInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CombustionAirInterlock',
              isRead: 'true',
              interval: '1765',
              texttableentry: 'CombustionAirInterlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleOperatingData',
              isRead: 'true',
              interval: '1766',
              texttableentry: 'ElectricalEnergyStorageModuleOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlueGasTemperatureSensorTwo',
              isRead: 'true',
              interval: '1767',
              texttableentry: 'FlueGasTemperatureSensorTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ReceiverTemperatureSensor',
              isRead: 'true',
              interval: '1768',
              texttableentry: 'ReceiverTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryInletTemperatureSensor',
              isRead: 'true',
              interval: '1769',
              texttableentry: 'PrimaryInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryOutletTemperatureSensor',
              isRead: 'true',
              interval: '1770',
              texttableentry: 'SecondaryOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EngineRoomTemperatureSensor',
              isRead: 'true',
              interval: '1771',
              texttableentry: 'EngineRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOilTemperatureSensor',
              isRead: 'true',
              interval: '1772',
              texttableentry: 'CompressorOilTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCircuitFourWayValve',
              isRead: 'true',
              interval: '1773',
              texttableentry: 'RefrigerantCircuitFourWayValve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorCrankCaseHeater',
              isRead: 'true',
              interval: '1774',
              texttableentry: 'CompressorCrankCaseHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitFanOne',
              isRead: 'true',
              interval: '1775',
              texttableentry: 'PrimaryCircuitFanOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitFanTwo',
              isRead: 'true',
              interval: '1776',
              texttableentry: 'PrimaryCircuitFanTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationOne',
              isRead: 'true',
              interval: '1777',
              texttableentry: 'TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationTwo',
              isRead: 'true',
              interval: '1778',
              texttableentry: 'TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry:
                'TI_TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationThree',
              isRead: 'true',
              interval: '1779',
              texttableentry: 'TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedIgnitionTimeSteps',
              isRead: 'true',
              interval: '1780',
              texttableentry: 'TimeSeriesRecordedIgnitionTimeSteps',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCalibrationCount',
              isRead: 'true',
              interval: '1781',
              texttableentry: 'TimeSeriesRecordedCalibrationCount',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedMonitoringIonizationMaximum',
              isRead: 'true',
              interval: '1782',
              texttableentry: 'TimeSeriesRecordedMonitoringIonizationMaximum',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedHeatingBurnerStopEvents',
              isRead: 'true',
              interval: '1783',
              texttableentry: 'TimeSeriesRecordedHeatingBurnerStopEvents',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedDomesticHotWaterBurnerStopEvents',
              isRead: 'true',
              interval: '1784',
              texttableentry: 'TimeSeriesRecordedDomesticHotWaterBurnerStopEvents',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlameLossModulation',
              isRead: 'true',
              interval: '1785',
              texttableentry: 'TimeSeriesRecordedFlameLossModulation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedWaterPressureStagnation',
              isRead: 'true',
              interval: '1786',
              texttableentry: 'TimeSeriesRecordedWaterPressureStagnation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedWaterPressurePeaks',
              isRead: 'true',
              interval: '1787',
              texttableentry: 'TimeSeriesRecordedWaterPressurePeaks',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CanInterfaceVersion',
              isRead: 'true',
              interval: '1788',
              texttableentry: 'CanInterfaceVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmInputOneValue',
              isRead: 'true',
              interval: '1789',
              texttableentry: 'DevicePwmInputOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmInputTwoValue',
              isRead: 'true',
              interval: '1790',
              texttableentry: 'DevicePwmInputTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveDefaultPositionConfiguration',
              isRead: 'true',
              interval: '1791',
              texttableentry: 'DiverterValveDefaultPositionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetElectricalEnergyHistory',
              isRead: 'true',
              interval: '1792',
              texttableentry: 'ResetElectricalEnergyHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BurnerPreconditions',
              isRead: 'true',
              interval: '1793',
              texttableentry: 'BurnerPreconditions',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingCircuitHeatDeficit',
              isRead: 'true',
              interval: '1794',
              texttableentry: 'HeatingCircuitHeatDeficit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellRuntimePrediction',
              isRead: 'true',
              interval: '1795',
              texttableentry: 'FuelCellRuntimePrediction',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticElectricalEnergyConsumption',
              isRead: 'true',
              interval: '1796',
              texttableentry: 'DomesticElectricalEnergyConsumption',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PredictionDomesticElectricalEnergyConsumptionNextHour',
              isRead: 'true',
              interval: '1797',
              texttableentry: 'PredictionDomesticElectricalEnergyConsumptionNextHour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellHoursTillNextStart',
              isRead: 'true',
              interval: '1798',
              texttableentry: 'FuelCellHoursTillNextStart',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1799',
              texttableentry: 'PrimaryCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetTimeSeriesRecordingGroups',
              isRead: 'true',
              interval: '1800',
              texttableentry: 'ResetTimeSeriesRecordingGroups',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageEnergyTransferStatistic',
              isRead: 'true',
              interval: '1801',
              texttableentry: 'ElectricalEnergyStorageEnergyTransferStatistic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyProductionPhotovoltaic',
              isRead: 'true',
              interval: '1802',
              texttableentry: 'EnergyProductionPhotovoltaic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfaceProcessValues',
              isRead: 'true',
              interval: '1803',
              texttableentry: 'DebuggingInterfaceProcessValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfacePowerDemand',
              isRead: 'false',
              interval: '1804',
              texttableentry: 'DebuggingInterfacePowerDemand',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfaceProgrammingMode',
              isRead: 'true',
              interval: '1805',
              texttableentry: 'DebuggingInterfaceProgrammingMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfaceReleaseCheckTestFunctions',
              isRead: 'false',
              interval: '1806',
              texttableentry: 'DebuggingInterfaceReleaseCheckTestFunctions',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDcInputOne',
              isRead: 'true',
              interval: '1807',
              texttableentry: 'ElectricalEnergyInverterDcInputOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDcInputTwo',
              isRead: 'true',
              interval: '1808',
              texttableentry: 'ElectricalEnergyInverterDcInputTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDcInputThree',
              isRead: 'true',
              interval: '1809',
              texttableentry: 'ElectricalEnergyInverterDcInputThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterPowerAc',
              isRead: 'true',
              interval: '1810',
              texttableentry: 'ElectricalEnergyInverterPowerAc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleSetUpCheck',
              isRead: 'true',
              interval: '1811',
              texttableentry: 'ElectricalEnergyStorageModuleSetUpCheck',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingConfiguredEnergyMeter',
              isRead: 'true',
              interval: '1812',
              texttableentry: 'PointOfCommonCouplingConfiguredEnergyMeter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnhancedVapourInjectionValve',
              isRead: 'true',
              interval: '1813',
              texttableentry: 'EnhancedVapourInjectionValve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ReceiverLiquidLevelSensor',
              isRead: 'true',
              interval: '1814',
              texttableentry: 'ReceiverLiquidLevelSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseOne',
              isRead: 'true',
              interval: '1815',
              texttableentry: 'ElectricalHeaterPhaseOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseTwo',
              isRead: 'true',
              interval: '1816',
              texttableentry: 'ElectricalHeaterPhaseTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseThree',
              isRead: 'true',
              interval: '1817',
              texttableentry: 'ElectricalHeaterPhaseThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SikaVortexFlowSensor',
              isRead: 'true',
              interval: '1818',
              texttableentry: 'SikaVortexFlowSensor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarPumpConfigurationSelection',
              isRead: 'true',
              interval: '1819',
              texttableentry: 'SolarPumpConfigurationSelection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarPumpCharacteristics',
              isRead: 'true',
              interval: '1820',
              texttableentry: 'SolarPumpCharacteristics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterVendorStateCode',
              isRead: 'true',
              interval: '1821',
              texttableentry: 'InverterVendorStateCode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterCurrent',
              isRead: 'true',
              interval: '1822',
              texttableentry: 'ThreePhaseInverterCurrent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterVoltage',
              isRead: 'true',
              interval: '1823',
              texttableentry: 'ThreePhaseInverterVoltage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterCurrentPower',
              isRead: 'true',
              interval: '1824',
              texttableentry: 'ThreePhaseInverterCurrentPower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterCurrentApparentPower',
              isRead: 'true',
              interval: '1825',
              texttableentry: 'ThreePhaseInverterCurrentApparentPower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterMaximunNominalPower',
              isRead: 'true',
              interval: '1826',
              texttableentry: 'ThreePhaseInverterMaximunNominalPower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterElectricalEnergyStorageMaximumNominalChargePower',
              isRead: 'true',
              interval: '1827',
              texttableentry: 'InverterElectricalEnergyStorageMaximumNominalChargePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterElectricalEnergyStorageCurrentMaximumlChargePower',
              isRead: 'true',
              interval: '1828',
              texttableentry: 'InverterElectricalEnergyStorageCurrentMaximumlChargePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterElectricalEnergyStorageMaximumNominalDischargePower',
              isRead: 'true',
              interval: '1829',
              texttableentry: 'InverterElectricalEnergyStorageMaximumNominalDischargePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterElectricalEnergyStorageCurrentMaximumlDishargePower',
              isRead: 'true',
              interval: '1830',
              texttableentry: 'InverterElectricalEnergyStorageCurrentMaximumlDishargePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicCurrentStringPower',
              isRead: 'true',
              interval: '1831',
              texttableentry: 'PhotovoltaicCurrentStringPower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicStringCurrent',
              isRead: 'true',
              interval: '1832',
              texttableentry: 'PhotovoltaicStringCurrent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicStringVoltage',
              isRead: 'true',
              interval: '1833',
              texttableentry: 'PhotovoltaicStringVoltage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageStateOfEnergy',
              isRead: 'true',
              interval: '1834',
              texttableentry: 'ElectricalEnergyStorageStateOfEnergy',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ManufacturerProperties',
              isRead: 'true',
              interval: '1835',
              texttableentry: 'ManufacturerProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageCurrentPower',
              isRead: 'true',
              interval: '1836',
              texttableentry: 'ElectricalEnergyStorageCurrentPower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageCurrent',
              isRead: 'true',
              interval: '1837',
              texttableentry: 'ElectricalEnergyStorageCurrent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageVoltage',
              isRead: 'true',
              interval: '1838',
              texttableentry: 'ElectricalEnergyStorageVoltage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageUsableEnergy',
              isRead: 'true',
              interval: '1839',
              texttableentry: 'ElectricalEnergyStorageUsableEnergy',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageUsableNominalEnergy',
              isRead: 'true',
              interval: '1840',
              texttableentry: 'ElectricalEnergyStorageUsableNominalEnergy',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingOverview',
              isRead: 'true',
              interval: '1841',
              texttableentry: 'PointOfCommonCouplingOverview',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryCircuitFourThreeWayValve',
              isRead: 'true',
              interval: '1842',
              texttableentry: 'SecondaryCircuitFourThreeWayValve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitHumidityProtection',
              isRead: 'true',
              interval: '1843',
              texttableentry: 'MixerOneCircuitHumidityProtection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitHumidityProtection',
              isRead: 'true',
              interval: '1844',
              texttableentry: 'MixerTwoCircuitHumidityProtection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCompressorEnvelope',
              isRead: 'true',
              interval: '1845',
              texttableentry: 'HeatPumpCompressorEnvelope',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCompressorCurrentOperatingPoint',
              isRead: 'true',
              interval: '1846',
              texttableentry: 'HeatPumpCompressorCurrentOperatingPoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerDetailsExtensions',
              isRead: 'true',
              interval: '1847',
              texttableentry: 'CustomerDetailsExtensions',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneProperty',
              isRead: 'true',
              interval: '1848',
              texttableentry: 'ApartmentOneProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSetpoints',
              isRead: 'true',
              interval: '1849',
              texttableentry: 'ApartmentOneSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneTimeScheduleMonday',
              isRead: 'true',
              interval: '1850',
              texttableentry: 'ApartmentOneTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneTimeScheduleTuesday',
              isRead: 'true',
              interval: '1851',
              texttableentry: 'ApartmentOneTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneTimeScheduleWednesday',
              isRead: 'true',
              interval: '1852',
              texttableentry: 'ApartmentOneTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneTimeScheduleThursday',
              isRead: 'true',
              interval: '1853',
              texttableentry: 'ApartmentOneTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneTimeScheduleFriday',
              isRead: 'true',
              interval: '1854',
              texttableentry: 'ApartmentOneTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneTimeScheduleSaturday',
              isRead: 'true',
              interval: '1855',
              texttableentry: 'ApartmentOneTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneTimeScheduleSunday',
              isRead: 'true',
              interval: '1856',
              texttableentry: 'ApartmentOneTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentTwoProperty',
              isRead: 'true',
              interval: '1857',
              texttableentry: 'ApartmentTwoProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentTwoSetpoints',
              isRead: 'true',
              interval: '1858',
              texttableentry: 'ApartmentTwoSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentTwoTimeScheduleMonday',
              isRead: 'true',
              interval: '1859',
              texttableentry: 'ApartmentTwoTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentTwoTimeScheduleTuesday',
              isRead: 'true',
              interval: '1860',
              texttableentry: 'ApartmentTwoTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentTwoTimeScheduleWednesday',
              isRead: 'true',
              interval: '1861',
              texttableentry: 'ApartmentTwoTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentTwoTimeScheduleThursday',
              isRead: 'true',
              interval: '1862',
              texttableentry: 'ApartmentTwoTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentTwoTimeScheduleFriday',
              isRead: 'true',
              interval: '1863',
              texttableentry: 'ApartmentTwoTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentTwoTimeScheduleSaturday',
              isRead: 'true',
              interval: '1864',
              texttableentry: 'ApartmentTwoTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentTwoTimeScheduleSunday',
              isRead: 'true',
              interval: '1865',
              texttableentry: 'ApartmentTwoTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentThreeProperty',
              isRead: 'true',
              interval: '1866',
              texttableentry: 'ApartmentThreeProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentThreeSetpoints',
              isRead: 'true',
              interval: '1867',
              texttableentry: 'ApartmentThreeSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentThreeTimeScheduleMonday',
              isRead: 'true',
              interval: '1868',
              texttableentry: 'ApartmentThreeTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentThreeTimeScheduleTuesday',
              isRead: 'true',
              interval: '1869',
              texttableentry: 'ApartmentThreeTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentThreeTimeScheduleWednesday',
              isRead: 'true',
              interval: '1870',
              texttableentry: 'ApartmentThreeTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentThreeTimeScheduleThursday',
              isRead: 'true',
              interval: '1871',
              texttableentry: 'ApartmentThreeTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentThreeTimeScheduleFriday',
              isRead: 'true',
              interval: '1872',
              texttableentry: 'ApartmentThreeTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentThreeTimeScheduleSaturday',
              isRead: 'true',
              interval: '1873',
              texttableentry: 'ApartmentThreeTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentThreeTimeScheduleSunday',
              isRead: 'true',
              interval: '1874',
              texttableentry: 'ApartmentThreeTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentFourProperty',
              isRead: 'true',
              interval: '1875',
              texttableentry: 'ApartmentFourProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentFourSetpoints',
              isRead: 'true',
              interval: '1876',
              texttableentry: 'ApartmentFourSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentFourTimeScheduleMonday',
              isRead: 'true',
              interval: '1877',
              texttableentry: 'ApartmentFourTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentFourTimeScheduleTuesday',
              isRead: 'true',
              interval: '1878',
              texttableentry: 'ApartmentFourTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentFourTimeScheduleWednesday',
              isRead: 'true',
              interval: '1879',
              texttableentry: 'ApartmentFourTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentFourTimeScheduleThursday',
              isRead: 'true',
              interval: '1880',
              texttableentry: 'ApartmentFourTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentFourTimeScheduleFriday',
              isRead: 'true',
              interval: '1881',
              texttableentry: 'ApartmentFourTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentFourTimeScheduleSaturday',
              isRead: 'true',
              interval: '1882',
              texttableentry: 'ApartmentFourTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentFourTimeScheduleSunday',
              isRead: 'true',
              interval: '1883',
              texttableentry: 'ApartmentFourTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomOneProperty',
              isRead: 'true',
              interval: '1884',
              texttableentry: 'RoomOneProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomOneSetpoints',
              isRead: 'true',
              interval: '1885',
              texttableentry: 'RoomOneSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomOneCurrentValues',
              isRead: 'true',
              interval: '1886',
              texttableentry: 'RoomOneCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwoProperty',
              isRead: 'true',
              interval: '1887',
              texttableentry: 'RoomTwoProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomTwoSetpoints',
              isRead: 'true',
              interval: '1888',
              texttableentry: 'RoomTwoSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomTwoCurrentValues',
              isRead: 'true',
              interval: '1889',
              texttableentry: 'RoomTwoCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThreeProperty',
              isRead: 'true',
              interval: '1890',
              texttableentry: 'RoomThreeProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomThreeSetpoints',
              isRead: 'true',
              interval: '1891',
              texttableentry: 'RoomThreeSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomThreeCurrentValues',
              isRead: 'true',
              interval: '1892',
              texttableentry: 'RoomThreeCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourProperty',
              isRead: 'true',
              interval: '1893',
              texttableentry: 'RoomFourProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomFourSetpoints',
              isRead: 'true',
              interval: '1894',
              texttableentry: 'RoomFourSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomFourCurrentValues',
              isRead: 'true',
              interval: '1895',
              texttableentry: 'RoomFourCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFiveProperty',
              isRead: 'true',
              interval: '1896',
              texttableentry: 'RoomFiveProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomFiveSetpoints',
              isRead: 'true',
              interval: '1897',
              texttableentry: 'RoomFiveSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomFiveCurrentValues',
              isRead: 'true',
              interval: '1898',
              texttableentry: 'RoomFiveCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixProperty',
              isRead: 'true',
              interval: '1899',
              texttableentry: 'RoomSixProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomSixSetpoints',
              isRead: 'true',
              interval: '1900',
              texttableentry: 'RoomSixSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomSixCurrentValues',
              isRead: 'true',
              interval: '1901',
              texttableentry: 'RoomSixCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSevenProperty',
              isRead: 'true',
              interval: '1902',
              texttableentry: 'RoomSevenProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomSevenSetpoints',
              isRead: 'true',
              interval: '1903',
              texttableentry: 'RoomSevenSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomSevenCurrentValues',
              isRead: 'true',
              interval: '1904',
              texttableentry: 'RoomSevenCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEightProperty',
              isRead: 'true',
              interval: '1905',
              texttableentry: 'RoomEightProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomEightSetpoints',
              isRead: 'true',
              interval: '1906',
              texttableentry: 'RoomEightSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomEightCurrentValues',
              isRead: 'true',
              interval: '1907',
              texttableentry: 'RoomEightCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineProperty',
              isRead: 'true',
              interval: '1908',
              texttableentry: 'RoomNineProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomNineSetpoints',
              isRead: 'true',
              interval: '1909',
              texttableentry: 'RoomNineSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomNineCurrentValues',
              isRead: 'true',
              interval: '1910',
              texttableentry: 'RoomNineCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTenProperty',
              isRead: 'true',
              interval: '1911',
              texttableentry: 'RoomTenProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomTenSetpoints',
              isRead: 'true',
              interval: '1912',
              texttableentry: 'RoomTenSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomTenCurrentValues',
              isRead: 'true',
              interval: '1913',
              texttableentry: 'RoomTenCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomElevenProperty',
              isRead: 'true',
              interval: '1914',
              texttableentry: 'RoomElevenProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomElevenSetpoints',
              isRead: 'true',
              interval: '1915',
              texttableentry: 'RoomElevenSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomElevenCurrentValues',
              isRead: 'true',
              interval: '1916',
              texttableentry: 'RoomElevenCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwelveProperty',
              isRead: 'true',
              interval: '1917',
              texttableentry: 'RoomTwelveProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomTwelveSetpoints',
              isRead: 'true',
              interval: '1918',
              texttableentry: 'RoomTwelveSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomTwelveCurrentValues',
              isRead: 'true',
              interval: '1919',
              texttableentry: 'RoomTwelveCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThirteenProperty',
              isRead: 'true',
              interval: '1920',
              texttableentry: 'RoomThirteenProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomThirteenSetpoints',
              isRead: 'true',
              interval: '1921',
              texttableentry: 'RoomThirteenSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomThirteenCurrentValues',
              isRead: 'true',
              interval: '1922',
              texttableentry: 'RoomThirteenCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourteenProperty',
              isRead: 'true',
              interval: '1923',
              texttableentry: 'RoomFourteenProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomFourteenSetpoints',
              isRead: 'true',
              interval: '1924',
              texttableentry: 'RoomFourteenSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomFourteenCurrentValues',
              isRead: 'true',
              interval: '1925',
              texttableentry: 'RoomFourteenCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFifteenProperty',
              isRead: 'true',
              interval: '1926',
              texttableentry: 'RoomFifteenProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomFifteenSetpoints',
              isRead: 'true',
              interval: '1927',
              texttableentry: 'RoomFifteenSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomFifteenCurrentValues',
              isRead: 'true',
              interval: '1928',
              texttableentry: 'RoomFifteenCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixteenProperty',
              isRead: 'true',
              interval: '1929',
              texttableentry: 'RoomSixteenProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomSixteenSetpoints',
              isRead: 'true',
              interval: '1930',
              texttableentry: 'RoomSixteenSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomSixteenCurrentValues',
              isRead: 'true',
              interval: '1931',
              texttableentry: 'RoomSixteenCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSeventeenProperty',
              isRead: 'true',
              interval: '1932',
              texttableentry: 'RoomSeventeenProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomSeventeenSetpoints',
              isRead: 'true',
              interval: '1933',
              texttableentry: 'RoomSeventeenSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomSeventeenCurrentValues',
              isRead: 'true',
              interval: '1934',
              texttableentry: 'RoomSeventeenCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEighteenProperty',
              isRead: 'true',
              interval: '1935',
              texttableentry: 'RoomEighteenProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomEighteenSetpoints',
              isRead: 'true',
              interval: '1936',
              texttableentry: 'RoomEighteenSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomEighteenCurrentValues',
              isRead: 'true',
              interval: '1937',
              texttableentry: 'RoomEighteenCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineteenProperty',
              isRead: 'true',
              interval: '1938',
              texttableentry: 'RoomNineteenProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomNineteenSetpoints',
              isRead: 'true',
              interval: '1939',
              texttableentry: 'RoomNineteenSetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomNineteenCurrentValues',
              isRead: 'true',
              interval: '1940',
              texttableentry: 'RoomNineteenCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwentyProperty',
              isRead: 'true',
              interval: '1941',
              texttableentry: 'RoomTwentyProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomTwentySetpoints',
              isRead: 'true',
              interval: '1942',
              texttableentry: 'RoomTwentySetpoints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomTwentyCurrentValues',
              isRead: 'true',
              interval: '1943',
              texttableentry: 'RoomTwentyCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomOneTimeScheduleMonday',
              isRead: 'true',
              interval: '1944',
              texttableentry: 'RoomOneTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomOneTimeScheduleTuesday',
              isRead: 'true',
              interval: '1945',
              texttableentry: 'RoomOneTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomOneTimeScheduleWednesday',
              isRead: 'true',
              interval: '1946',
              texttableentry: 'RoomOneTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomOneTimeScheduleThursday',
              isRead: 'true',
              interval: '1947',
              texttableentry: 'RoomOneTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomOneTimeScheduleFriday',
              isRead: 'true',
              interval: '1948',
              texttableentry: 'RoomOneTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomOneTimeScheduleSaturday',
              isRead: 'true',
              interval: '1949',
              texttableentry: 'RoomOneTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomOneTimeScheduleSunday',
              isRead: 'true',
              interval: '1950',
              texttableentry: 'RoomOneTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwoTimeScheduleMonday',
              isRead: 'true',
              interval: '1951',
              texttableentry: 'RoomTwoTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwoTimeScheduleTuesday',
              isRead: 'true',
              interval: '1952',
              texttableentry: 'RoomTwoTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwoTimeScheduleWednesday',
              isRead: 'true',
              interval: '1953',
              texttableentry: 'RoomTwoTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwoTimeScheduleThursday',
              isRead: 'true',
              interval: '1954',
              texttableentry: 'RoomTwoTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwoTimeScheduleFriday',
              isRead: 'true',
              interval: '1955',
              texttableentry: 'RoomTwoTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwoTimeScheduleSaturday',
              isRead: 'true',
              interval: '1956',
              texttableentry: 'RoomTwoTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwoTimeScheduleSunday',
              isRead: 'true',
              interval: '1957',
              texttableentry: 'RoomTwoTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThreeTimeScheduleMonday',
              isRead: 'true',
              interval: '1958',
              texttableentry: 'RoomThreeTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThreeTimeScheduleTuesday',
              isRead: 'true',
              interval: '1959',
              texttableentry: 'RoomThreeTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThreeTimeScheduleWednesday',
              isRead: 'true',
              interval: '1960',
              texttableentry: 'RoomThreeTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThreeTimeScheduleThursday',
              isRead: 'true',
              interval: '1961',
              texttableentry: 'RoomThreeTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThreeTimeScheduleFriday',
              isRead: 'true',
              interval: '1962',
              texttableentry: 'RoomThreeTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThreeTimeScheduleSaturday',
              isRead: 'true',
              interval: '1963',
              texttableentry: 'RoomThreeTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThreeTimeScheduleSunday',
              isRead: 'true',
              interval: '1964',
              texttableentry: 'RoomThreeTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourTimeScheduleMonday',
              isRead: 'true',
              interval: '1965',
              texttableentry: 'RoomFourTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourTimeScheduleTuesday',
              isRead: 'true',
              interval: '1966',
              texttableentry: 'RoomFourTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourTimeScheduleWednesday',
              isRead: 'true',
              interval: '1967',
              texttableentry: 'RoomFourTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourTimeScheduleThursday',
              isRead: 'true',
              interval: '1968',
              texttableentry: 'RoomFourTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourTimeScheduleFriday',
              isRead: 'true',
              interval: '1969',
              texttableentry: 'RoomFourTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourTimeScheduleSaturday',
              isRead: 'true',
              interval: '1970',
              texttableentry: 'RoomFourTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourTimeScheduleSunday',
              isRead: 'true',
              interval: '1971',
              texttableentry: 'RoomFourTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFiveTimeScheduleMonday',
              isRead: 'true',
              interval: '1972',
              texttableentry: 'RoomFiveTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFiveTimeScheduleTuesday',
              isRead: 'true',
              interval: '1973',
              texttableentry: 'RoomFiveTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFiveTimeScheduleWednesday',
              isRead: 'true',
              interval: '1974',
              texttableentry: 'RoomFiveTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFiveTimeScheduleThursday',
              isRead: 'true',
              interval: '1975',
              texttableentry: 'RoomFiveTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFiveTimeScheduleFriday',
              isRead: 'true',
              interval: '1976',
              texttableentry: 'RoomFiveTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFiveTimeScheduleSaturday',
              isRead: 'true',
              interval: '1977',
              texttableentry: 'RoomFiveTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFiveTimeScheduleSunday',
              isRead: 'true',
              interval: '1978',
              texttableentry: 'RoomFiveTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixTimeScheduleMonday',
              isRead: 'true',
              interval: '1979',
              texttableentry: 'RoomSixTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixTimeScheduleTuesday',
              isRead: 'true',
              interval: '1980',
              texttableentry: 'RoomSixTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixTimeScheduleWednesday',
              isRead: 'true',
              interval: '1981',
              texttableentry: 'RoomSixTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixTimeScheduleThursday',
              isRead: 'true',
              interval: '1982',
              texttableentry: 'RoomSixTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixTimeScheduleFriday',
              isRead: 'true',
              interval: '1983',
              texttableentry: 'RoomSixTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixTimeScheduleSaturday',
              isRead: 'true',
              interval: '1984',
              texttableentry: 'RoomSixTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixTimeScheduleSunday',
              isRead: 'true',
              interval: '1985',
              texttableentry: 'RoomSixTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSevenTimeScheduleMonday',
              isRead: 'true',
              interval: '1986',
              texttableentry: 'RoomSevenTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSevenTimeScheduleTuesday',
              isRead: 'true',
              interval: '1987',
              texttableentry: 'RoomSevenTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSevenTimeScheduleWednesday',
              isRead: 'true',
              interval: '1988',
              texttableentry: 'RoomSevenTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSevenTimeScheduleThursday',
              isRead: 'true',
              interval: '1989',
              texttableentry: 'RoomSevenTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSevenTimeScheduleFriday',
              isRead: 'true',
              interval: '1990',
              texttableentry: 'RoomSevenTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSevenTimeScheduleSaturday',
              isRead: 'true',
              interval: '1991',
              texttableentry: 'RoomSevenTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSevenTimeScheduleSunday',
              isRead: 'true',
              interval: '1992',
              texttableentry: 'RoomSevenTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEightTimeScheduleMonday',
              isRead: 'true',
              interval: '1993',
              texttableentry: 'RoomEightTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEightTimeScheduleTuesday',
              isRead: 'true',
              interval: '1994',
              texttableentry: 'RoomEightTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEightTimeScheduleWednesday',
              isRead: 'true',
              interval: '1995',
              texttableentry: 'RoomEightTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEightTimeScheduleThursday',
              isRead: 'true',
              interval: '1996',
              texttableentry: 'RoomEightTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEightTimeScheduleFriday',
              isRead: 'true',
              interval: '1997',
              texttableentry: 'RoomEightTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEightTimeScheduleSaturday',
              isRead: 'true',
              interval: '1998',
              texttableentry: 'RoomEightTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEightTimeScheduleSunday',
              isRead: 'true',
              interval: '1999',
              texttableentry: 'RoomEightTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineTimeScheduleMonday',
              isRead: 'true',
              interval: '2000',
              texttableentry: 'RoomNineTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineTimeScheduleTuesday',
              isRead: 'true',
              interval: '2001',
              texttableentry: 'RoomNineTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineTimeScheduleWednesday',
              isRead: 'true',
              interval: '2002',
              texttableentry: 'RoomNineTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineTimeScheduleThursday',
              isRead: 'true',
              interval: '2003',
              texttableentry: 'RoomNineTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineTimeScheduleFriday',
              isRead: 'true',
              interval: '2004',
              texttableentry: 'RoomNineTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineTimeScheduleSaturday',
              isRead: 'true',
              interval: '2005',
              texttableentry: 'RoomNineTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineTimeScheduleSunday',
              isRead: 'true',
              interval: '2006',
              texttableentry: 'RoomNineTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTenTimeScheduleMonday',
              isRead: 'true',
              interval: '2007',
              texttableentry: 'RoomTenTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTenTimeScheduleTuesday',
              isRead: 'true',
              interval: '2008',
              texttableentry: 'RoomTenTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTenTimeScheduleWednesday',
              isRead: 'true',
              interval: '2009',
              texttableentry: 'RoomTenTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTenTimeScheduleThursday',
              isRead: 'true',
              interval: '2010',
              texttableentry: 'RoomTenTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTenTimeScheduleFriday',
              isRead: 'true',
              interval: '2011',
              texttableentry: 'RoomTenTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTenTimeScheduleSaturday',
              isRead: 'true',
              interval: '2012',
              texttableentry: 'RoomTenTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTenTimeScheduleSunday',
              isRead: 'true',
              interval: '2013',
              texttableentry: 'RoomTenTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomElevenTimeScheduleMonday',
              isRead: 'true',
              interval: '2014',
              texttableentry: 'RoomElevenTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomElevenTimeScheduleTuesday',
              isRead: 'true',
              interval: '2015',
              texttableentry: 'RoomElevenTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomElevenTimeScheduleWednesday',
              isRead: 'true',
              interval: '2016',
              texttableentry: 'RoomElevenTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomElevenTimeScheduleThursday',
              isRead: 'true',
              interval: '2017',
              texttableentry: 'RoomElevenTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomElevenTimeScheduleFriday',
              isRead: 'true',
              interval: '2018',
              texttableentry: 'RoomElevenTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomElevenTimeScheduleSaturday',
              isRead: 'true',
              interval: '2019',
              texttableentry: 'RoomElevenTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomElevenTimeScheduleSunday',
              isRead: 'true',
              interval: '2020',
              texttableentry: 'RoomElevenTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwelveTimeScheduleMonday',
              isRead: 'true',
              interval: '2021',
              texttableentry: 'RoomTwelveTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwelveTimeScheduleTuesday',
              isRead: 'true',
              interval: '2022',
              texttableentry: 'RoomTwelveTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwelveTimeScheduleWednesday',
              isRead: 'true',
              interval: '2023',
              texttableentry: 'RoomTwelveTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwelveTimeScheduleThursday',
              isRead: 'true',
              interval: '2024',
              texttableentry: 'RoomTwelveTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwelveTimeScheduleFriday',
              isRead: 'true',
              interval: '2025',
              texttableentry: 'RoomTwelveTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwelveTimeScheduleSaturday',
              isRead: 'true',
              interval: '2026',
              texttableentry: 'RoomTwelveTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwelveTimeScheduleSunday',
              isRead: 'true',
              interval: '2027',
              texttableentry: 'RoomTwelveTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThirteenTimeScheduleMonday',
              isRead: 'true',
              interval: '2028',
              texttableentry: 'RoomThirteenTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThirteenTimeScheduleTuesday',
              isRead: 'true',
              interval: '2029',
              texttableentry: 'RoomThirteenTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThirteenTimeScheduleWednesday',
              isRead: 'true',
              interval: '2030',
              texttableentry: 'RoomThirteenTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThirteenTimeScheduleThursday',
              isRead: 'true',
              interval: '2031',
              texttableentry: 'RoomThirteenTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThirteenTimeScheduleFriday',
              isRead: 'true',
              interval: '2032',
              texttableentry: 'RoomThirteenTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThirteenTimeScheduleSaturday',
              isRead: 'true',
              interval: '2033',
              texttableentry: 'RoomThirteenTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomThirteenTimeScheduleSunday',
              isRead: 'true',
              interval: '2034',
              texttableentry: 'RoomThirteenTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourteenTimeScheduleMonday',
              isRead: 'true',
              interval: '2035',
              texttableentry: 'RoomFourteenTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourteenTimeScheduleTuesday',
              isRead: 'true',
              interval: '2036',
              texttableentry: 'RoomFourteenTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourteenTimeScheduleWednesday',
              isRead: 'true',
              interval: '2037',
              texttableentry: 'RoomFourteenTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourteenTimeScheduleThursday',
              isRead: 'true',
              interval: '2038',
              texttableentry: 'RoomFourteenTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourteenTimeScheduleFriday',
              isRead: 'true',
              interval: '2039',
              texttableentry: 'RoomFourteenTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourteenTimeScheduleSaturday',
              isRead: 'true',
              interval: '2040',
              texttableentry: 'RoomFourteenTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFourteenTimeScheduleSunday',
              isRead: 'true',
              interval: '2041',
              texttableentry: 'RoomFourteenTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFifteenTimeScheduleMonday',
              isRead: 'true',
              interval: '2042',
              texttableentry: 'RoomFifteenTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFifteenTimeScheduleTuesday',
              isRead: 'true',
              interval: '2043',
              texttableentry: 'RoomFifteenTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFifteenTimeScheduleWednesday',
              isRead: 'true',
              interval: '2044',
              texttableentry: 'RoomFifteenTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFifteenTimeScheduleThursday',
              isRead: 'true',
              interval: '2045',
              texttableentry: 'RoomFifteenTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFifteenTimeScheduleFriday',
              isRead: 'true',
              interval: '2046',
              texttableentry: 'RoomFifteenTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFifteenTimeScheduleSaturday',
              isRead: 'true',
              interval: '2047',
              texttableentry: 'RoomFifteenTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomFifteenTimeScheduleSunday',
              isRead: 'true',
              interval: '2048',
              texttableentry: 'RoomFifteenTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixteenTimeScheduleMonday',
              isRead: 'true',
              interval: '2049',
              texttableentry: 'RoomSixteenTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixteenTimeScheduleTuesday',
              isRead: 'true',
              interval: '2050',
              texttableentry: 'RoomSixteenTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixteenTimeScheduleWednesday',
              isRead: 'true',
              interval: '2051',
              texttableentry: 'RoomSixteenTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixteenTimeScheduleThursday',
              isRead: 'true',
              interval: '2052',
              texttableentry: 'RoomSixteenTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixteenTimeScheduleFriday',
              isRead: 'true',
              interval: '2053',
              texttableentry: 'RoomSixteenTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixteenTimeScheduleSaturday',
              isRead: 'true',
              interval: '2054',
              texttableentry: 'RoomSixteenTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSixteenTimeScheduleSunday',
              isRead: 'true',
              interval: '2055',
              texttableentry: 'RoomSixteenTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSeventeenTimeScheduleMonday',
              isRead: 'true',
              interval: '2056',
              texttableentry: 'RoomSeventeenTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSeventeenTimeScheduleTuesday',
              isRead: 'true',
              interval: '2057',
              texttableentry: 'RoomSeventeenTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSeventeenTimeScheduleWednesday',
              isRead: 'true',
              interval: '2058',
              texttableentry: 'RoomSeventeenTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSeventeenTimeScheduleThursday',
              isRead: 'true',
              interval: '2059',
              texttableentry: 'RoomSeventeenTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSeventeenTimeScheduleFriday',
              isRead: 'true',
              interval: '2060',
              texttableentry: 'RoomSeventeenTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSeventeenTimeScheduleSaturday',
              isRead: 'true',
              interval: '2061',
              texttableentry: 'RoomSeventeenTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomSeventeenTimeScheduleSunday',
              isRead: 'true',
              interval: '2062',
              texttableentry: 'RoomSeventeenTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEighteenTimeScheduleMonday',
              isRead: 'true',
              interval: '2063',
              texttableentry: 'RoomEighteenTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEighteenTimeScheduleTuesday',
              isRead: 'true',
              interval: '2064',
              texttableentry: 'RoomEighteenTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEighteenTimeScheduleWednesday',
              isRead: 'true',
              interval: '2065',
              texttableentry: 'RoomEighteenTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEighteenTimeScheduleThursday',
              isRead: 'true',
              interval: '2066',
              texttableentry: 'RoomEighteenTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEighteenTimeScheduleFriday',
              isRead: 'true',
              interval: '2067',
              texttableentry: 'RoomEighteenTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEighteenTimeScheduleSaturday',
              isRead: 'true',
              interval: '2068',
              texttableentry: 'RoomEighteenTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomEighteenTimeScheduleSunday',
              isRead: 'true',
              interval: '2069',
              texttableentry: 'RoomEighteenTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineteenTimeScheduleMonday',
              isRead: 'true',
              interval: '2070',
              texttableentry: 'RoomNineteenTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineteenTimeScheduleTuesday',
              isRead: 'true',
              interval: '2071',
              texttableentry: 'RoomNineteenTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineteenTimeScheduleWednesday',
              isRead: 'true',
              interval: '2072',
              texttableentry: 'RoomNineteenTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineteenTimeScheduleThursday',
              isRead: 'true',
              interval: '2073',
              texttableentry: 'RoomNineteenTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineteenTimeScheduleFriday',
              isRead: 'true',
              interval: '2074',
              texttableentry: 'RoomNineteenTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineteenTimeScheduleSaturday',
              isRead: 'true',
              interval: '2075',
              texttableentry: 'RoomNineteenTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomNineteenTimeScheduleSunday',
              isRead: 'true',
              interval: '2076',
              texttableentry: 'RoomNineteenTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwentyTimeScheduleMonday',
              isRead: 'true',
              interval: '2077',
              texttableentry: 'RoomTwentyTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwentyTimeScheduleTuesday',
              isRead: 'true',
              interval: '2078',
              texttableentry: 'RoomTwentyTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwentyTimeScheduleWednesday',
              isRead: 'true',
              interval: '2079',
              texttableentry: 'RoomTwentyTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwentyTimeScheduleThursday',
              isRead: 'true',
              interval: '2080',
              texttableentry: 'RoomTwentyTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwentyTimeScheduleFriday',
              isRead: 'true',
              interval: '2081',
              texttableentry: 'RoomTwentyTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwentyTimeScheduleSaturday',
              isRead: 'true',
              interval: '2082',
              texttableentry: 'RoomTwentyTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTwentyTimeScheduleSunday',
              isRead: 'true',
              interval: '2083',
              texttableentry: 'RoomTwentyTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeOneDeviceProperty',
              isRead: 'true',
              interval: '2084',
              texttableentry: 'ZigBeeOneDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeOneDeviceSetpoint',
              isRead: 'true',
              interval: '2085',
              texttableentry: 'ZigBeeOneDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeOneDeviceCurrentValues',
              isRead: 'true',
              interval: '2086',
              texttableentry: 'ZigBeeOneDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwoDeviceProperty',
              isRead: 'true',
              interval: '2087',
              texttableentry: 'ZigBeeTwoDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwoDeviceSetpoint',
              isRead: 'true',
              interval: '2088',
              texttableentry: 'ZigBeeTwoDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwoDeviceCurrentValues',
              isRead: 'true',
              interval: '2089',
              texttableentry: 'ZigBeeTwoDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThreeDeviceProperty',
              isRead: 'true',
              interval: '2090',
              texttableentry: 'ZigBeeThreeDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThreeDeviceSetpoint',
              isRead: 'true',
              interval: '2091',
              texttableentry: 'ZigBeeThreeDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThreeDeviceCurrentValues',
              isRead: 'true',
              interval: '2092',
              texttableentry: 'ZigBeeThreeDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourDeviceProperty',
              isRead: 'true',
              interval: '2093',
              texttableentry: 'ZigBeeFourDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourDeviceSetpoint',
              isRead: 'true',
              interval: '2094',
              texttableentry: 'ZigBeeFourDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourDeviceCurrentValues',
              isRead: 'true',
              interval: '2095',
              texttableentry: 'ZigBeeFourDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFiveDeviceProperty',
              isRead: 'true',
              interval: '2096',
              texttableentry: 'ZigBeeFiveDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFiveDeviceSetpoint',
              isRead: 'true',
              interval: '2097',
              texttableentry: 'ZigBeeFiveDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFiveDeviceCurrentValues',
              isRead: 'true',
              interval: '2098',
              texttableentry: 'ZigBeeFiveDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixDeviceProperty',
              isRead: 'true',
              interval: '2099',
              texttableentry: 'ZigBeeSixDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixDeviceSetpoint',
              isRead: 'true',
              interval: '2100',
              texttableentry: 'ZigBeeSixDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixDeviceCurrentValues',
              isRead: 'true',
              interval: '2101',
              texttableentry: 'ZigBeeSixDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSevenDeviceProperty',
              isRead: 'true',
              interval: '2102',
              texttableentry: 'ZigBeeSevenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSevenDeviceSetpoint',
              isRead: 'true',
              interval: '2103',
              texttableentry: 'ZigBeeSevenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSevenDeviceCurrentValues',
              isRead: 'true',
              interval: '2104',
              texttableentry: 'ZigBeeSevenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEightDeviceProperty',
              isRead: 'true',
              interval: '2105',
              texttableentry: 'ZigBeeEightDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEightDeviceSetpoint',
              isRead: 'true',
              interval: '2106',
              texttableentry: 'ZigBeeEightDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEightDeviceCurrentValues',
              isRead: 'true',
              interval: '2107',
              texttableentry: 'ZigBeeEightDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineDeviceProperty',
              isRead: 'true',
              interval: '2108',
              texttableentry: 'ZigBeeNineDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineDeviceSetpoint',
              isRead: 'true',
              interval: '2109',
              texttableentry: 'ZigBeeNineDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineDeviceCurrentValues',
              isRead: 'true',
              interval: '2110',
              texttableentry: 'ZigBeeNineDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTenDeviceProperty',
              isRead: 'true',
              interval: '2111',
              texttableentry: 'ZigBeeTenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTenDeviceSetpoint',
              isRead: 'true',
              interval: '2112',
              texttableentry: 'ZigBeeTenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTenDeviceCurrentValues',
              isRead: 'true',
              interval: '2113',
              texttableentry: 'ZigBeeTenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeElevenDeviceProperty',
              isRead: 'true',
              interval: '2114',
              texttableentry: 'ZigBeeElevenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeElevenDeviceSetpoint',
              isRead: 'true',
              interval: '2115',
              texttableentry: 'ZigBeeElevenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeElevenDeviceCurrentValues',
              isRead: 'true',
              interval: '2116',
              texttableentry: 'ZigBeeElevenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwelveDeviceProperty',
              isRead: 'true',
              interval: '2117',
              texttableentry: 'ZigBeeTwelveDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwelveDeviceSetpoint',
              isRead: 'true',
              interval: '2118',
              texttableentry: 'ZigBeeTwelveDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwelveDeviceCurrentValues',
              isRead: 'true',
              interval: '2119',
              texttableentry: 'ZigBeeTwelveDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirteenDeviceProperty',
              isRead: 'true',
              interval: '2120',
              texttableentry: 'ZigBeeThirteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirteenDeviceSetpoint',
              isRead: 'true',
              interval: '2121',
              texttableentry: 'ZigBeeThirteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2122',
              texttableentry: 'ZigBeeThirteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourteenDeviceProperty',
              isRead: 'true',
              interval: '2123',
              texttableentry: 'ZigBeeFourteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourteenDeviceSetpoint',
              isRead: 'true',
              interval: '2124',
              texttableentry: 'ZigBeeFourteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2125',
              texttableentry: 'ZigBeeFourteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFifteenDeviceProperty',
              isRead: 'true',
              interval: '2126',
              texttableentry: 'ZigBeeFifteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFifteenDeviceSetpoint',
              isRead: 'true',
              interval: '2127',
              texttableentry: 'ZigBeeFifteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFifteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2128',
              texttableentry: 'ZigBeeFifteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixteenDeviceProperty',
              isRead: 'true',
              interval: '2129',
              texttableentry: 'ZigBeeSixteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixteenDeviceSetpoint',
              isRead: 'true',
              interval: '2130',
              texttableentry: 'ZigBeeSixteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2131',
              texttableentry: 'ZigBeeSixteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSeventeenDeviceProperty',
              isRead: 'true',
              interval: '2132',
              texttableentry: 'ZigBeeSeventeenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSeventeenDeviceSetpoint',
              isRead: 'true',
              interval: '2133',
              texttableentry: 'ZigBeeSeventeenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSeventeenDeviceCurrentValues',
              isRead: 'true',
              interval: '2134',
              texttableentry: 'ZigBeeSeventeenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEighteenDeviceProperty',
              isRead: 'true',
              interval: '2135',
              texttableentry: 'ZigBeeEighteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEighteenDeviceSetpoint',
              isRead: 'true',
              interval: '2136',
              texttableentry: 'ZigBeeEighteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEighteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2137',
              texttableentry: 'ZigBeeEighteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineteenDeviceProperty',
              isRead: 'true',
              interval: '2138',
              texttableentry: 'ZigBeeNineteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineteenDeviceSetpoint',
              isRead: 'true',
              interval: '2139',
              texttableentry: 'ZigBeeNineteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2140',
              texttableentry: 'ZigBeeNineteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyDeviceProperty',
              isRead: 'true',
              interval: '2141',
              texttableentry: 'ZigBeeTwentyDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyDeviceSetpoint',
              isRead: 'true',
              interval: '2142',
              texttableentry: 'ZigBeeTwentyDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyDeviceCurrentValues',
              isRead: 'true',
              interval: '2143',
              texttableentry: 'ZigBeeTwentyDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingAcActiveCurrent',
              isRead: 'true',
              interval: '2144',
              texttableentry: 'PointOfCommonCouplingAcActiveCurrent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectTopology',
              isRead: 'true',
              interval: '2145',
              texttableentry: 'ObjectTopology',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentOneProperty',
              isRead: 'true',
              interval: '2146',
              texttableentry: 'ZigBeeApartmentOneProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentOneTopology',
              isRead: 'true',
              interval: '2147',
              texttableentry: 'ZigBeeApartmentOneTopology',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentOnePreConfiguredList',
              isRead: 'true',
              interval: '2148',
              texttableentry: 'ZigBeeApartmentOnePreConfiguredList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentTwoProperty',
              isRead: 'true',
              interval: '2149',
              texttableentry: 'ZigBeeApartmentTwoProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentTwoTopology',
              isRead: 'true',
              interval: '2150',
              texttableentry: 'ZigBeeApartmentTwoTopology',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentTwoPreConfiguredList',
              isRead: 'true',
              interval: '2151',
              texttableentry: 'ZigBeeApartmentTwoPreConfiguredList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentThreeProperty',
              isRead: 'true',
              interval: '2152',
              texttableentry: 'ZigBeeApartmentThreeProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentThreeTopology',
              isRead: 'true',
              interval: '2153',
              texttableentry: 'ZigBeeApartmentThreeTopology',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentThreePreConfiguredList',
              isRead: 'true',
              interval: '2154',
              texttableentry: 'ZigBeeApartmentThreePreConfiguredList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentFourProperty',
              isRead: 'true',
              interval: '2155',
              texttableentry: 'ZigBeeApartmentFourProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentFourTopology',
              isRead: 'true',
              interval: '2156',
              texttableentry: 'ZigBeeApartmentFourTopology',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentFourPreConfiguredList',
              isRead: 'true',
              interval: '2157',
              texttableentry: 'ZigBeeApartmentFourPreConfiguredList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ActivatedFeatures',
              isRead: 'true',
              interval: '2158',
              texttableentry: 'ActivatedFeatures',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneCurrentValues',
              isRead: 'true',
              interval: '2159',
              texttableentry: 'ApartmentOneCurrentValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentTwoCurrentValues',
              isRead: 'true',
              interval: '2160',
              texttableentry: 'ApartmentTwoCurrentValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentThreeCurrentValues',
              isRead: 'true',
              interval: '2161',
              texttableentry: 'ApartmentThreeCurrentValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentFourCurrentValues',
              isRead: 'true',
              interval: '2162',
              texttableentry: 'ApartmentFourCurrentValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedRoomOneMeasurements',
              isRead: 'true',
              interval: '2163',
              texttableentry: 'TimeSeriesRecordedRoomOneMeasurements',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputSixValue',
              isRead: 'true',
              interval: '2164',
              texttableentry: 'DeviceDigitalInputSixValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DevicePwmOutputThreeValue',
              isRead: 'true',
              interval: '2165',
              texttableentry: 'DevicePwmOutputThreeValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2166',
              texttableentry: 'MixerOneCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2167',
              texttableentry: 'MixerTwoCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2168',
              texttableentry: 'MixerThreeCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2169',
              texttableentry: 'MixerFourCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2170',
              texttableentry: 'MixerFiveCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2171',
              texttableentry: 'MixerSixCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2172',
              texttableentry: 'MixerSevenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2173',
              texttableentry: 'MixerEightCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2174',
              texttableentry: 'MixerNineCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2175',
              texttableentry: 'MixerTenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2176',
              texttableentry: 'MixerElevenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2177',
              texttableentry: 'MixerTwelveCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2178',
              texttableentry: 'MixerThirteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2179',
              texttableentry: 'MixerFourteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2180',
              texttableentry: 'MixerFifteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2181',
              texttableentry: 'MixerSixteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupportedApartmentFeatures',
              isRead: 'true',
              interval: '2182',
              texttableentry: 'SupportedApartmentFeatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActivatedApartmentFeatures',
              isRead: 'true',
              interval: '2183',
              texttableentry: 'ActivatedApartmentFeatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BackupBoxTest',
              isRead: 'true',
              interval: '2184',
              texttableentry: 'BackupBoxTest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryStateOfChargeHistogram',
              isRead: 'true',
              interval: '2185',
              texttableentry: 'BatteryStateOfChargeHistogram',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryAmbientTemperatureHistogram',
              isRead: 'true',
              interval: '2186',
              texttableentry: 'BatteryAmbientTemperatureHistogram',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryTemperatureHistogram',
              isRead: 'true',
              interval: '2187',
              texttableentry: 'BatteryTemperatureHistogram',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingSetActivePowerTotal',
              isRead: 'true',
              interval: '2188',
              texttableentry: 'PointOfCommonCouplingSetActivePowerTotal',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListTwo',
              isRead: 'true',
              interval: '2189',
              texttableentry: 'EebusDeviceListTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListThree',
              isRead: 'true',
              interval: '2190',
              texttableentry: 'EebusDeviceListThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListFour',
              isRead: 'true',
              interval: '2191',
              texttableentry: 'EebusDeviceListFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListFive',
              isRead: 'true',
              interval: '2192',
              texttableentry: 'EebusDeviceListFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelTwoTimeScheduleMonday',
              isRead: 'true',
              interval: '2193',
              texttableentry: 'ApartmentOneSupplyChannelTwoTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelTwoTimeScheduleTuesday',
              isRead: 'true',
              interval: '2194',
              texttableentry: 'ApartmentOneSupplyChannelTwoTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelTwoTimeScheduleWednesday',
              isRead: 'true',
              interval: '2195',
              texttableentry: 'ApartmentOneSupplyChannelTwoTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelTwoTimeScheduleThursday',
              isRead: 'true',
              interval: '2196',
              texttableentry: 'ApartmentOneSupplyChannelTwoTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelTwoTimeScheduleFriday',
              isRead: 'true',
              interval: '2197',
              texttableentry: 'ApartmentOneSupplyChannelTwoTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelTwoTimeScheduleSaturday',
              isRead: 'true',
              interval: '2198',
              texttableentry: 'ApartmentOneSupplyChannelTwoTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelTwoTimeScheduleSunday',
              isRead: 'true',
              interval: '2199',
              texttableentry: 'ApartmentOneSupplyChannelTwoTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelThreeTimeScheduleMonday',
              isRead: 'true',
              interval: '2200',
              texttableentry: 'ApartmentOneSupplyChannelThreeTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelThreeTimeScheduleTuesday',
              isRead: 'true',
              interval: '2201',
              texttableentry: 'ApartmentOneSupplyChannelThreeTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelThreeTimeScheduleWednesday',
              isRead: 'true',
              interval: '2202',
              texttableentry: 'ApartmentOneSupplyChannelThreeTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelThreeTimeScheduleThursday',
              isRead: 'true',
              interval: '2203',
              texttableentry: 'ApartmentOneSupplyChannelThreeTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelThreeTimeScheduleFriday',
              isRead: 'true',
              interval: '2204',
              texttableentry: 'ApartmentOneSupplyChannelThreeTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelThreeTimeScheduleSaturday',
              isRead: 'true',
              interval: '2205',
              texttableentry: 'ApartmentOneSupplyChannelThreeTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelThreeTimeScheduleSunday',
              isRead: 'true',
              interval: '2206',
              texttableentry: 'ApartmentOneSupplyChannelThreeTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelFourTimeScheduleMonday',
              isRead: 'true',
              interval: '2207',
              texttableentry: 'ApartmentOneSupplyChannelFourTimeScheduleMonday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelFourTimeScheduleTuesday',
              isRead: 'true',
              interval: '2208',
              texttableentry: 'ApartmentOneSupplyChannelFourTimeScheduleTuesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelFourTimeScheduleWednesday',
              isRead: 'true',
              interval: '2209',
              texttableentry: 'ApartmentOneSupplyChannelFourTimeScheduleWednesday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelFourTimeScheduleThursday',
              isRead: 'true',
              interval: '2210',
              texttableentry: 'ApartmentOneSupplyChannelFourTimeScheduleThursday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelFourTimeScheduleFriday',
              isRead: 'true',
              interval: '2211',
              texttableentry: 'ApartmentOneSupplyChannelFourTimeScheduleFriday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelFourTimeScheduleSaturday',
              isRead: 'true',
              interval: '2212',
              texttableentry: 'ApartmentOneSupplyChannelFourTimeScheduleSaturday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApartmentOneSupplyChannelFourTimeScheduleSunday',
              isRead: 'true',
              interval: '2213',
              texttableentry: 'ApartmentOneSupplyChannelFourTimeScheduleSunday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BackupBoxConfiguration',
              isRead: 'true',
              interval: '2214',
              texttableentry: 'BackupBoxConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterActivationControl',
              isRead: 'true',
              interval: '2215',
              texttableentry: 'DomesticHotWaterActivationControl',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterComfortModeActivation',
              isRead: 'true',
              interval: '2216',
              texttableentry: 'DomesticHotWaterComfortModeActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InputDemandSideManagementlReceiver',
              isRead: 'true',
              interval: '2217',
              texttableentry: 'InputDemandSideManagementlReceiver',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RemoteLimitValueDemandSideManagement',
              isRead: 'true',
              interval: '2218',
              texttableentry: 'RemoteLimitValueDemandSideManagement',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryCalibration',
              isRead: 'true',
              interval: '2219',
              texttableentry: 'BatteryCalibration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryReactivePowerMode',
              isRead: 'true',
              interval: '2220',
              texttableentry: 'BatteryReactivePowerMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryReactivePowerFixCosinusPhi',
              isRead: 'true',
              interval: '2221',
              texttableentry: 'BatteryReactivePowerFixCosinusPhi',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryReactivePower',
              isRead: 'true',
              interval: '2222',
              texttableentry: 'BatteryReactivePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryReactivePowerCosinusPhi',
              isRead: 'true',
              interval: '2223',
              texttableentry: 'BatteryReactivePowerCosinusPhi',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicsActivePowerLimitation',
              isRead: 'true',
              interval: '2224',
              texttableentry: 'PhotovoltaicsActivePowerLimitation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricEnergyStorageSetpoint',
              isRead: 'true',
              interval: '2225',
              texttableentry: 'ElectricEnergyStorageSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricEnergyStorageMaximum',
              isRead: 'true',
              interval: '2226',
              texttableentry: 'ElectricEnergyStorageMaximum',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OpenThermStatus',
              isRead: 'true',
              interval: '2227',
              texttableentry: 'OpenThermStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GasAirRatioSystemWithMassFlowSensor',
              isRead: 'true',
              interval: '2228',
              texttableentry: 'GasAirRatioSystemWithMassFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalOneFunction',
              isRead: 'true',
              interval: '2229',
              texttableentry: 'ThermostatTerminalOneFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalTwoFunction',
              isRead: 'true',
              interval: '2230',
              texttableentry: 'ThermostatTerminalTwoFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalThreeFunction',
              isRead: 'true',
              interval: '2231',
              texttableentry: 'ThermostatTerminalThreeFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_StartUpdatePersistentStorage',
              isRead: 'true',
              interval: '2232',
              texttableentry: 'StartUpdatePersistentStorage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentStorageStatus',
              isRead: 'true',
              interval: '2233',
              texttableentry: 'PersistentStorageStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormOne',
              isRead: 'true',
              interval: '2234',
              texttableentry: 'PowerGridCodeSettingsNormOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeSystemConfiguration',
              isRead: 'true',
              interval: '2235',
              texttableentry: 'CascadeSystemConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceSetpoint',
              isRead: 'true',
              interval: '2236',
              texttableentry: 'CascadeDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatus',
              isRead: 'true',
              interval: '2237',
              texttableentry: 'CascadeDeviceStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RemoteWeatherServiceForecast',
              isRead: 'true',
              interval: '2238',
              texttableentry: 'RemoteWeatherServiceForecast',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricEnergyStorageControlMode',
              isRead: 'true',
              interval: '2239',
              texttableentry: 'ElectricEnergyStorageControlMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryTemperatureSensor',
              isRead: 'true',
              interval: '2240',
              texttableentry: 'BatteryTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureSensorSource',
              isRead: 'true',
              interval: '2241',
              texttableentry: 'OutsideTemperatureSensorSource',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormTwo',
              isRead: 'true',
              interval: '2242',
              texttableentry: 'PowerGridCodeSettingsNormTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormThree',
              isRead: 'true',
              interval: '2243',
              texttableentry: 'PowerGridCodeSettingsNormThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormFour',
              isRead: 'true',
              interval: '2244',
              texttableentry: 'PowerGridCodeSettingsNormFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormFive',
              isRead: 'true',
              interval: '2245',
              texttableentry: 'PowerGridCodeSettingsNormFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FixReactivePowerIn',
              isRead: 'true',
              interval: '2246',
              texttableentry: 'FixReactivePowerIn',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FilterRuntime',
              isRead: 'true',
              interval: '2247',
              texttableentry: 'FilterRuntime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentVentilationHeatRecovery',
              isRead: 'true',
              interval: '2248',
              texttableentry: 'CurrentVentilationHeatRecovery',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DigitalSwitchSettingOne',
              isRead: 'true',
              interval: '2249',
              texttableentry: 'DigitalSwitchSettingOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DigitalSwitchSettingTwo',
              isRead: 'true',
              interval: '2250',
              texttableentry: 'DigitalSwitchSettingTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LedStatusOne',
              isRead: 'true',
              interval: '2251',
              texttableentry: 'LedStatusOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LedStatusTwo',
              isRead: 'true',
              interval: '2252',
              texttableentry: 'LedStatusTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputSevenValue',
              isRead: 'true',
              interval: '2253',
              texttableentry: 'DeviceDigitalInputSevenValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingConfiguration',
              isRead: 'true',
              interval: '2254',
              texttableentry: 'PowerGridCodeSettingConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MinimumSecondaryReturnTemperatureRefrigerantCircuit',
              isRead: 'true',
              interval: '2255',
              texttableentry: 'MinimumSecondaryReturnTemperatureRefrigerantCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DesiredThermalEnergyDefrost',
              isRead: 'true',
              interval: '2256',
              texttableentry: 'DesiredThermalEnergyDefrost',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpointOffset',
              isRead: 'true',
              interval: '2257',
              texttableentry: 'DomesticHotWaterTemperatureSetpointOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleForceBalancing',
              isRead: 'true',
              interval: '2258',
              texttableentry: 'BatteryModuleForceBalancing',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerationCircuitStatus',
              isRead: 'true',
              interval: '2259',
              texttableentry: 'RefrigerationCircuitStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyOneDeviceProperty',
              isRead: 'true',
              interval: '2260',
              texttableentry: 'ZigBeeTwentyOneDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyOneDeviceSetpoint',
              isRead: 'true',
              interval: '2261',
              texttableentry: 'ZigBeeTwentyOneDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyOneDeviceCurrentValues',
              isRead: 'true',
              interval: '2262',
              texttableentry: 'ZigBeeTwentyOneDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyTwoDeviceProperty',
              isRead: 'true',
              interval: '2263',
              texttableentry: 'ZigBeeTwentyTwoDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyTwoDeviceSetpoint',
              isRead: 'true',
              interval: '2264',
              texttableentry: 'ZigBeeTwentyTwoDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyTwoDeviceCurrentValues',
              isRead: 'true',
              interval: '2265',
              texttableentry: 'ZigBeeTwentyTwoDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyThreeDeviceProperty',
              isRead: 'true',
              interval: '2266',
              texttableentry: 'ZigBeeTwentyThreeDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyThreeDeviceSetpoint',
              isRead: 'true',
              interval: '2267',
              texttableentry: 'ZigBeeTwentyThreeDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyThreeDeviceCurrentValues',
              isRead: 'true',
              interval: '2268',
              texttableentry: 'ZigBeeTwentyThreeDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFourDeviceProperty',
              isRead: 'true',
              interval: '2269',
              texttableentry: 'ZigBeeTwentyFourDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFourDeviceSetpoint',
              isRead: 'true',
              interval: '2270',
              texttableentry: 'ZigBeeTwentyFourDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFourDeviceCurrentValues',
              isRead: 'true',
              interval: '2271',
              texttableentry: 'ZigBeeTwentyFourDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFiveDeviceProperty',
              isRead: 'true',
              interval: '2272',
              texttableentry: 'ZigBeeTwentyFiveDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFiveDeviceSetpoint',
              isRead: 'true',
              interval: '2273',
              texttableentry: 'ZigBeeTwentyFiveDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFiveDeviceCurrentValues',
              isRead: 'true',
              interval: '2274',
              texttableentry: 'ZigBeeTwentyFiveDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySixDeviceProperty',
              isRead: 'true',
              interval: '2275',
              texttableentry: 'ZigBeeTwentySixDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySixDeviceSetpoint',
              isRead: 'true',
              interval: '2276',
              texttableentry: 'ZigBeeTwentySixDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySixDeviceCurrentValues',
              isRead: 'true',
              interval: '2277',
              texttableentry: 'ZigBeeTwentySixDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySevenDeviceProperty',
              isRead: 'true',
              interval: '2278',
              texttableentry: 'ZigBeeTwentySevenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySevenDeviceSetpoint',
              isRead: 'true',
              interval: '2279',
              texttableentry: 'ZigBeeTwentySevenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySevenDeviceCurrentValues',
              isRead: 'true',
              interval: '2280',
              texttableentry: 'ZigBeeTwentySevenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyEightDeviceProperty',
              isRead: 'true',
              interval: '2281',
              texttableentry: 'ZigBeeTwentyEightDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyEightDeviceSetpoint',
              isRead: 'true',
              interval: '2282',
              texttableentry: 'ZigBeeTwentyEightDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyEightDeviceCurrentValues',
              isRead: 'true',
              interval: '2283',
              texttableentry: 'ZigBeeTwentyEightDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyNineDeviceProperty',
              isRead: 'true',
              interval: '2284',
              texttableentry: 'ZigBeeTwentyNineDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyNineDeviceSetpoint',
              isRead: 'true',
              interval: '2285',
              texttableentry: 'ZigBeeTwentyNineDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyNineDeviceCurrentValues',
              isRead: 'true',
              interval: '2286',
              texttableentry: 'ZigBeeTwentyNineDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyDeviceProperty',
              isRead: 'true',
              interval: '2287',
              texttableentry: 'ZigBeeThirtyDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyDeviceSetpoint',
              isRead: 'true',
              interval: '2288',
              texttableentry: 'ZigBeeThirtyDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyDeviceCurrentValues',
              isRead: 'true',
              interval: '2289',
              texttableentry: 'ZigBeeThirtyDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyOneDeviceProperty',
              isRead: 'true',
              interval: '2290',
              texttableentry: 'ZigBeeThirtyOneDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyOneDeviceSetpoint',
              isRead: 'true',
              interval: '2291',
              texttableentry: 'ZigBeeThirtyOneDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyOneDeviceCurrentValues',
              isRead: 'true',
              interval: '2292',
              texttableentry: 'ZigBeeThirtyOneDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyTwoDeviceProperty',
              isRead: 'true',
              interval: '2293',
              texttableentry: 'ZigBeeThirtyTwoDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyTwoDeviceSetpoint',
              isRead: 'true',
              interval: '2294',
              texttableentry: 'ZigBeeThirtyTwoDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyTwoDeviceCurrentValues',
              isRead: 'true',
              interval: '2295',
              texttableentry: 'ZigBeeThirtyTwoDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyThreeDeviceProperty',
              isRead: 'true',
              interval: '2296',
              texttableentry: 'ZigBeeThirtyThreeDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyThreeDeviceSetpoint',
              isRead: 'true',
              interval: '2297',
              texttableentry: 'ZigBeeThirtyThreeDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyThreeDeviceCurrentValues',
              isRead: 'true',
              interval: '2298',
              texttableentry: 'ZigBeeThirtyThreeDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFourDeviceProperty',
              isRead: 'true',
              interval: '2299',
              texttableentry: 'ZigBeeThirtyFourDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFourDeviceSetpoint',
              isRead: 'true',
              interval: '2300',
              texttableentry: 'ZigBeeThirtyFourDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFourDeviceCurrentValues',
              isRead: 'true',
              interval: '2301',
              texttableentry: 'ZigBeeThirtyFourDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFiveDeviceProperty',
              isRead: 'true',
              interval: '2302',
              texttableentry: 'ZigBeeThirtyFiveDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFiveDeviceSetpoint',
              isRead: 'true',
              interval: '2303',
              texttableentry: 'ZigBeeThirtyFiveDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFiveDeviceCurrentValues',
              isRead: 'true',
              interval: '2304',
              texttableentry: 'ZigBeeThirtyFiveDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySixDeviceProperty',
              isRead: 'true',
              interval: '2305',
              texttableentry: 'ZigBeeThirtySixDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySixDeviceSetpoint',
              isRead: 'true',
              interval: '2306',
              texttableentry: 'ZigBeeThirtySixDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySixDeviceCurrentValues',
              isRead: 'true',
              interval: '2307',
              texttableentry: 'ZigBeeThirtySixDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySevenDeviceProperty',
              isRead: 'true',
              interval: '2308',
              texttableentry: 'ZigBeeThirtySevenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySevenDeviceSetpoint',
              isRead: 'true',
              interval: '2309',
              texttableentry: 'ZigBeeThirtySevenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySevenDeviceCurrentValues',
              isRead: 'true',
              interval: '2310',
              texttableentry: 'ZigBeeThirtySevenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyEightDeviceProperty',
              isRead: 'true',
              interval: '2311',
              texttableentry: 'ZigBeeThirtyEightDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyEightDeviceSetpoint',
              isRead: 'true',
              interval: '2312',
              texttableentry: 'ZigBeeThirtyEightDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyEightDeviceCurrentValues',
              isRead: 'true',
              interval: '2313',
              texttableentry: 'ZigBeeThirtyEightDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyNineDeviceProperty',
              isRead: 'true',
              interval: '2314',
              texttableentry: 'ZigBeeThirtyNineDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyNineDeviceSetpoint',
              isRead: 'true',
              interval: '2315',
              texttableentry: 'ZigBeeThirtyNineDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyNineDeviceCurrentValues',
              isRead: 'true',
              interval: '2316',
              texttableentry: 'ZigBeeThirtyNineDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourtyDeviceProperty',
              isRead: 'true',
              interval: '2317',
              texttableentry: 'ZigBeeFourtyDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourtyDeviceSetpoint',
              isRead: 'true',
              interval: '2318',
              texttableentry: 'ZigBeeFourtyDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourtyDeviceCurrentValues',
              isRead: 'true',
              interval: '2319',
              texttableentry: 'ZigBeeFourtyDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterStatus',
              isRead: 'true',
              interval: '2320',
              texttableentry: 'DomesticHotWaterStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentOneDecoupleList',
              isRead: 'true',
              interval: '2321',
              texttableentry: 'ZigBeeApartmentOneDecoupleList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentTwoDecoupleList',
              isRead: 'true',
              interval: '2322',
              texttableentry: 'ZigBeeApartmentTwoDecoupleList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentThreeDecoupleList',
              isRead: 'true',
              interval: '2323',
              texttableentry: 'ZigBeeApartmentThreeDecoupleList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeApartmentFourDecoupleList',
              isRead: 'true',
              interval: '2324',
              texttableentry: 'ZigBeeApartmentFourDecoupleList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HomeEnergyMonitoringSystemWiringScheme',
              isRead: 'true',
              interval: '2325',
              texttableentry: 'HomeEnergyMonitoringSystemWiringScheme',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HomeEnergyMonitoringSystemAggregatedPower',
              isRead: 'true',
              interval: '2326',
              texttableentry: 'HomeEnergyMonitoringSystemAggregatedPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationTargetVolumeFlow',
              isRead: 'true',
              interval: '2327',
              texttableentry: 'VentilationTargetVolumeFlow',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationCurrentVolumeFlow',
              isRead: 'true',
              interval: '2328',
              texttableentry: 'VentilationCurrentVolumeFlow',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryEnergyUsedAverage',
              isRead: 'true',
              interval: '2329',
              texttableentry: 'BatteryEnergyUsedAverage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardTwo',
              isRead: 'true',
              interval: '2330',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardThree',
              isRead: 'true',
              interval: '2331',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardFour',
              isRead: 'true',
              interval: '2332',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EconomizerLiquidTemperatureSensor',
              isRead: 'true',
              interval: '2333',
              texttableentry: 'EconomizerLiquidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EvaporatorVaporTemperatureSensor',
              isRead: 'true',
              interval: '2334',
              texttableentry: 'EvaporatorVaporTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleCoulombCounters',
              isRead: 'true',
              interval: '2335',
              texttableentry: 'BatteryModuleCoulombCounters',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ControllerBoardTemperatureSensor',
              isRead: 'true',
              interval: '2336',
              texttableentry: 'ControllerBoardTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_UltraLowNitroOxideStatusActive',
              isRead: 'true',
              interval: '2337',
              texttableentry: 'UltraLowNitroOxideStatusActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HighLimitTestMode',
              isRead: 'true',
              interval: '2338',
              texttableentry: 'HighLimitTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SafetyLimiterThresholdTemperature',
              isRead: 'true',
              interval: '2339',
              texttableentry: 'SafetyLimiterThresholdTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterConfiguration',
              isRead: 'true',
              interval: '2340',
              texttableentry: 'ElectricalHeaterConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoefficientOfPerformanceConfiguration',
              isRead: 'true',
              interval: '2341',
              texttableentry: 'CoefficientOfPerformanceConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NominalThermalCapacityHeating',
              isRead: 'true',
              interval: '2342',
              texttableentry: 'NominalThermalCapacityHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NominalThermalCapacityCooling',
              isRead: 'true',
              interval: '2343',
              texttableentry: 'NominalThermalCapacityCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CombustionAirInterlockSettings',
              isRead: 'true',
              interval: '2344',
              texttableentry: 'CombustionAirInterlockSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorSetpointPercent',
              isRead: 'true',
              interval: '2345',
              texttableentry: 'CompressorSetpointPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorSpeedPercent',
              isRead: 'true',
              interval: '2346',
              texttableentry: 'CompressorSpeedPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveClimateTargetPerSupplyChannel',
              isRead: 'true',
              interval: '2347',
              texttableentry: 'ActiveClimateTargetPerSupplyChannel',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicsActivePowerLimitationEnergyManagementSystem',
              isRead: 'true',
              interval: '2348',
              texttableentry: 'PhotovoltaicsActivePowerLimitationEnergyManagementSystem',
              isWrite: 'true',
            },
            {
              TI_texttableentry:
                'TI_PhotovoltaicsActivePowerLimitationFallbackEnergyManagementSystem',
              isRead: 'true',
              interval: '2349',
              texttableentry: 'PhotovoltaicsActivePowerLimitationFallbackEnergyManagementSystem',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyManagmentSystemResultingControlState',
              isRead: 'true',
              interval: '2350',
              texttableentry: 'EnergyManagmentSystemResultingControlState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCompressor',
              isRead: 'true',
              interval: '2351',
              texttableentry: 'HeatPumpCompressor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AdditionalElectricHeater',
              isRead: 'true',
              interval: '2352',
              texttableentry: 'AdditionalElectricHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TargetDemandHeatProducer',
              isRead: 'true',
              interval: '2353',
              texttableentry: 'TargetDemandHeatProducer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CombustionStartParameters',
              isRead: 'true',
              interval: '2354',
              texttableentry: 'CombustionStartParameters',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MinimumVentilationSupplyAirTemperature',
              isRead: 'true',
              interval: '2355',
              texttableentry: 'MinimumVentilationSupplyAirTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentSystemHeatingCoolingLevel',
              isRead: 'true',
              interval: '2356',
              texttableentry: 'CurrentSystemHeatingCoolingLevel',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OpenSourceLicenses',
              isRead: 'true',
              interval: '2357',
              texttableentry: 'OpenSourceLicenses',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetStatisticalValues',
              isRead: 'true',
              interval: '2358',
              texttableentry: 'ResetStatisticalValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HomeEnergyMonitoringSystemPowerData',
              isRead: 'true',
              interval: '2359',
              texttableentry: 'HomeEnergyMonitoringSystemPowerData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnvironmentAirQualityInputData',
              isRead: 'true',
              interval: '2360',
              texttableentry: 'EnvironmentAirQualityInputData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortReducedPropertiesSettings',
              isRead: 'true',
              interval: '2361',
              texttableentry: 'ClimateComfortReducedPropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortNormalPropertiesSettings',
              isRead: 'true',
              interval: '2362',
              texttableentry: 'ClimateComfortNormalPropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortComfortPropertiesSettings',
              isRead: 'true',
              interval: '2363',
              texttableentry: 'ClimateComfortComfortPropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortIntensivePropertiesSettings',
              isRead: 'true',
              interval: '2364',
              texttableentry: 'ClimateComfortIntensivePropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortHolidayAtHomePropertiesSettings',
              isRead: 'true',
              interval: '2365',
              texttableentry: 'ClimateComfortHolidayAtHomePropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortHolidayAwayPropertiesSettings',
              isRead: 'true',
              interval: '2366',
              texttableentry: 'ClimateComfortHolidayAwayPropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortPartyPropertiesSettings',
              isRead: 'true',
              interval: '2367',
              texttableentry: 'ClimateComfortPartyPropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortOneTimePropertiesSettings',
              isRead: 'true',
              interval: '2368',
              texttableentry: 'ClimateComfortOneTimePropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCompressorStatistical',
              isRead: 'true',
              interval: '2369',
              texttableentry: 'HeatPumpCompressorStatistical',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AdditionalElectricHeaterStatistical',
              isRead: 'true',
              interval: '2370',
              texttableentry: 'AdditionalElectricHeaterStatistical',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationControlMode',
              isRead: 'true',
              interval: '2371',
              texttableentry: 'VentilationControlMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationControllerOperationState',
              isRead: 'true',
              interval: '2372',
              texttableentry: 'VentilationControllerOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationAirVolumeFlowBalancingOffset',
              isRead: 'true',
              interval: '2373',
              texttableentry: 'VentilationAirVolumeFlowBalancingOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationExternalLockFunctionSetting',
              isRead: 'true',
              interval: '2374',
              texttableentry: 'VentilationExternalLockFunctionSetting',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NarrowBandInternetOfThingsConfiguration',
              isRead: 'true',
              interval: '2375',
              texttableentry: 'NarrowBandInternetOfThingsConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NarrowBandInternetOfThingsRadio',
              isRead: 'true',
              interval: '2376',
              texttableentry: 'NarrowBandInternetOfThingsRadio',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EvolvedUniversalTerrestrialRadioAccessDataLinkInfo',
              isRead: 'true',
              interval: '2377',
              texttableentry: 'EvolvedUniversalTerrestrialRadioAccessDataLinkInfo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EvolvedUniversalTerrestrialRadioAccessNeighborCells',
              isRead: 'true',
              interval: '2378',
              texttableentry: 'EvolvedUniversalTerrestrialRadioAccessNeighborCells',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EvolvedUniversalTerrestrialRadioAccessServingCellInfo',
              isRead: 'true',
              interval: '2379',
              texttableentry: 'EvolvedUniversalTerrestrialRadioAccessServingCellInfo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EvolvedUniversalTerrestrialRadioAccessServingCellMeasurements',
              isRead: 'true',
              interval: '2380',
              texttableentry: 'EvolvedUniversalTerrestrialRadioAccessServingCellMeasurements',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutdoorUnitDefrostingFunction',
              isRead: 'true',
              interval: '2381',
              texttableentry: 'OutdoorUnitDefrostingFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PaddleSwitch',
              isRead: 'true',
              interval: '2382',
              texttableentry: 'PaddleSwitch',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryLevel',
              isRead: 'true',
              interval: '2383',
              texttableentry: 'BatteryLevel',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HomeEnergyMonitoringSystemKeyPerformanceIndicators',
              isRead: 'true',
              interval: '2384',
              texttableentry: 'HomeEnergyMonitoringSystemKeyPerformanceIndicators',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TargetHumiditySetpoint',
              isRead: 'true',
              interval: '2385',
              texttableentry: 'TargetHumiditySetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveRegulationParameter',
              isRead: 'true',
              interval: '2386',
              texttableentry: 'ElectronicExpansionValveRegulationParameter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceOneName',
              isRead: 'true',
              interval: '2387',
              texttableentry: 'CustomerSpecificDeviceOneName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceTwoName',
              isRead: 'true',
              interval: '2388',
              texttableentry: 'CustomerSpecificDeviceTwoName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceThreeName',
              isRead: 'true',
              interval: '2389',
              texttableentry: 'CustomerSpecificDeviceThreeName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceFourName',
              isRead: 'true',
              interval: '2390',
              texttableentry: 'CustomerSpecificDeviceFourName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceFiveName',
              isRead: 'true',
              interval: '2391',
              texttableentry: 'CustomerSpecificDeviceFiveName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceSixName',
              isRead: 'true',
              interval: '2392',
              texttableentry: 'CustomerSpecificDeviceSixName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceSevenName',
              isRead: 'true',
              interval: '2393',
              texttableentry: 'CustomerSpecificDeviceSevenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceEightName',
              isRead: 'true',
              interval: '2394',
              texttableentry: 'CustomerSpecificDeviceEightName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceNineName',
              isRead: 'true',
              interval: '2395',
              texttableentry: 'CustomerSpecificDeviceNineName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceTenName',
              isRead: 'true',
              interval: '2396',
              texttableentry: 'CustomerSpecificDeviceTenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceElevenName',
              isRead: 'true',
              interval: '2397',
              texttableentry: 'CustomerSpecificDeviceElevenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceTwelveName',
              isRead: 'true',
              interval: '2398',
              texttableentry: 'CustomerSpecificDeviceTwelveName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceThirteenName',
              isRead: 'true',
              interval: '2399',
              texttableentry: 'CustomerSpecificDeviceThirteenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceFourteenName',
              isRead: 'true',
              interval: '2400',
              texttableentry: 'CustomerSpecificDeviceFourteenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceFifteenName',
              isRead: 'true',
              interval: '2401',
              texttableentry: 'CustomerSpecificDeviceFifteenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceSixteenName',
              isRead: 'true',
              interval: '2402',
              texttableentry: 'CustomerSpecificDeviceSixteenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BypassOperationLevel',
              isRead: 'true',
              interval: '2403',
              texttableentry: 'BypassOperationLevel',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BivalenceControlMode',
              isRead: 'true',
              interval: '2404',
              texttableentry: 'BivalenceControlMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitConstantFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2405',
              texttableentry: 'MixerOneCircuitConstantFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitConstantFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2406',
              texttableentry: 'MixerTwoCircuitConstantFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitConstantFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2407',
              texttableentry: 'MixerThreeCircuitConstantFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitConstantFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2408',
              texttableentry: 'MixerFourCircuitConstantFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitMinimumMaximumFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2409',
              texttableentry: 'MixerOneCircuitMinimumMaximumFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitMinimumMaximumFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2410',
              texttableentry: 'MixerTwoCircuitMinimumMaximumFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitMinimumMaximumFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2411',
              texttableentry: 'MixerThreeCircuitMinimumMaximumFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitMinimumMaximumFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2412',
              texttableentry: 'MixerFourCircuitMinimumMaximumFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitThresholdCooling',
              isRead: 'true',
              interval: '2413',
              texttableentry: 'MixerOneCircuitThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitThresholdCooling',
              isRead: 'true',
              interval: '2414',
              texttableentry: 'MixerTwoCircuitThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitThresholdCooling',
              isRead: 'true',
              interval: '2415',
              texttableentry: 'MixerThreeCircuitThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitThresholdCooling',
              isRead: 'true',
              interval: '2416',
              texttableentry: 'MixerFourCircuitThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTargetValueRelativeHumidityCooling',
              isRead: 'true',
              interval: '2417',
              texttableentry: 'MixerOneCircuitTargetValueRelativeHumidityCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTargetValueRelativeHumidityCooling',
              isRead: 'true',
              interval: '2418',
              texttableentry: 'MixerTwoCircuitTargetValueRelativeHumidityCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTargetValueRelativeHumidityCooling',
              isRead: 'true',
              interval: '2419',
              texttableentry: 'MixerThreeCircuitTargetValueRelativeHumidityCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTargetValueRelativeHumidityCooling',
              isRead: 'true',
              interval: '2420',
              texttableentry: 'MixerFourCircuitTargetValueRelativeHumidityCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTemperatureOffsetCooling',
              isRead: 'true',
              interval: '2421',
              texttableentry: 'MixerOneCircuitTemperatureOffsetCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTemperatureOffsetCooling',
              isRead: 'true',
              interval: '2422',
              texttableentry: 'MixerTwoCircuitTemperatureOffsetCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTemperatureOffsetCooling',
              isRead: 'true',
              interval: '2423',
              texttableentry: 'MixerThreeCircuitTemperatureOffsetCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTemperatureOffsetCooling',
              isRead: 'true',
              interval: '2424',
              texttableentry: 'MixerFourCircuitTemperatureOffsetCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleTypeId',
              isRead: 'true',
              interval: '2425',
              texttableentry: 'BatteryModuleTypeId',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2426',
              texttableentry: 'MixerOneCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2427',
              texttableentry: 'MixerTwoCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2428',
              texttableentry: 'MixerThreeCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2429',
              texttableentry: 'MixerFourCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2430',
              texttableentry: 'MixerFiveCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2431',
              texttableentry: 'MixerSixCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2432',
              texttableentry: 'MixerSevenCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2433',
              texttableentry: 'MixerEightCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2434',
              texttableentry: 'MixerNineCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2435',
              texttableentry: 'MixerTenCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2436',
              texttableentry: 'MixerElevenCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2437',
              texttableentry: 'MixerTwelveCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2438',
              texttableentry: 'MixerThirteenCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2439',
              texttableentry: 'MixerFourteenCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2440',
              texttableentry: 'MixerFifteenCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2441',
              texttableentry: 'MixerSixteenCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpFrostProtection',
              isRead: 'true',
              interval: '2442',
              texttableentry: 'HeatPumpFrostProtection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HomeEnergyMonitoringSystemEnergyData',
              isRead: 'true',
              interval: '2443',
              texttableentry: 'HomeEnergyMonitoringSystemEnergyData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LogLevelEmbbededApplication',
              isRead: 'true',
              interval: '2444',
              texttableentry: 'LogLevelEmbbededApplication',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupplementalHeatEngineConfiguration',
              isRead: 'true',
              interval: '2445',
              texttableentry: 'SupplementalHeatEngineConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HmiWakeupTrigger',
              isRead: 'true',
              interval: '2446',
              texttableentry: 'HmiWakeupTrigger',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupplyAirVolumeFlowDeviceLimit',
              isRead: 'true',
              interval: '2447',
              texttableentry: 'SupplyAirVolumeFlowDeviceLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirVolumeFlowDeviceLimit',
              isRead: 'true',
              interval: '2448',
              texttableentry: 'ExhaustAirVolumeFlowDeviceLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceName',
              isRead: 'true',
              interval: '2449',
              texttableentry: 'CustomerSpecificDeviceName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeSequenceCurrentBoiler',
              isRead: 'true',
              interval: '2450',
              texttableentry: 'CascadeSequenceCurrentBoiler',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeEmergencyOperationMode',
              isRead: 'true',
              interval: '2451',
              texttableentry: 'CascadeEmergencyOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureThresholdCooling',
              isRead: 'true',
              interval: '2452',
              texttableentry: 'MixerOneCircuitRoomTemperatureThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomTemperatureThresholdCooling',
              isRead: 'true',
              interval: '2453',
              texttableentry: 'MixerTwoCircuitRoomTemperatureThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomTemperatureThresholdCooling',
              isRead: 'true',
              interval: '2454',
              texttableentry: 'MixerThreeCircuitRoomTemperatureThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomTemperatureThresholdCooling',
              isRead: 'true',
              interval: '2455',
              texttableentry: 'MixerFourCircuitRoomTemperatureThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UserInterfacePageIdentificationNumber',
              isRead: 'true',
              interval: '2456',
              texttableentry: 'UserInterfacePageIdentificationNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CalculatedOutsideTemperature',
              isRead: 'true',
              interval: '2457',
              texttableentry: 'CalculatedOutsideTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLead',
              isRead: 'true',
              interval: '2458',
              texttableentry: 'CascadeDeviceStatusLead',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagOne',
              isRead: 'true',
              interval: '2459',
              texttableentry: 'CascadeDeviceStatusLagOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagTwo',
              isRead: 'true',
              interval: '2460',
              texttableentry: 'CascadeDeviceStatusLagTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagThree',
              isRead: 'true',
              interval: '2461',
              texttableentry: 'CascadeDeviceStatusLagThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagFour',
              isRead: 'true',
              interval: '2462',
              texttableentry: 'CascadeDeviceStatusLagFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagFive',
              isRead: 'true',
              interval: '2463',
              texttableentry: 'CascadeDeviceStatusLagFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagSix',
              isRead: 'true',
              interval: '2464',
              texttableentry: 'CascadeDeviceStatusLagSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagSeven',
              isRead: 'true',
              interval: '2465',
              texttableentry: 'CascadeDeviceStatusLagSeven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagEight',
              isRead: 'true',
              interval: '2466',
              texttableentry: 'CascadeDeviceStatusLagEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagNine',
              isRead: 'true',
              interval: '2467',
              texttableentry: 'CascadeDeviceStatusLagNine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagTen',
              isRead: 'true',
              interval: '2468',
              texttableentry: 'CascadeDeviceStatusLagTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagEleven',
              isRead: 'true',
              interval: '2469',
              texttableentry: 'CascadeDeviceStatusLagEleven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagTwelve',
              isRead: 'true',
              interval: '2470',
              texttableentry: 'CascadeDeviceStatusLagTwelve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagThirteen',
              isRead: 'true',
              interval: '2471',
              texttableentry: 'CascadeDeviceStatusLagThirteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagFourteen',
              isRead: 'true',
              interval: '2472',
              texttableentry: 'CascadeDeviceStatusLagFourteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagFifteen',
              isRead: 'true',
              interval: '2473',
              texttableentry: 'CascadeDeviceStatusLagFifteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeCommonFlowTemperatureSensor',
              isRead: 'true',
              interval: '2474',
              texttableentry: 'CascadeCommonFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeCommonFlowCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '2475',
              texttableentry: 'CascadeCommonFlowCurrentTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnvironmentAirQualityTargetValues',
              isRead: 'true',
              interval: '2476',
              texttableentry: 'EnvironmentAirQualityTargetValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnvironmentAirQualitySensor',
              isRead: 'true',
              interval: '2477',
              texttableentry: 'EnvironmentAirQualitySensor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomAirHumiditySensor',
              isRead: 'true',
              interval: '2478',
              texttableentry: 'RoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2479',
              texttableentry: 'MixerOneCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2480',
              texttableentry: 'MixerTwoCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2481',
              texttableentry: 'MixerThreeCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2482',
              texttableentry: 'MixerFourCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OpenThermConfiguration',
              isRead: 'true',
              interval: '2483',
              texttableentry: 'OpenThermConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPowerRangeMetaData',
              isRead: 'true',
              interval: '2484',
              texttableentry: 'ElectricalPowerRangeMetaData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyTotalConsumption',
              isRead: 'true',
              interval: '2485',
              texttableentry: 'ElectricalEnergyTotalConsumption',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentElectricalPowerConsumptionRefrigerantCircuit',
              isRead: 'true',
              interval: '2486',
              texttableentry: 'CurrentElectricalPowerConsumptionRefrigerantCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentElectricalPowerConsumptionElectricHeater',
              isRead: 'true',
              interval: '2487',
              texttableentry: 'CurrentElectricalPowerConsumptionElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentElectricalPowerConsumptionSystem',
              isRead: 'true',
              interval: '2488',
              texttableentry: 'CurrentElectricalPowerConsumptionSystem',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FrostProtectionStatus',
              isRead: 'true',
              interval: '2489',
              texttableentry: 'FrostProtectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StartUpWizardState',
              isRead: 'true',
              interval: '2490',
              texttableentry: 'StartUpWizardState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterDemandInput',
              isRead: 'true',
              interval: '2491',
              texttableentry: 'DomesticHotWaterDemandInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitState',
              isRead: 'true',
              interval: '2492',
              texttableentry: 'ElectronicControlUnitState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationBypassPosition',
              isRead: 'true',
              interval: '2493',
              texttableentry: 'VentilationBypassPosition',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentThermalCapacityRefrigerantCircuit',
              isRead: 'true',
              interval: '2494',
              texttableentry: 'CurrentThermalCapacityRefrigerantCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentThermalCapacityElectricHeater',
              isRead: 'true',
              interval: '2495',
              texttableentry: 'CurrentThermalCapacityElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentThermalCapacitySystem',
              isRead: 'true',
              interval: '2496',
              texttableentry: 'CurrentThermalCapacitySystem',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetStatisticalValuesDate',
              isRead: 'true',
              interval: '2497',
              texttableentry: 'ResetStatisticalValuesDate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpType',
              isRead: 'true',
              interval: '2498',
              texttableentry: 'CentralHeatingPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpType',
              isRead: 'true',
              interval: '2499',
              texttableentry: 'MixerOneCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpType',
              isRead: 'true',
              interval: '2500',
              texttableentry: 'MixerTwoCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpType',
              isRead: 'true',
              interval: '2501',
              texttableentry: 'MixerThreeCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpType',
              isRead: 'true',
              interval: '2502',
              texttableentry: 'MixerFourCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitPumpType',
              isRead: 'true',
              interval: '2503',
              texttableentry: 'MixerFiveCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitPumpType',
              isRead: 'true',
              interval: '2504',
              texttableentry: 'MixerSixCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitPumpType',
              isRead: 'true',
              interval: '2505',
              texttableentry: 'MixerSevenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitPumpType',
              isRead: 'true',
              interval: '2506',
              texttableentry: 'MixerEightCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitPumpType',
              isRead: 'true',
              interval: '2507',
              texttableentry: 'MixerNineCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitPumpType',
              isRead: 'true',
              interval: '2508',
              texttableentry: 'MixerTenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitPumpType',
              isRead: 'true',
              interval: '2509',
              texttableentry: 'MixerElevenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitPumpType',
              isRead: 'true',
              interval: '2510',
              texttableentry: 'MixerTwelveCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitPumpType',
              isRead: 'true',
              interval: '2511',
              texttableentry: 'MixerThirteenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitPumpType',
              isRead: 'true',
              interval: '2512',
              texttableentry: 'MixerFourteenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitPumpType',
              isRead: 'true',
              interval: '2513',
              texttableentry: 'MixerFifteenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitPumpType',
              isRead: 'true',
              interval: '2514',
              texttableentry: 'MixerSixteenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterMonthMatrixElectricHeater',
              isRead: 'true',
              interval: '2515',
              texttableentry: 'EnergyConsumptionDomesticHotWaterMonthMatrixElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterYearMatrixElectricHeater',
              isRead: 'true',
              interval: '2516',
              texttableentry: 'EnergyConsumptionDomesticHotWaterYearMatrixElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterElectricHeater',
              isRead: 'true',
              interval: '2517',
              texttableentry: 'EnergyConsumptionDomesticHotWaterElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCoolingMonthMatrixRefrigerantCycle',
              isRead: 'true',
              interval: '2518',
              texttableentry: 'EnergyConsumptionCoolingMonthMatrixRefrigerantCycle',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCoolingYearMatrixRefrigerantCycle',
              isRead: 'true',
              interval: '2519',
              texttableentry: 'EnergyConsumptionCoolingYearMatrixRefrigerantCycle',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCoolingRefrigerantCycle',
              isRead: 'true',
              interval: '2520',
              texttableentry: 'EnergyConsumptionCoolingRefrigerantCycle',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterMonthMatrixRefrigerantCycle',
              isRead: 'true',
              interval: '2521',
              texttableentry: 'EnergyConsumptionDomesticHotWaterMonthMatrixRefrigerantCycle',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterYearMatrixRefrigerantCycle',
              isRead: 'true',
              interval: '2522',
              texttableentry: 'EnergyConsumptionDomesticHotWaterYearMatrixRefrigerantCycle',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterRefrigerantCycle',
              isRead: 'true',
              interval: '2523',
              texttableentry: 'EnergyConsumptionDomesticHotWaterRefrigerantCycle',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixElectricHeater',
              isRead: 'true',
              interval: '2524',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixElectricHeater',
              isRead: 'true',
              interval: '2525',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingElectricHeater',
              isRead: 'true',
              interval: '2526',
              texttableentry: 'EnergyConsumptionCentralHeatingElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedCoolingOutputMonthMatrix',
              isRead: 'true',
              interval: '2527',
              texttableentry: 'GeneratedCoolingOutputMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedCoolingOutputYearMatrix',
              isRead: 'true',
              interval: '2528',
              texttableentry: 'GeneratedCoolingOutputYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedCoolingOutput',
              isRead: 'true',
              interval: '2529',
              texttableentry: 'GeneratedCoolingOutput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixRefrigerantCycle',
              isRead: 'true',
              interval: '2530',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixRefrigerantCycle',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixRefrigerantCycle',
              isRead: 'true',
              interval: '2531',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixRefrigerantCycle',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingRefrigerantCycle',
              isRead: 'true',
              interval: '2532',
              texttableentry: 'EnergyConsumptionCentralHeatingRefrigerantCycle',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormSix',
              isRead: 'true',
              interval: '2533',
              texttableentry: 'PowerGridCodeSettingsNormSix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixSix',
              isRead: 'true',
              interval: '2534',
              texttableentry: 'BusTopologyMatrixSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixSeven',
              isRead: 'true',
              interval: '2535',
              texttableentry: 'BusTopologyMatrixSeven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixEight',
              isRead: 'true',
              interval: '2536',
              texttableentry: 'BusTopologyMatrixEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixNine',
              isRead: 'true',
              interval: '2537',
              texttableentry: 'BusTopologyMatrixNine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixTen',
              isRead: 'true',
              interval: '2538',
              texttableentry: 'BusTopologyMatrixTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AlternatingCurrentEnergyStatistic',
              isRead: 'true',
              interval: '2539',
              texttableentry: 'AlternatingCurrentEnergyStatistic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionSettings',
              isRead: 'true',
              interval: '2540',
              texttableentry: 'NoiseReductionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupplyAirVolumeFlowConfigurationLimit',
              isRead: 'true',
              interval: '2541',
              texttableentry: 'SupplyAirVolumeFlowConfigurationLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirVolumeFlowConfigurationLimit',
              isRead: 'true',
              interval: '2542',
              texttableentry: 'ExhaustAirVolumeFlowConfigurationLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SmartGridTemperatureOffsets',
              isRead: 'true',
              interval: '2543',
              texttableentry: 'SmartGridTemperatureOffsets',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnableElectricalHeaterSmartGridLock',
              isRead: 'true',
              interval: '2544',
              texttableentry: 'EnableElectricalHeaterSmartGridLock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnableElectricalHeaterSmartGridIncreaseMaxDemand',
              isRead: 'true',
              interval: '2545',
              texttableentry: 'EnableElectricalHeaterSmartGridIncreaseMaxDemand',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureSetpointCooling',
              isRead: 'true',
              interval: '2546',
              texttableentry: 'MixerOneCircuitRoomTemperatureSetpointCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomTemperatureSetpointCooling',
              isRead: 'true',
              interval: '2547',
              texttableentry: 'MixerTwoCircuitRoomTemperatureSetpointCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomTemperatureSetpointCooling',
              isRead: 'true',
              interval: '2548',
              texttableentry: 'MixerThreeCircuitRoomTemperatureSetpointCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomTemperatureSetpointCooling',
              isRead: 'true',
              interval: '2549',
              texttableentry: 'MixerFourCircuitRoomTemperatureSetpointCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OxygenProbeProcessValues',
              isRead: 'true',
              interval: '2550',
              texttableentry: 'OxygenProbeProcessValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlameBurnerTwo',
              isRead: 'true',
              interval: '2551',
              texttableentry: 'FlameBurnerTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ModulationCurrentValueBurnerTwo',
              isRead: 'true',
              interval: '2552',
              texttableentry: 'ModulationCurrentValueBurnerTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatEngineStatisticalBurnerTwo',
              isRead: 'true',
              interval: '2553',
              texttableentry: 'HeatEngineStatisticalBurnerTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CellularModemIdentification',
              isRead: 'true',
              interval: '2554',
              texttableentry: 'CellularModemIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPowerSetPoint',
              isRead: 'true',
              interval: '2555',
              texttableentry: 'ElectricalPowerSetPoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyRemainingCapacity',
              isRead: 'true',
              interval: '2556',
              texttableentry: 'ElectricalEnergyRemainingCapacity',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatPumpState',
              isRead: 'true',
              interval: '2557',
              texttableentry: 'HeatPumpState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpSupportedStates',
              isRead: 'true',
              interval: '2558',
              texttableentry: 'HeatPumpSupportedStates',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationFanModbusId',
              isRead: 'true',
              interval: '2559',
              texttableentry: 'VentilationFanModbusId',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SmartGridFeatureSelection',
              isRead: 'true',
              interval: '2560',
              texttableentry: 'SmartGridFeatureSelection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentCoefficientOfPerformance',
              isRead: 'true',
              interval: '2561',
              texttableentry: 'CurrentCoefficientOfPerformance',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeDevicePreConfiguredList',
              isRead: 'true',
              interval: '2562',
              texttableentry: 'ZigBeeDevicePreConfiguredList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeDeviceDecoupleList',
              isRead: 'true',
              interval: '2563',
              texttableentry: 'ZigBeeDeviceDecoupleList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HydraulicFlapState',
              isRead: 'true',
              interval: '2564',
              texttableentry: 'HydraulicFlapState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SurfaceNetSolarIrradianceForecast',
              isRead: 'true',
              interval: '2565',
              texttableentry: 'SurfaceNetSolarIrradianceForecast',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationSupplyFanRuntime',
              isRead: 'true',
              interval: '2566',
              texttableentry: 'VentilationSupplyFanRuntime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationExhaustFanRuntime',
              isRead: 'true',
              interval: '2567',
              texttableentry: 'VentilationExhaustFanRuntime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantType',
              isRead: 'true',
              interval: '2568',
              texttableentry: 'RefrigerantType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorSpeedRps',
              isRead: 'true',
              interval: '2569',
              texttableentry: 'CompressorSpeedRps',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorModulType',
              isRead: 'true',
              interval: '2570',
              texttableentry: 'CompressorModulType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorSuctionSuperheat',
              isRead: 'true',
              interval: '2571',
              texttableentry: 'CompressorSuctionSuperheat',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActualCompressorInletMassflow',
              isRead: 'true',
              interval: '2572',
              texttableentry: 'ActualCompressorInletMassflow',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOnTimer',
              isRead: 'true',
              interval: '2573',
              texttableentry: 'CompressorOnTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_NominalPowerElectricalHeater',
              isRead: 'true',
              interval: '2574',
              texttableentry: 'NominalPowerElectricalHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerationCycleApplicationState',
              isRead: 'true',
              interval: '2575',
              texttableentry: 'RefrigerationCycleApplicationState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellTestModeOne',
              isRead: 'true',
              interval: '2576',
              texttableentry: 'FuelCellTestModeOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellTestModeTwo',
              isRead: 'true',
              interval: '2577',
              texttableentry: 'FuelCellTestModeTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerationCircuitDesiredOperatingMode',
              isRead: 'true',
              interval: '2578',
              texttableentry: 'RefrigerationCircuitDesiredOperatingMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMinMaxAllowedPrimaryTemperatureHeating',
              isRead: 'true',
              interval: '2579',
              texttableentry: 'CompressorMinMaxAllowedPrimaryTemperatureHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorSetpointRps',
              isRead: 'true',
              interval: '2580',
              texttableentry: 'CompressorSetpointRps',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorCalculatedSetpointRps',
              isRead: 'true',
              interval: '2581',
              texttableentry: 'CompressorCalculatedSetpointRps',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorOffTimer',
              isRead: 'true',
              interval: '2582',
              texttableentry: 'CompressorOffTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OxygenProbeProcessValuesBurnerOne',
              isRead: 'true',
              interval: '2583',
              texttableentry: 'OxygenProbeProcessValuesBurnerOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OxygenProbeProcessValuesBurnerTwo',
              isRead: 'true',
              interval: '2584',
              texttableentry: 'OxygenProbeProcessValuesBurnerTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OxygenProbeProcessValuesBurnerThree',
              isRead: 'true',
              interval: '2585',
              texttableentry: 'OxygenProbeProcessValuesBurnerThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DigitalOutputCooling',
              isRead: 'true',
              interval: '2586',
              texttableentry: 'DigitalOutputCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleWarrantyDataListLastEntry',
              isRead: 'true',
              interval: '2587',
              texttableentry: 'BatteryModuleWarrantyDataListLastEntry',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleWarrantyDataListOne',
              isRead: 'true',
              interval: '2588',
              texttableentry: 'BatteryModuleWarrantyDataListOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleWarrantyDataListTwo',
              isRead: 'true',
              interval: '2589',
              texttableentry: 'BatteryModuleWarrantyDataListTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCommonSettingsHeating',
              isRead: 'true',
              interval: '2590',
              texttableentry: 'HeatPumpCommonSettingsHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCommonSettingsCooling',
              isRead: 'true',
              interval: '2591',
              texttableentry: 'HeatPumpCommonSettingsCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExpansionValveTheoreticalSetpoint',
              isRead: 'true',
              interval: '2592',
              texttableentry: 'ExpansionValveTheoreticalSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductMatrix',
              isRead: 'true',
              interval: '2593',
              texttableentry: 'ProductMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalPreHeaterMonthMatrix',
              isRead: 'true',
              interval: '2594',
              texttableentry: 'ElectricalPreHeaterMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPreHeaterYearMatrix',
              isRead: 'true',
              interval: '2595',
              texttableentry: 'ElectricalPreHeaterYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyProductionPhotovoltaicMonthMatrix',
              isRead: 'true',
              interval: '2596',
              texttableentry: 'EnergyProductionPhotovoltaicMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyProductionPhotovoltaicYearMatrix',
              isRead: 'true',
              interval: '2597',
              texttableentry: 'EnergyProductionPhotovoltaicYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationFanAssignmentAvailable',
              isRead: 'true',
              interval: '2598',
              texttableentry: 'VentilationFanAssignmentAvailable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationFanAssignmentSwitch',
              isRead: 'true',
              interval: '2599',
              texttableentry: 'VentilationFanAssignmentSwitch',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterActivation',
              isRead: 'true',
              interval: '2600',
              texttableentry: 'ElectricalHeaterActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterVentilationConfiguration',
              isRead: 'true',
              interval: '2601',
              texttableentry: 'ElectricalHeaterVentilationConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerStatus',
              isRead: 'true',
              interval: '2602',
              texttableentry: 'PrimaryHeatExchangerStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerCommonSettings',
              isRead: 'true',
              interval: '2603',
              texttableentry: 'PrimaryHeatExchangerCommonSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LevelSwitchActivation',
              isRead: 'true',
              interval: '2604',
              texttableentry: 'LevelSwitchActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_QuickModeRuntime',
              isRead: 'true',
              interval: '2605',
              texttableentry: 'QuickModeRuntime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalTriggerActivation',
              isRead: 'true',
              interval: '2606',
              texttableentry: 'ExternalTriggerActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalTriggerSettings',
              isRead: 'true',
              interval: '2607',
              texttableentry: 'ExternalTriggerSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FilterSettings',
              isRead: 'true',
              interval: '2608',
              texttableentry: 'FilterSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CommissioningStatus',
              isRead: 'true',
              interval: '2609',
              texttableentry: 'CommissioningStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStateExpert',
              isRead: 'true',
              interval: '2610',
              texttableentry: 'SetDeliveryStateExpert',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NominalThermalCapacityIndoorUnit',
              isRead: 'true',
              interval: '2611',
              texttableentry: 'NominalThermalCapacityIndoorUnit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimarySourceCommonSettingsHeating',
              isRead: 'true',
              interval: '2612',
              texttableentry: 'PrimarySourceCommonSettingsHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimarySourceCommonSettingsCooling',
              isRead: 'true',
              interval: '2613',
              texttableentry: 'PrimarySourceCommonSettingsCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WaterDeviceConfigration',
              isRead: 'true',
              interval: '2614',
              texttableentry: 'WaterDeviceConfigration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WaterDeviceInformation',
              isRead: 'true',
              interval: '2615',
              texttableentry: 'WaterDeviceInformation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WaterValve',
              isRead: 'true',
              interval: '2616',
              texttableentry: 'WaterValve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterConsumption',
              isRead: 'true',
              interval: '2617',
              texttableentry: 'WaterConsumption',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterSaltLevelInformation',
              isRead: 'true',
              interval: '2618',
              texttableentry: 'WaterSaltLevelInformation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WaterLeakageSensor',
              isRead: 'true',
              interval: '2619',
              texttableentry: 'WaterLeakageSensor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimarySourceCommonSettings',
              isRead: 'true',
              interval: '2620',
              texttableentry: 'PrimarySourceCommonSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MaximumOperatingPressureActualTemperatureSetpoint',
              isRead: 'true',
              interval: '2621',
              texttableentry: 'MaximumOperatingPressureActualTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SeasonalCoefficientOfPerformaceHeating',
              isRead: 'true',
              interval: '2622',
              texttableentry: 'SeasonalCoefficientOfPerformaceHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SeasonalEnergyEfficiencyRatioCooling',
              isRead: 'true',
              interval: '2623',
              texttableentry: 'SeasonalEnergyEfficiencyRatioCooling',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SeasonalCoefficientOfPerformaceDomesticHotWater',
              isRead: 'true',
              interval: '2624',
              texttableentry: 'SeasonalCoefficientOfPerformaceDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SeasonalCoefficientOfPerformaceHeatingAndDomesticHotWater',
              isRead: 'true',
              interval: '2625',
              texttableentry: 'SeasonalCoefficientOfPerformaceHeatingAndDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MaximumPowerElectricalHeater',
              isRead: 'true',
              interval: '2626',
              texttableentry: 'MaximumPowerElectricalHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorStartUpTimer',
              isRead: 'true',
              interval: '2627',
              texttableentry: 'CompressorStartUpTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ScreedDryingActivation',
              isRead: 'true',
              interval: '2628',
              texttableentry: 'ScreedDryingActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DesiredThermalCapacity',
              isRead: 'true',
              interval: '2629',
              texttableentry: 'DesiredThermalCapacity',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMinMaxSpeedHeating',
              isRead: 'true',
              interval: '2630',
              texttableentry: 'CompressorMinMaxSpeedHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMinMaxSpeedCooling',
              isRead: 'true',
              interval: '2631',
              texttableentry: 'CompressorMinMaxSpeedCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMinMaxSpeedDefrost',
              isRead: 'true',
              interval: '2632',
              texttableentry: 'CompressorMinMaxSpeedDefrost',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MaxSpeedNoiseReductionMode',
              isRead: 'true',
              interval: '2633',
              texttableentry: 'MaxSpeedNoiseReductionMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionMode',
              isRead: 'true',
              interval: '2634',
              texttableentry: 'NoiseReductionMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BurnerProcessDataFlags',
              isRead: 'true',
              interval: '2635',
              texttableentry: 'BurnerProcessDataFlags',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BurnerTwoProcessDataFlags',
              isRead: 'true',
              interval: '2636',
              texttableentry: 'BurnerTwoProcessDataFlags',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BurnerThreeProcessDataFlags',
              isRead: 'true',
              interval: '2637',
              texttableentry: 'BurnerThreeProcessDataFlags',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupportedCountryCodes',
              isRead: 'true',
              interval: '2638',
              texttableentry: 'SupportedCountryCodes',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceCalibrationTrigger',
              isRead: 'true',
              interval: '2639',
              texttableentry: 'DeviceCalibrationTrigger',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetHistory',
              isRead: 'true',
              interval: '2640',
              texttableentry: 'ResetHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RoomTemperatureSetpointProperties',
              isRead: 'true',
              interval: '2641',
              texttableentry: 'RoomTemperatureSetpointProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ComfortEnsuringModeProperties',
              isRead: 'true',
              interval: '2642',
              texttableentry: 'ComfortEnsuringModeProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MaximumRechargePower',
              isRead: 'true',
              interval: '2643',
              texttableentry: 'MaximumRechargePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OverTheAirUpdateStatus',
              isRead: 'true',
              interval: '2644',
              texttableentry: 'OverTheAirUpdateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkControl',
              isRead: 'true',
              interval: '2645',
              texttableentry: 'ZigBeeNetworkControl',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkConfiguration',
              isRead: 'true',
              interval: '2646',
              texttableentry: 'ZigBeeNetworkConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkStatus',
              isRead: 'true',
              interval: '2647',
              texttableentry: 'ZigBeeNetworkStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceControlStatus',
              isRead: 'true',
              interval: '2648',
              texttableentry: 'ZigBeeNetworkDeviceControlStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceControl',
              isRead: 'true',
              interval: '2649',
              texttableentry: 'ZigBeeNetworkDeviceControl',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeDiagnosisScannedNetworks',
              isRead: 'true',
              interval: '2650',
              texttableentry: 'ZigBeeDiagnosisScannedNetworks',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeDiagnosisScannedChannels',
              isRead: 'true',
              interval: '2651',
              texttableentry: 'ZigBeeDiagnosisScannedChannels',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeDiagnosisScannedDevice',
              isRead: 'true',
              interval: '2652',
              texttableentry: 'ZigBeeDiagnosisScannedDevice',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceOnePropertyLocal',
              isRead: 'true',
              interval: '2653',
              texttableentry: 'ZigBeeNetworkDeviceOnePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwoPropertyLocal',
              isRead: 'true',
              interval: '2654',
              texttableentry: 'ZigBeeNetworkDeviceTwoPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThreePropertyLocal',
              isRead: 'true',
              interval: '2655',
              texttableentry: 'ZigBeeNetworkDeviceThreePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceFourPropertyLocal',
              isRead: 'true',
              interval: '2656',
              texttableentry: 'ZigBeeNetworkDeviceFourPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceFivePropertyLocal',
              isRead: 'true',
              interval: '2657',
              texttableentry: 'ZigBeeNetworkDeviceFivePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceSixPropertyLocal',
              isRead: 'true',
              interval: '2658',
              texttableentry: 'ZigBeeNetworkDeviceSixPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceSevenPropertyLocal',
              isRead: 'true',
              interval: '2659',
              texttableentry: 'ZigBeeNetworkDeviceSevenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceEightPropertyLocal',
              isRead: 'true',
              interval: '2660',
              texttableentry: 'ZigBeeNetworkDeviceEightPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceNinePropertyLocal',
              isRead: 'true',
              interval: '2661',
              texttableentry: 'ZigBeeNetworkDeviceNinePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTenPropertyLocal',
              isRead: 'true',
              interval: '2662',
              texttableentry: 'ZigBeeNetworkDeviceTenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceElevenPropertyLocal',
              isRead: 'true',
              interval: '2663',
              texttableentry: 'ZigBeeNetworkDeviceElevenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwelvePropertyLocal',
              isRead: 'true',
              interval: '2664',
              texttableentry: 'ZigBeeNetworkDeviceTwelvePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirTeenPropertyLocal',
              isRead: 'true',
              interval: '2665',
              texttableentry: 'ZigBeeNetworkDeviceThirTeenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceFourTeenPropertyLocal',
              isRead: 'true',
              interval: '2666',
              texttableentry: 'ZigBeeNetworkDeviceFourTeenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceFifteenPropertyLocal',
              isRead: 'true',
              interval: '2667',
              texttableentry: 'ZigBeeNetworkDeviceFifteenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceSixteenPropertyLocal',
              isRead: 'true',
              interval: '2668',
              texttableentry: 'ZigBeeNetworkDeviceSixteenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceSeventeenPropertyLocal',
              isRead: 'true',
              interval: '2669',
              texttableentry: 'ZigBeeNetworkDeviceSeventeenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceEighteenPropertyLocal',
              isRead: 'true',
              interval: '2670',
              texttableentry: 'ZigBeeNetworkDeviceEighteenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceNineteenPropertyLocal',
              isRead: 'true',
              interval: '2671',
              texttableentry: 'ZigBeeNetworkDeviceNineteenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyPropertyLocal',
              isRead: 'true',
              interval: '2672',
              texttableentry: 'ZigBeeNetworkDeviceTwentyPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyOnePropertyLocal',
              isRead: 'true',
              interval: '2673',
              texttableentry: 'ZigBeeNetworkDeviceTwentyOnePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyTwoPropertyLocal',
              isRead: 'true',
              interval: '2674',
              texttableentry: 'ZigBeeNetworkDeviceTwentyTwoPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyThreePropertyLocal',
              isRead: 'true',
              interval: '2675',
              texttableentry: 'ZigBeeNetworkDeviceTwentyThreePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyFourPropertyLocal',
              isRead: 'true',
              interval: '2676',
              texttableentry: 'ZigBeeNetworkDeviceTwentyFourPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyFivePropertyLocal',
              isRead: 'true',
              interval: '2677',
              texttableentry: 'ZigBeeNetworkDeviceTwentyFivePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentySixPropertyLocal',
              isRead: 'true',
              interval: '2678',
              texttableentry: 'ZigBeeNetworkDeviceTwentySixPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentySevenPropertyLocal',
              isRead: 'true',
              interval: '2679',
              texttableentry: 'ZigBeeNetworkDeviceTwentySevenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyEightPropertyLocal',
              isRead: 'true',
              interval: '2680',
              texttableentry: 'ZigBeeNetworkDeviceTwentyEightPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyNinePropertyLocal',
              isRead: 'true',
              interval: '2681',
              texttableentry: 'ZigBeeNetworkDeviceTwentyNinePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyPropertyLocal',
              isRead: 'true',
              interval: '2682',
              texttableentry: 'ZigBeeNetworkDeviceThirtyPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyOnePropertyLocal',
              isRead: 'true',
              interval: '2683',
              texttableentry: 'ZigBeeNetworkDeviceThirtyOnePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyTwoPropertyLocal',
              isRead: 'true',
              interval: '2684',
              texttableentry: 'ZigBeeNetworkDeviceThirtyTwoPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyThreePropertyLocal',
              isRead: 'true',
              interval: '2685',
              texttableentry: 'ZigBeeNetworkDeviceThirtyThreePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyFourPropertyLocal',
              isRead: 'true',
              interval: '2686',
              texttableentry: 'ZigBeeNetworkDeviceThirtyFourPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyFivePropertyLocal',
              isRead: 'true',
              interval: '2687',
              texttableentry: 'ZigBeeNetworkDeviceThirtyFivePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtySixPropertyLocal',
              isRead: 'true',
              interval: '2688',
              texttableentry: 'ZigBeeNetworkDeviceThirtySixPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtySevenPropertyLocal',
              isRead: 'true',
              interval: '2689',
              texttableentry: 'ZigBeeNetworkDeviceThirtySevenPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyEightPropertyLocal',
              isRead: 'true',
              interval: '2690',
              texttableentry: 'ZigBeeNetworkDeviceThirtyEightPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyNinePropertyLocal',
              isRead: 'true',
              interval: '2691',
              texttableentry: 'ZigBeeNetworkDeviceThirtyNinePropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceFourtyPropertyLocal',
              isRead: 'true',
              interval: '2692',
              texttableentry: 'ZigBeeNetworkDeviceFourtyPropertyLocal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceOnePropertyCoordinator',
              isRead: 'true',
              interval: '2693',
              texttableentry: 'ZigBeeNetworkDeviceOnePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwoPropertyCoordinator',
              isRead: 'true',
              interval: '2694',
              texttableentry: 'ZigBeeNetworkDeviceTwoPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThreePropertyCoordinator',
              isRead: 'true',
              interval: '2695',
              texttableentry: 'ZigBeeNetworkDeviceThreePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceFourPropertyCoordinator',
              isRead: 'true',
              interval: '2696',
              texttableentry: 'ZigBeeNetworkDeviceFourPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceFivePropertyCoordinator',
              isRead: 'true',
              interval: '2697',
              texttableentry: 'ZigBeeNetworkDeviceFivePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceSixPropertyCoordinator',
              isRead: 'true',
              interval: '2698',
              texttableentry: 'ZigBeeNetworkDeviceSixPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceSevenPropertyCoordinator',
              isRead: 'true',
              interval: '2699',
              texttableentry: 'ZigBeeNetworkDeviceSevenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceEightPropertyCoordinator',
              isRead: 'true',
              interval: '2700',
              texttableentry: 'ZigBeeNetworkDeviceEightPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceNinePropertyCoordinator',
              isRead: 'true',
              interval: '2701',
              texttableentry: 'ZigBeeNetworkDeviceNinePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTenPropertyCoordinator',
              isRead: 'true',
              interval: '2702',
              texttableentry: 'ZigBeeNetworkDeviceTenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceElevenPropertyCoordinator',
              isRead: 'true',
              interval: '2703',
              texttableentry: 'ZigBeeNetworkDeviceElevenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwelvePropertyCoordinator',
              isRead: 'true',
              interval: '2704',
              texttableentry: 'ZigBeeNetworkDeviceTwelvePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirTeenPropertyCoordinator',
              isRead: 'true',
              interval: '2705',
              texttableentry: 'ZigBeeNetworkDeviceThirTeenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceFourTeenPropertyCoordinator',
              isRead: 'true',
              interval: '2706',
              texttableentry: 'ZigBeeNetworkDeviceFourTeenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceFifteenPropertyCoordinator',
              isRead: 'true',
              interval: '2707',
              texttableentry: 'ZigBeeNetworkDeviceFifteenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceSixteenPropertyCoordinator',
              isRead: 'true',
              interval: '2708',
              texttableentry: 'ZigBeeNetworkDeviceSixteenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceSeventeenPropertyCoordinator',
              isRead: 'true',
              interval: '2709',
              texttableentry: 'ZigBeeNetworkDeviceSeventeenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceEighteenPropertyCoordinator',
              isRead: 'true',
              interval: '2710',
              texttableentry: 'ZigBeeNetworkDeviceEighteenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceNineteenPropertyCoordinator',
              isRead: 'true',
              interval: '2711',
              texttableentry: 'ZigBeeNetworkDeviceNineteenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyPropertyCoordinator',
              isRead: 'true',
              interval: '2712',
              texttableentry: 'ZigBeeNetworkDeviceTwentyPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyOnePropertyCoordinator',
              isRead: 'true',
              interval: '2713',
              texttableentry: 'ZigBeeNetworkDeviceTwentyOnePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyTwoPropertyCoordinator',
              isRead: 'true',
              interval: '2714',
              texttableentry: 'ZigBeeNetworkDeviceTwentyTwoPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyThreePropertyCoordinator',
              isRead: 'true',
              interval: '2715',
              texttableentry: 'ZigBeeNetworkDeviceTwentyThreePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyFourPropertyCoordinator',
              isRead: 'true',
              interval: '2716',
              texttableentry: 'ZigBeeNetworkDeviceTwentyFourPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyFivePropertyCoordinator',
              isRead: 'true',
              interval: '2717',
              texttableentry: 'ZigBeeNetworkDeviceTwentyFivePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentySixPropertyCoordinator',
              isRead: 'true',
              interval: '2718',
              texttableentry: 'ZigBeeNetworkDeviceTwentySixPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentySevenPropertyCoordinator',
              isRead: 'true',
              interval: '2719',
              texttableentry: 'ZigBeeNetworkDeviceTwentySevenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyEightPropertyCoordinator',
              isRead: 'true',
              interval: '2720',
              texttableentry: 'ZigBeeNetworkDeviceTwentyEightPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceTwentyNinePropertyCoordinator',
              isRead: 'true',
              interval: '2721',
              texttableentry: 'ZigBeeNetworkDeviceTwentyNinePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyPropertyCoordinator',
              isRead: 'true',
              interval: '2722',
              texttableentry: 'ZigBeeNetworkDeviceThirtyPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyOnePropertyCoordinator',
              isRead: 'true',
              interval: '2723',
              texttableentry: 'ZigBeeNetworkDeviceThirtyOnePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyTwoPropertyCoordinator',
              isRead: 'true',
              interval: '2724',
              texttableentry: 'ZigBeeNetworkDeviceThirtyTwoPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyThreePropertyCoordinator',
              isRead: 'true',
              interval: '2725',
              texttableentry: 'ZigBeeNetworkDeviceThirtyThreePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyFourPropertyCoordinator',
              isRead: 'true',
              interval: '2726',
              texttableentry: 'ZigBeeNetworkDeviceThirtyFourPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyFivePropertyCoordinator',
              isRead: 'true',
              interval: '2727',
              texttableentry: 'ZigBeeNetworkDeviceThirtyFivePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtySixPropertyCoordinator',
              isRead: 'true',
              interval: '2728',
              texttableentry: 'ZigBeeNetworkDeviceThirtySixPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtySevenPropertyCoordinator',
              isRead: 'true',
              interval: '2729',
              texttableentry: 'ZigBeeNetworkDeviceThirtySevenPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyEightPropertyCoordinator',
              isRead: 'true',
              interval: '2730',
              texttableentry: 'ZigBeeNetworkDeviceThirtyEightPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceThirtyNinePropertyCoordinator',
              isRead: 'true',
              interval: '2731',
              texttableentry: 'ZigBeeNetworkDeviceThirtyNinePropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNetworkDeviceFourtyPropertyCoordinator',
              isRead: 'true',
              interval: '2732',
              texttableentry: 'ZigBeeNetworkDeviceFourtyPropertyCoordinator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InstallationConfirmation',
              isRead: 'true',
              interval: '2733',
              texttableentry: 'InstallationConfirmation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ComfortEnsuranceHistory',
              isRead: 'true',
              interval: '2734',
              texttableentry: 'ComfortEnsuranceHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FourThreeWayValveValveCurrentPosition',
              isRead: 'true',
              interval: '2735',
              texttableentry: 'FourThreeWayValveValveCurrentPosition',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputSevenValue',
              isRead: 'true',
              interval: '2736',
              texttableentry: 'DeviceDigitalOutputSevenValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputEightValue',
              isRead: 'true',
              interval: '2737',
              texttableentry: 'DeviceDigitalOutputEightValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputNineValue',
              isRead: 'true',
              interval: '2738',
              texttableentry: 'DeviceDigitalOutputNineValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTenValue',
              isRead: 'true',
              interval: '2739',
              texttableentry: 'DeviceDigitalOutputTenValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputElevenValue',
              isRead: 'true',
              interval: '2740',
              texttableentry: 'DeviceDigitalOutputElevenValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ComfortEnsuringMode',
              isRead: 'true',
              interval: '2741',
              texttableentry: 'ComfortEnsuringMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterInterval',
              isRead: 'true',
              interval: '2742',
              texttableentry: 'DiagnosticHydraulicFilterInterval',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticElectricalHeaterSafetyTemperatureLimiter',
              isRead: 'true',
              interval: '2743',
              texttableentry: 'DiagnosticElectricalHeaterSafetyTemperatureLimiter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticSecondaryFourThreeWayValve',
              isRead: 'true',
              interval: '2744',
              texttableentry: 'DiagnosticSecondaryFourThreeWayValve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterContamination',
              isRead: 'true',
              interval: '2745',
              texttableentry: 'DiagnosticHydraulicFilterContamination',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicSafetyValve',
              isRead: 'true',
              interval: '2746',
              texttableentry: 'DiagnosticHydraulicSafetyValve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterIdentification',
              isRead: 'true',
              interval: '2747',
              texttableentry: 'DiagnosticHydraulicFilterIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticControlledLowPressureShutDown',
              isRead: 'true',
              interval: '2748',
              texttableentry: 'DiagnosticControlledLowPressureShutDown',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticControlledHighPressureShutDown',
              isRead: 'true',
              interval: '2749',
              texttableentry: 'DiagnosticControlledHighPressureShutDown',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicTemperatureSensors',
              isRead: 'true',
              interval: '2750',
              texttableentry: 'DiagnosticHydraulicTemperatureSensors',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticElectronicExpansionValve',
              isRead: 'true',
              interval: '2751',
              texttableentry: 'DiagnosticElectronicExpansionValve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticFanOperation',
              isRead: 'true',
              interval: '2752',
              texttableentry: 'DiagnosticFanOperation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHeatExchangerConstraints',
              isRead: 'true',
              interval: '2753',
              texttableentry: 'DiagnosticHeatExchangerConstraints',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasVolumeFactoryOffset',
              isRead: 'true',
              interval: '2754',
              texttableentry: 'GasVolumeFactoryOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpSevenValue',
              isRead: 'true',
              interval: '2755',
              texttableentry: 'AccessoryPumpSevenValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpSevenStatistical',
              isRead: 'true',
              interval: '2756',
              texttableentry: 'AccessoryPumpSevenStatistical',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AnalogOutputZeroToTenTwoValue',
              isRead: 'true',
              interval: '2757',
              texttableentry: 'AnalogOutputZeroToTenTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasPressureSwitchErrorReaction',
              isRead: 'true',
              interval: '2758',
              texttableentry: 'GasPressureSwitchErrorReaction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyRecoveredCrossHeatExchanger',
              isRead: 'true',
              interval: '2759',
              texttableentry: 'EnergyRecoveredCrossHeatExchanger',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyOwnConsumption',
              isRead: 'true',
              interval: '2760',
              texttableentry: 'EnergyOwnConsumption',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitPumpDeltaTemperatureValue',
              isRead: 'true',
              interval: '2761',
              texttableentry: 'PrimaryCircuitPumpDeltaTemperatureValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoolingControlPid',
              isRead: 'true',
              interval: '2762',
              texttableentry: 'CoolingControlPid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatingControlPid',
              isRead: 'true',
              interval: '2763',
              texttableentry: 'HeatingControlPid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterControlPid',
              isRead: 'true',
              interval: '2764',
              texttableentry: 'DomesticHotWaterControlPid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LoadBufferControlPid',
              isRead: 'true',
              interval: '2765',
              texttableentry: 'LoadBufferControlPid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UnloadBufferControlPid',
              isRead: 'true',
              interval: '2766',
              texttableentry: 'UnloadBufferControlPid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticMonitoringPressureDrop',
              isRead: 'true',
              interval: '2767',
              texttableentry: 'DiagnosticMonitoringPressureDrop',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticMonitoringPressurePeaks',
              isRead: 'true',
              interval: '2768',
              texttableentry: 'DiagnosticMonitoringPressurePeaks',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryPumpMassflowControlPID',
              isRead: 'true',
              interval: '2769',
              texttableentry: 'SecondaryPumpMassflowControlPID',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatingCoolingCircuitTwoPumpMassflowControlPID',
              isRead: 'true',
              interval: '2770',
              texttableentry: 'HeatingCoolingCircuitTwoPumpMassflowControlPID',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericHioAccessoryModuleFunction',
              isRead: 'true',
              interval: '2771',
              texttableentry: 'GenericHioAccessoryModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyRecoveredCrossHeatExchangerMonthMatrix',
              isRead: 'true',
              interval: '2772',
              texttableentry: 'EnergyRecoveredCrossHeatExchangerMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyRecoveredCrossHeatExchangerYearMatrix',
              isRead: 'true',
              interval: '2773',
              texttableentry: 'EnergyRecoveredCrossHeatExchangerYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyOwnConsumptionMonthMatrix',
              isRead: 'true',
              interval: '2774',
              texttableentry: 'EnergyOwnConsumptionMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyOwnConsumptionYearMatrix',
              isRead: 'true',
              interval: '2775',
              texttableentry: 'EnergyOwnConsumptionYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductMatrixTwo',
              isRead: 'true',
              interval: '2776',
              texttableentry: 'ProductMatrixTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryBootLoaderVersion',
              isRead: 'true',
              interval: '2777',
              texttableentry: 'PrimaryBootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorMessageInputSelection',
              isRead: 'true',
              interval: '2778',
              texttableentry: 'ErrorMessageInputSelection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeltaTemperaturePumpControlSetpoint',
              isRead: 'true',
              interval: '2779',
              texttableentry: 'DeltaTemperaturePumpControlSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterFlowRangeDwellDuration',
              isRead: 'true',
              interval: '2780',
              texttableentry: 'DomesticHotWaterFlowRangeDwellDuration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AirVolumeFlowSetpoint',
              isRead: 'true',
              interval: '2781',
              texttableentry: 'AirVolumeFlowSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AirVolumeFlowStatus',
              isRead: 'true',
              interval: '2782',
              texttableentry: 'AirVolumeFlowStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationSelfCheckDuration',
              isRead: 'true',
              interval: '2783',
              texttableentry: 'VentilationSelfCheckDuration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerVaporPressureSensor',
              isRead: 'true',
              interval: '2784',
              texttableentry: 'SecondaryHeatExchangerVaporPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterStarts',
              isRead: 'true',
              interval: '2785',
              texttableentry: 'ElectricalHeaterStarts',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPreheaterCurrentPowerConsumption',
              isRead: 'true',
              interval: '2786',
              texttableentry: 'ElectricalPreheaterCurrentPowerConsumption',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalChargeDischargeSetpoint',
              isRead: 'true',
              interval: '2787',
              texttableentry: 'ElectricalChargeDischargeSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalChargeDischargeStatus',
              isRead: 'true',
              interval: '2788',
              texttableentry: 'ElectricalChargeDischargeStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BurnerTargetTestMode',
              isRead: 'true',
              interval: '2789',
              texttableentry: 'BurnerTargetTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BurnerCurrentTestMode',
              isRead: 'true',
              interval: '2790',
              texttableentry: 'BurnerCurrentTestMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpStatus',
              isRead: 'true',
              interval: '2791',
              texttableentry: 'CentralHeatingPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpStatus',
              isRead: 'true',
              interval: '2792',
              texttableentry: 'MixerOneCircuitPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpStatus',
              isRead: 'true',
              interval: '2793',
              texttableentry: 'MixerTwoCircuitPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpStatus',
              isRead: 'true',
              interval: '2794',
              texttableentry: 'MixerThreeCircuitPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpStatus',
              isRead: 'true',
              interval: '2795',
              texttableentry: 'MixerFourCircuitPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterConfiguration',
              isRead: 'true',
              interval: '2796',
              texttableentry: 'ExternalHeaterConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationBypassFlapAvailableCount',
              isRead: 'true',
              interval: '2797',
              texttableentry: 'VentilationBypassFlapAvailableCount',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RelativeHumiditySensorSelection',
              isRead: 'true',
              interval: '2798',
              texttableentry: 'RelativeHumiditySensorSelection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeatersShutdownDelay',
              isRead: 'true',
              interval: '2799',
              texttableentry: 'ElectricalHeatersShutdownDelay',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationHeatExchangerType',
              isRead: 'true',
              interval: '2800',
              texttableentry: 'VentilationHeatExchangerType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationFanAssignmentSwitchManufacturing',
              isRead: 'true',
              interval: '2801',
              texttableentry: 'VentilationFanAssignmentSwitchManufacturing',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterSelfTestStatus',
              isRead: 'true',
              interval: '2802',
              texttableentry: 'InverterSelfTestStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterSelfTestResultOne',
              isRead: 'true',
              interval: '2803',
              texttableentry: 'InverterSelfTestResultOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterSelfTestResultTwo',
              isRead: 'true',
              interval: '2804',
              texttableentry: 'InverterSelfTestResultTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterSelfTestResultThree',
              isRead: 'true',
              interval: '2805',
              texttableentry: 'InverterSelfTestResultThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerationCircuitOperationMode',
              isRead: 'true',
              interval: '2806',
              texttableentry: 'RefrigerationCircuitOperationMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InverterHousingTemperature',
              isRead: 'true',
              interval: '2807',
              texttableentry: 'InverterHousingTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InverterInternalPowerModuleTemperature',
              isRead: 'true',
              interval: '2808',
              texttableentry: 'InverterInternalPowerModuleTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PumpMinSpeedConfiguration',
              isRead: 'true',
              interval: '2809',
              texttableentry: 'PumpMinSpeedConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpFeedbackSignalHandlingMode',
              isRead: 'true',
              interval: '2810',
              texttableentry: 'CentralHeatingPumpFeedbackSignalHandlingMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagOne',
              isRead: 'true',
              interval: '2811',
              texttableentry: 'CascadeOxygenStatisticsLagOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagTwo',
              isRead: 'true',
              interval: '2812',
              texttableentry: 'CascadeOxygenStatisticsLagTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagThree',
              isRead: 'true',
              interval: '2813',
              texttableentry: 'CascadeOxygenStatisticsLagThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagFour',
              isRead: 'true',
              interval: '2814',
              texttableentry: 'CascadeOxygenStatisticsLagFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagFive',
              isRead: 'true',
              interval: '2815',
              texttableentry: 'CascadeOxygenStatisticsLagFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagSix',
              isRead: 'true',
              interval: '2816',
              texttableentry: 'CascadeOxygenStatisticsLagSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagSeven',
              isRead: 'true',
              interval: '2817',
              texttableentry: 'CascadeOxygenStatisticsLagSeven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagEight',
              isRead: 'true',
              interval: '2818',
              texttableentry: 'CascadeOxygenStatisticsLagEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagNine',
              isRead: 'true',
              interval: '2819',
              texttableentry: 'CascadeOxygenStatisticsLagNine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagTen',
              isRead: 'true',
              interval: '2820',
              texttableentry: 'CascadeOxygenStatisticsLagTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagEleven',
              isRead: 'true',
              interval: '2821',
              texttableentry: 'CascadeOxygenStatisticsLagEleven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagTwelve',
              isRead: 'true',
              interval: '2822',
              texttableentry: 'CascadeOxygenStatisticsLagTwelve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagThirteen',
              isRead: 'true',
              interval: '2823',
              texttableentry: 'CascadeOxygenStatisticsLagThirteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagFouteen',
              isRead: 'true',
              interval: '2824',
              texttableentry: 'CascadeOxygenStatisticsLagFouteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagFifteen',
              isRead: 'true',
              interval: '2825',
              texttableentry: 'CascadeOxygenStatisticsLagFifteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellNetworkSystemProtectionErrorHistory',
              isRead: 'true',
              interval: '2826',
              texttableentry: 'FuelCellNetworkSystemProtectionErrorHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellNetworkSystemProtectionParameters',
              isRead: 'true',
              interval: '2827',
              texttableentry: 'FuelCellNetworkSystemProtectionParameters',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellSdCardRecording',
              isRead: 'true',
              interval: '2828',
              texttableentry: 'FuelCellSdCardRecording',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductIdentification',
              isRead: 'true',
              interval: '2829',
              texttableentry: 'ProductIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EmergencyMode',
              isRead: 'true',
              interval: '2830',
              texttableentry: 'EmergencyMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BivalenceControlAlternativeTemperature',
              isRead: 'true',
              interval: '2831',
              texttableentry: 'BivalenceControlAlternativeTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BaseHeaterTimer',
              isRead: 'true',
              interval: '2832',
              texttableentry: 'BaseHeaterTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BaseHeaterTimerMode',
              isRead: 'true',
              interval: '2833',
              texttableentry: 'BaseHeaterTimerMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BaseHeaterTimerDuration',
              isRead: 'true',
              interval: '2834',
              texttableentry: 'BaseHeaterTimerDuration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BaseHeaterTemperatureThreshold',
              isRead: 'true',
              interval: '2835',
              texttableentry: 'BaseHeaterTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerMinimumVolumeFlowThreshold',
              isRead: 'true',
              interval: '2836',
              texttableentry: 'SecondaryHeatExchangerMinimumVolumeFlowThreshold',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerOptimumTemperatureSpreadExponent',
              isRead: 'true',
              interval: '2837',
              texttableentry: 'SecondaryHeatExchangerOptimumTemperatureSpreadExponent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerOptimumTemperatureSpreadHeating',
              isRead: 'true',
              interval: '2838',
              texttableentry: 'SecondaryHeatExchangerOptimumTemperatureSpreadHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerOptimumTemperatureSpreadCooling',
              isRead: 'true',
              interval: '2839',
              texttableentry: 'SecondaryHeatExchangerOptimumTemperatureSpreadCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerOptimumVolumeFlowDefrost',
              isRead: 'true',
              interval: '2840',
              texttableentry: 'SecondaryHeatExchangerOptimumVolumeFlowDefrost',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerHxModuleAvailabilty',
              isRead: 'true',
              interval: '2841',
              texttableentry: 'SecondaryHeatExchangerHxModuleAvailabilty',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerHxSubcooling',
              isRead: 'true',
              interval: '2842',
              texttableentry: 'SecondaryHeatExchangerHxSubcooling',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerMinimumVolumeFlow',
              isRead: 'true',
              interval: '2843',
              texttableentry: 'SecondaryHeatExchangerMinimumVolumeFlow',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerMinimumOutletTemperature',
              isRead: 'true',
              interval: '2844',
              texttableentry: 'SecondaryHeatExchangerMinimumOutletTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerMaximumOutletTemperature',
              isRead: 'true',
              interval: '2845',
              texttableentry: 'SecondaryHeatExchangerMaximumOutletTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationBypassDynamicVentilationLevel',
              isRead: 'true',
              interval: '2846',
              texttableentry: 'VentilationBypassDynamicVentilationLevel',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FourWayValveCounterStatistic',
              isRead: 'true',
              interval: '2847',
              texttableentry: 'FourWayValveCounterStatistic',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CrankCaseHeaterTemperatureStatistics',
              isRead: 'true',
              interval: '2848',
              texttableentry: 'CrankCaseHeaterTemperatureStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormSeven',
              isRead: 'true',
              interval: '2849',
              texttableentry: 'PowerGridCodeSettingsNormSeven',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InstalledHeater',
              isRead: 'true',
              interval: '2850',
              texttableentry: 'InstalledHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PreStartDuration',
              isRead: 'true',
              interval: '2851',
              texttableentry: 'PreStartDuration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FanDuctHeater',
              isRead: 'true',
              interval: '2852',
              texttableentry: 'FanDuctHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterTimeIntegralThershold',
              isRead: 'true',
              interval: '2853',
              texttableentry: 'ExternalHeaterTimeIntegralThershold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ConfiguredAdditionalDevices',
              isRead: 'true',
              interval: '2854',
              texttableentry: 'ConfiguredAdditionalDevices',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2855',
              texttableentry: 'MixerOneCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2856',
              texttableentry: 'MixerTwoCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2857',
              texttableentry: 'MixerThreeCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2858',
              texttableentry: 'MixerFourCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2859',
              texttableentry: 'MixerFiveCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2860',
              texttableentry: 'MixerSixCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2861',
              texttableentry: 'MixerSevenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2862',
              texttableentry: 'MixerEightCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2863',
              texttableentry: 'MixerNineCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2864',
              texttableentry: 'MixerTenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2865',
              texttableentry: 'MixerElevenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2866',
              texttableentry: 'MixerTwelveCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2867',
              texttableentry: 'MixerThirteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2868',
              texttableentry: 'MixerFourteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2869',
              texttableentry: 'MixerFifteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2870',
              texttableentry: 'MixerSixteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UpdateOxygenProbeCurrentValueCompensationOffsetMeasurement',
              isRead: 'true',
              interval: '2871',
              texttableentry: 'UpdateOxygenProbeCurrentValueCompensationOffsetMeasurement',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EepromOxygenProbeCurrentValueCompensationOffset',
              isRead: 'true',
              interval: '2872',
              texttableentry: 'EepromOxygenProbeCurrentValueCompensationOffset',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FanHeightCorrectionFactor',
              isRead: 'true',
              interval: '2873',
              texttableentry: 'FanHeightCorrectionFactor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimarySourceRpsOne',
              isRead: 'true',
              interval: '2874',
              texttableentry: 'PrimarySourceRpsOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimarySourceRpsTwo',
              isRead: 'true',
              interval: '2875',
              texttableentry: 'PrimarySourceRpsTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryPumpCommonSetpoint',
              isRead: 'true',
              interval: '2876',
              texttableentry: 'PrimaryPumpCommonSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SuctionSuperheatSetpoint',
              isRead: 'true',
              interval: '2877',
              texttableentry: 'SuctionSuperheatSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SubcoolingSetpoint',
              isRead: 'true',
              interval: '2878',
              texttableentry: 'SubcoolingSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitHeatingBlocked',
              isRead: 'true',
              interval: '2879',
              texttableentry: 'MixerOneCircuitHeatingBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitHeatingBlocked',
              isRead: 'true',
              interval: '2880',
              texttableentry: 'MixerTwoCircuitHeatingBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExpansionValveOneTimer',
              isRead: 'true',
              interval: '2881',
              texttableentry: 'ExpansionValveOneTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExpansionValveTwoTimer',
              isRead: 'true',
              interval: '2882',
              texttableentry: 'ExpansionValveTwoTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExpansionValveMaximumOperatingPressureTemperatureSetpoint',
              isRead: 'true',
              interval: '2883',
              texttableentry: 'ExpansionValveMaximumOperatingPressureTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExpansionValveOneStatus',
              isRead: 'true',
              interval: '2884',
              texttableentry: 'ExpansionValveOneStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExpansionValveTwoStatus',
              isRead: 'true',
              interval: '2885',
              texttableentry: 'ExpansionValveTwoStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCyclePostStopDuration',
              isRead: 'true',
              interval: '2886',
              texttableentry: 'RefrigerantCyclePostStopDuration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCycleAlarmPauseDuration',
              isRead: 'true',
              interval: '2887',
              texttableentry: 'RefrigerantCycleAlarmPauseDuration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCyclePumpdownStoppingDelay',
              isRead: 'true',
              interval: '2888',
              texttableentry: 'RefrigerantCyclePumpdownStoppingDelay',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCycleTimers',
              isRead: 'true',
              interval: '2889',
              texttableentry: 'RefrigerantCycleTimers',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCyclePumpdownHoldTimer',
              isRead: 'true',
              interval: '2890',
              texttableentry: 'RefrigerantCyclePumpdownHoldTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCycleDefrostTimers',
              isRead: 'true',
              interval: '2891',
              texttableentry: 'RefrigerantCycleDefrostTimers',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCycleTransitionToHeatingTimer',
              isRead: 'true',
              interval: '2892',
              texttableentry: 'RefrigerantCycleTransitionToHeatingTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCycleTransitionToCoolingTimer',
              isRead: 'true',
              interval: '2893',
              texttableentry: 'RefrigerantCycleTransitionToCoolingTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCycleAvailability',
              isRead: 'true',
              interval: '2894',
              texttableentry: 'RefrigerantCycleAvailability',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryPumpSettings',
              isRead: 'true',
              interval: '2895',
              texttableentry: 'PrimaryPumpSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryPumpOneStatus',
              isRead: 'true',
              interval: '2896',
              texttableentry: 'PrimaryPumpOneStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryPumpTwoStatus',
              isRead: 'true',
              interval: '2897',
              texttableentry: 'PrimaryPumpTwoStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EcuDeviceAssignment',
              isRead: 'true',
              interval: '2898',
              texttableentry: 'EcuDeviceAssignment',
              isWrite: 'false',
            },
            {
              TI_texttableentry:
                'TI_ExpansionValveOneEqualPercentageSetpointExceedingThresholdTimer',
              isRead: 'true',
              interval: '2899',
              texttableentry: 'ExpansionValveOneEqualPercentageSetpointExceedingThresholdTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry:
                'TI_ExpansionValveTwoEqualPercentageSetpointExceedingThresholdTimer',
              isRead: 'true',
              interval: '2900',
              texttableentry: 'ExpansionValveTwoEqualPercentageSetpointExceedingThresholdTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExpansionValveModuleAvailabilty',
              isRead: 'true',
              interval: '2901',
              texttableentry: 'ExpansionValveModuleAvailabilty',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerModuleAvailabilty',
              isRead: 'true',
              interval: '2902',
              texttableentry: 'PrimaryHeatExchangerModuleAvailabilty',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LowEvaporatingTemperatureAlarmTimer',
              isRead: 'true',
              interval: '2903',
              texttableentry: 'LowEvaporatingTemperatureAlarmTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryPumpOneDtcErrorTimer',
              isRead: 'true',
              interval: '2904',
              texttableentry: 'PrimaryPumpOneDtcErrorTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryPumpTwoDtcErrorTimer',
              isRead: 'true',
              interval: '2905',
              texttableentry: 'PrimaryPumpTwoDtcErrorTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryPumpDtcErrorDelay',
              isRead: 'true',
              interval: '2906',
              texttableentry: 'PrimaryPumpDtcErrorDelay',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryPumpModuleAvailabilty',
              isRead: 'true',
              interval: '2907',
              texttableentry: 'PrimaryPumpModuleAvailabilty',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InverterModuleType',
              isRead: 'true',
              interval: '2908',
              texttableentry: 'InverterModuleType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMinMaxRequestedSecondaryReturnTemperatureCooling',
              isRead: 'true',
              interval: '2909',
              texttableentry: 'CompressorMinMaxRequestedSecondaryReturnTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry:
                'TI_CompressorMinMaxRequestedSecondaryReturnTemperaturePreStartDefrost',
              isRead: 'true',
              interval: '2910',
              texttableentry: 'CompressorMinMaxRequestedSecondaryReturnTemperaturePreStartDefrost',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMaximumRequestedSecondaryReturnTempDefrost',
              isRead: 'true',
              interval: '2911',
              texttableentry: 'CompressorMaximumRequestedSecondaryReturnTempDefrost',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMaximumDischargeTemperature',
              isRead: 'true',
              interval: '2912',
              texttableentry: 'CompressorMaximumDischargeTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMinimumAllowedSecondaryOutletTemperatureHeating',
              isRead: 'true',
              interval: '2913',
              texttableentry: 'CompressorMinimumAllowedSecondaryOutletTemperatureHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMinMaxAllowedPrimaryTemperatureCooling',
              isRead: 'true',
              interval: '2914',
              texttableentry: 'CompressorMinMaxAllowedPrimaryTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMaximumCondensingPressure',
              isRead: 'true',
              interval: '2915',
              texttableentry: 'CompressorMaximumCondensingPressure',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMaximumEvaporatingPressure',
              isRead: 'true',
              interval: '2916',
              texttableentry: 'CompressorMaximumEvaporatingPressure',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMinimumEvaporatingPressureHeating',
              isRead: 'true',
              interval: '2917',
              texttableentry: 'CompressorMinimumEvaporatingPressureHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMinimumEvaporatingPressureCooling',
              isRead: 'true',
              interval: '2918',
              texttableentry: 'CompressorMinimumEvaporatingPressureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMaximumRequestedSecondaryReturnTemperatureHeating',
              isRead: 'true',
              interval: '2919',
              texttableentry: 'CompressorMaximumRequestedSecondaryReturnTemperatureHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterSpecification',
              isRead: 'true',
              interval: '2920',
              texttableentry: 'ExternalHeaterSpecification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterIntervalSettings',
              isRead: 'true',
              interval: '2921',
              texttableentry: 'DiagnosticHydraulicFilterIntervalSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterIntervalTemporalSettings',
              isRead: 'true',
              interval: '2922',
              texttableentry: 'DiagnosticHydraulicFilterIntervalTemporalSettings',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiagnosticSecondaryFourThreeWayValveSettings',
              isRead: 'true',
              interval: '2923',
              texttableentry: 'DiagnosticSecondaryFourThreeWayValveSettings',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterContaminationSettings',
              isRead: 'true',
              interval: '2924',
              texttableentry: 'DiagnosticHydraulicFilterContaminationSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticMonitoringPressurePeaksSettings',
              isRead: 'true',
              interval: '2925',
              texttableentry: 'DiagnosticMonitoringPressurePeaksSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticMonitoringPressureDropSettings',
              isRead: 'true',
              interval: '2926',
              texttableentry: 'DiagnosticMonitoringPressureDropSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticElectronicExpansionValveSettings',
              isRead: 'true',
              interval: '2927',
              texttableentry: 'DiagnosticElectronicExpansionValveSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHeatExchangerConstraintsSettings',
              isRead: 'true',
              interval: '2928',
              texttableentry: 'DiagnosticHeatExchangerConstraintsSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticRefrigerantCircuitPressureSensors',
              isRead: 'true',
              interval: '2929',
              texttableentry: 'DiagnosticRefrigerantCircuitPressureSensors',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticRefrigerantCircuitFourTwoWayValve',
              isRead: 'true',
              interval: '2930',
              texttableentry: 'DiagnosticRefrigerantCircuitFourTwoWayValve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticRefrigerantCircuitTemperatureSensors',
              isRead: 'true',
              interval: '2931',
              texttableentry: 'DiagnosticRefrigerantCircuitTemperatureSensors',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeCounterSinceLastReset',
              isRead: 'true',
              interval: '2932',
              texttableentry: 'TimeCounterSinceLastReset',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyMeterFunction',
              isRead: 'true',
              interval: '2933',
              texttableentry: 'EnergyMeterFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentElectricalSystemPowerSetpoint',
              isRead: 'true',
              interval: '2934',
              texttableentry: 'CurrentElectricalSystemPowerSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentSystemState',
              isRead: 'true',
              interval: '2935',
              texttableentry: 'CurrentSystemState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageSystemState',
              isRead: 'true',
              interval: '2936',
              texttableentry: 'ElectricalEnergyStorageSystemState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SystemPumpConfiguration',
              isRead: 'true',
              interval: '2937',
              texttableentry: 'SystemPumpConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeSystemPump',
              isRead: 'true',
              interval: '2938',
              texttableentry: 'CascadeSystemPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerLowEvaporatingTemperatureAlarmDelay',
              isRead: 'true',
              interval: '2939',
              texttableentry: 'PrimaryHeatExchangerLowEvaporatingTemperatureAlarmDelay',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterDelayTimer',
              isRead: 'true',
              interval: '2940',
              texttableentry: 'ExternalHeaterDelayTimer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PumpdownControl',
              isRead: 'true',
              interval: '2941',
              texttableentry: 'PumpdownControl',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ListOfLayerSettingServiceDevices',
              isRead: 'true',
              interval: '2942',
              texttableentry: 'ListOfLayerSettingServiceDevices',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetSystemDeviceList',
              isRead: 'true',
              interval: '2943',
              texttableentry: 'ResetSystemDeviceList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NodeIdOnExternalCan',
              isRead: 'true',
              interval: '2944',
              texttableentry: 'NodeIdOnExternalCan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingEnergyMeterConnectedPhases',
              isRead: 'true',
              interval: '2945',
              texttableentry: 'PointOfCommonCouplingEnergyMeterConnectedPhases',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionElectricalPreHeater',
              isRead: 'true',
              interval: '2946',
              texttableentry: 'EnergyConsumptionElectricalPreHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SleepModePrevention',
              isRead: 'true',
              interval: '2947',
              texttableentry: 'SleepModePrevention',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WaterLeakageSensorTwo',
              isRead: 'true',
              interval: '2948',
              texttableentry: 'WaterLeakageSensorTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WaterLeakageSensorThree',
              isRead: 'true',
              interval: '2949',
              texttableentry: 'WaterLeakageSensorThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WaterLeakageSensorFour',
              isRead: 'true',
              interval: '2950',
              texttableentry: 'WaterLeakageSensorFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WaterLeakageSensorFive',
              isRead: 'true',
              interval: '2951',
              texttableentry: 'WaterLeakageSensorFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ListOfLayerSettingServiceDevicesTwo',
              isRead: 'true',
              interval: '2952',
              texttableentry: 'ListOfLayerSettingServiceDevicesTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeSystemConfigurationArray',
              isRead: 'true',
              interval: '2953',
              texttableentry: 'CascadeSystemConfigurationArray',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellFuelProcessorTemperatures',
              isRead: 'true',
              interval: '2954',
              texttableentry: 'FuelCellFuelProcessorTemperatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellFuelProcessorProcessWater',
              isRead: 'true',
              interval: '2955',
              texttableentry: 'FuelCellFuelProcessorProcessWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputEightValue',
              isRead: 'true',
              interval: '2956',
              texttableentry: 'DeviceDigitalInputEightValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputNineValue',
              isRead: 'true',
              interval: '2957',
              texttableentry: 'DeviceDigitalInputNineValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ModulationCurrentValueBurnerOne',
              isRead: 'true',
              interval: '2958',
              texttableentry: 'ModulationCurrentValueBurnerOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ModulationTargetSetpointBurnerOne',
              isRead: 'true',
              interval: '2959',
              texttableentry: 'ModulationTargetSetpointBurnerOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ModulationTargetSetpointBurnerTwo',
              isRead: 'true',
              interval: '2960',
              texttableentry: 'ModulationTargetSetpointBurnerTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlameBurnerOne',
              isRead: 'true',
              interval: '2961',
              texttableentry: 'FlameBurnerOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatEngineStatisticalBurnerOne',
              isRead: 'true',
              interval: '2962',
              texttableentry: 'HeatEngineStatisticalBurnerOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionElectricalBaseHeater',
              isRead: 'true',
              interval: '2963',
              texttableentry: 'EnergyConsumptionElectricalBaseHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionElectricalBaseHeaterMonthMatrix',
              isRead: 'true',
              interval: '2964',
              texttableentry: 'EnergyConsumptionElectricalBaseHeaterMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionElectricalBaseHeaterYearMatrix',
              isRead: 'true',
              interval: '2965',
              texttableentry: 'EnergyConsumptionElectricalBaseHeaterYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCrankCaseHeater',
              isRead: 'true',
              interval: '2966',
              texttableentry: 'EnergyConsumptionCrankCaseHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCrankCaseHeaterMonthMatrix',
              isRead: 'true',
              interval: '2967',
              texttableentry: 'EnergyConsumptionCrankCaseHeaterMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCrankCaseHeaterYearMatrix',
              isRead: 'true',
              interval: '2968',
              texttableentry: 'EnergyConsumptionCrankCaseHeaterYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellExtendedStatusInformation',
              isRead: 'true',
              interval: '2970',
              texttableentry: 'FuelCellExtendedStatusInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellFuelProcessorOperatingTimeReset',
              isRead: 'true',
              interval: '2971',
              texttableentry: 'FuelCellFuelProcessorOperatingTimeReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThirdPartyDeviceSoftwareInformation',
              isRead: 'true',
              interval: '2972',
              texttableentry: 'ThirdPartyDeviceSoftwareInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellExtendedCounters',
              isRead: 'true',
              interval: '2973',
              texttableentry: 'FuelCellExtendedCounters',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellPrimaryPumpSpeed',
              isRead: 'true',
              interval: '2974',
              texttableentry: 'FuelCellPrimaryPumpSpeed',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellElectricalPowerOutputNet',
              isRead: 'true',
              interval: '2975',
              texttableentry: 'FuelCellElectricalPowerOutputNet',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellControlSequenceNumber',
              isRead: 'true',
              interval: '2976',
              texttableentry: 'FuelCellControlSequenceNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellSystemSeparationCircuitVolumeFlow',
              isRead: 'true',
              interval: '2977',
              texttableentry: 'FuelCellSystemSeparationCircuitVolumeFlow',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellInverter',
              isRead: 'true',
              interval: '2978',
              texttableentry: 'FuelCellInverter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellHousing',
              isRead: 'true',
              interval: '2979',
              texttableentry: 'FuelCellHousing',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellGas',
              isRead: 'true',
              interval: '2980',
              texttableentry: 'FuelCellGas',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellAirStackPreferentialOxidation',
              isRead: 'true',
              interval: '2981',
              texttableentry: 'FuelCellAirStackPreferentialOxidation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellFuelProcessorBurner',
              isRead: 'true',
              interval: '2982',
              texttableentry: 'FuelCellFuelProcessorBurner',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellExhaustGas',
              isRead: 'true',
              interval: '2983',
              texttableentry: 'FuelCellExhaustGas',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellStack',
              isRead: 'true',
              interval: '2984',
              texttableentry: 'FuelCellStack',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterTemperatureSetpoint',
              isRead: 'true',
              interval: '2985',
              texttableentry: 'ExternalHeaterTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterOperationState',
              isRead: 'true',
              interval: '2986',
              texttableentry: 'ExternalHeaterOperationState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCycleUnlock',
              isRead: 'true',
              interval: '2987',
              texttableentry: 'RefrigerantCycleUnlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryModuleCellType',
              isRead: 'true',
              interval: '2988',
              texttableentry: 'ElectricalEnergySystemBatteryModuleCellType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryModuleCount',
              isRead: 'true',
              interval: '2989',
              texttableentry: 'ElectricalEnergySystemBatteryModuleCount',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryCapacityDelta',
              isRead: 'true',
              interval: '2990',
              texttableentry: 'ElectricalEnergySystemBatteryCapacityDelta',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryCapacity',
              isRead: 'true',
              interval: '2991',
              texttableentry: 'ElectricalEnergySystemBatteryCapacity',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemStateOfChargeUseable',
              isRead: 'true',
              interval: '2992',
              texttableentry: 'ElectricalEnergySystemStateOfChargeUseable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ArrayLastFiveEstimatedValuesOfUsableSystemEnergy',
              isRead: 'true',
              interval: '2993',
              texttableentry: 'ArrayLastFiveEstimatedValuesOfUsableSystemEnergy',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryLastForcedBalancingTime',
              isRead: 'true',
              interval: '2994',
              texttableentry: 'ElectricalEnergySystemBatteryLastForcedBalancingTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryLastForcedCalibrationTime',
              isRead: 'true',
              interval: '2995',
              texttableentry: 'ElectricalEnergySystemBatteryLastForcedCalibrationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryAmbientTemperatureHistogramTwoPointFour',
              isRead: 'true',
              interval: '2996',
              texttableentry: 'BatteryAmbientTemperatureHistogramTwoPointFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryTemperatureHistogramTwoPointFour',
              isRead: 'true',
              interval: '2997',
              texttableentry: 'BatteryTemperatureHistogramTwoPointFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareSignalCheckCsc',
              isRead: 'true',
              interval: '2998',
              texttableentry: 'HardwareSignalCheckCsc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeatersOperationHours',
              isRead: 'true',
              interval: '2999',
              texttableentry: 'ElectricalHeatersOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EcuResetInformationList',
              isRead: 'true',
              interval: '3000',
              texttableentry: 'EcuResetInformationList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LowEvaporatingLowCondensingDriveDuration',
              isRead: 'true',
              interval: '3001',
              texttableentry: 'LowEvaporatingLowCondensingDriveDuration',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MidEvaporatingLowCondensingDriveDuration',
              isRead: 'true',
              interval: '3002',
              texttableentry: 'MidEvaporatingLowCondensingDriveDuration',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HighEvaporatingLowCondensingDriveDuration',
              isRead: 'true',
              interval: '3003',
              texttableentry: 'HighEvaporatingLowCondensingDriveDuration',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LowEvaporatingHighCondensingDriveDuration',
              isRead: 'true',
              interval: '3004',
              texttableentry: 'LowEvaporatingHighCondensingDriveDuration',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MidEvaporatingHighCondensingDriveDuration',
              isRead: 'true',
              interval: '3005',
              texttableentry: 'MidEvaporatingHighCondensingDriveDuration',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HighEvaporatingHighCondensingDriveDuration',
              isRead: 'true',
              interval: '3006',
              texttableentry: 'HighEvaporatingHighCondensingDriveDuration',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterSaltLevelSet',
              isRead: 'true',
              interval: '3007',
              texttableentry: 'WaterSaltLevelSet',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FanDuctHeaterOnDuration',
              isRead: 'true',
              interval: '3008',
              texttableentry: 'FanDuctHeaterOnDuration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FanDuctHeaterOnTimer',
              isRead: 'true',
              interval: '3009',
              texttableentry: 'FanDuctHeaterOnTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterControlSet',
              isRead: 'true',
              interval: '3010',
              texttableentry: 'WaterControlSet',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CondensateBlockageDetection',
              isRead: 'true',
              interval: '3011',
              texttableentry: 'CondensateBlockageDetection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellServiceMemory',
              isRead: 'true',
              interval: '3012',
              texttableentry: 'FuelCellServiceMemory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerHybridThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '3013',
              texttableentry: 'MixerHybridThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutdoorMiddleCoilTemperatureSensor',
              isRead: 'true',
              interval: '3014',
              texttableentry: 'OutdoorMiddleCoilTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatSinkTemperatureSensor',
              isRead: 'true',
              interval: '3015',
              texttableentry: 'HeatSinkTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingBufferTemperatureSensor',
              isRead: 'true',
              interval: '3016',
              texttableentry: 'HeatingBufferTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CoolingBufferTemperatureSensor',
              isRead: 'true',
              interval: '3017',
              texttableentry: 'CoolingBufferTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingCoolingBufferTemperatureSensor',
              isRead: 'true',
              interval: '3018',
              texttableentry: 'HeatingCoolingBufferTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOutletTargetTemperature',
              isRead: 'true',
              interval: '3019',
              texttableentry: 'CompressorOutletTargetTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticThermalEnergyConsumptionHeatingCircuit',
              isRead: 'true',
              interval: '3020',
              texttableentry: 'DomesticThermalEnergyConsumptionHeatingCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry:
                'TI_PredictionDomesticThermalEnergyConsumptionHeatingCircuitNextHour',
              isRead: 'true',
              interval: '3021',
              texttableentry: 'PredictionDomesticThermalEnergyConsumptionHeatingCircuitNextHour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticElectricalEnergyConsumptionHistory',
              isRead: 'true',
              interval: '3022',
              texttableentry: 'DomesticElectricalEnergyConsumptionHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticThermalEnergyConsumptionHeatingCircuitHistory',
              isRead: 'true',
              interval: '3023',
              texttableentry: 'DomesticThermalEnergyConsumptionHeatingCircuitHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RunTimeSinceLastStartUp',
              isRead: 'true',
              interval: '3024',
              texttableentry: 'RunTimeSinceLastStartUp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellDiverterValveStatisticalCounterDomesticHotWater',
              isRead: 'true',
              interval: '3025',
              texttableentry: 'FuelCellDiverterValveStatisticalCounterDomesticHotWater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellDiverterValveStatisticalCounterHeatingCircuit',
              isRead: 'true',
              interval: '3026',
              texttableentry: 'FuelCellDiverterValveStatisticalCounterHeatingCircuit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellDiverterValveStatisticalDurationDomesticHotWater',
              isRead: 'true',
              interval: '3027',
              texttableentry: 'FuelCellDiverterValveStatisticalDurationDomesticHotWater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellDiverterValveStatisticalDurationHeatingCircuit',
              isRead: 'true',
              interval: '3028',
              texttableentry: 'FuelCellDiverterValveStatisticalDurationHeatingCircuit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterEfficiencyMode',
              isRead: 'true',
              interval: '3029',
              texttableentry: 'DomesticHotWaterEfficiencyMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterEfficiencyModeAvailability',
              isRead: 'true',
              interval: '3030',
              texttableentry: 'DomesticHotWaterEfficiencyModeAvailability',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalHeater',
              isRead: 'true',
              interval: '3031',
              texttableentry: 'ExternalHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryEnergyFactorElectricity',
              isRead: 'true',
              interval: '3032',
              texttableentry: 'PrimaryEnergyFactorElectricity',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPumpStatus',
              isRead: 'true',
              interval: '3033',
              texttableentry: 'DomesticHotWaterPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterReturnTemperaturTankLoadSystem',
              isRead: 'true',
              interval: '3034',
              texttableentry: 'DomesticHotWaterReturnTemperaturTankLoadSystem',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterFlowTemperaturTankLoadSystem',
              isRead: 'true',
              interval: '3035',
              texttableentry: 'DomesticHotWaterFlowTemperaturTankLoadSystem',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryEnergyFactorExternalHeater',
              isRead: 'true',
              interval: '3036',
              texttableentry: 'PrimaryEnergyFactorExternalHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleMonday',
              isRead: 'true',
              interval: '3037',
              texttableentry: 'ElectricityPriceTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleTuesday',
              isRead: 'true',
              interval: '3038',
              texttableentry: 'ElectricityPriceTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleWednesday',
              isRead: 'true',
              interval: '3039',
              texttableentry: 'ElectricityPriceTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleThursday',
              isRead: 'true',
              interval: '3040',
              texttableentry: 'ElectricityPriceTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleFriday',
              isRead: 'true',
              interval: '3041',
              texttableentry: 'ElectricityPriceTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleSaturday',
              isRead: 'true',
              interval: '3042',
              texttableentry: 'ElectricityPriceTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleSunday',
              isRead: 'true',
              interval: '3043',
              texttableentry: 'ElectricityPriceTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VehicleChargingStationActualElectricCurrentPerPhase',
              isRead: 'true',
              interval: '3044',
              texttableentry: 'VehicleChargingStationActualElectricCurrentPerPhase',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VehicleChargingStationActualElectricPowerPerPhase',
              isRead: 'true',
              interval: '3045',
              texttableentry: 'VehicleChargingStationActualElectricPowerPerPhase',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VehicleChargingStationSession',
              isRead: 'true',
              interval: '3046',
              texttableentry: 'VehicleChargingStationSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricVehicleParameters',
              isRead: 'true',
              interval: '3047',
              texttableentry: 'ElectricVehicleParameters',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VehicleChargingStationCurrentLimit',
              isRead: 'true',
              interval: '3048',
              texttableentry: 'VehicleChargingStationCurrentLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VehicleChargingStationCurrentCurtailment',
              isRead: 'true',
              interval: '3049',
              texttableentry: 'VehicleChargingStationCurrentCurtailment',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ThirdPartyDeviceManufacturer',
              isRead: 'true',
              interval: '3050',
              texttableentry: 'ThirdPartyDeviceManufacturer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ThirdPartyDeviceModel',
              isRead: 'true',
              interval: '3051',
              texttableentry: 'ThirdPartyDeviceModel',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GridCurrentLimit',
              isRead: 'true',
              interval: '3052',
              texttableentry: 'GridCurrentLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VehicleChargingStationControlSettings',
              isRead: 'true',
              interval: '3053',
              texttableentry: 'VehicleChargingStationControlSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VehicleChargingStationControlStatus',
              isRead: 'true',
              interval: '3054',
              texttableentry: 'VehicleChargingStationControlStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_NarrowBandInternetOfThingsNetworkOperatorConfiguration',
              isRead: 'true',
              interval: '3055',
              texttableentry: 'NarrowBandInternetOfThingsNetworkOperatorConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NarrowBandInternetOfThingsNetworkStatus',
              isRead: 'true',
              interval: '3056',
              texttableentry: 'NarrowBandInternetOfThingsNetworkStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_NarrowBandInternetOfThingsCloudStatus',
              isRead: 'true',
              interval: '3057',
              texttableentry: 'NarrowBandInternetOfThingsCloudStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EebusPartnerInfoTwo',
              isRead: 'true',
              interval: '3058',
              texttableentry: 'EebusPartnerInfoTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusConnectionStatusTwo',
              isRead: 'true',
              interval: '3059',
              texttableentry: 'EebusConnectionStatusTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListSix',
              isRead: 'true',
              interval: '3060',
              texttableentry: 'EebusDeviceListSix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListSeven',
              isRead: 'true',
              interval: '3061',
              texttableentry: 'EebusDeviceListSeven',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListEight',
              isRead: 'true',
              interval: '3062',
              texttableentry: 'EebusDeviceListEight',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListNine',
              isRead: 'true',
              interval: '3063',
              texttableentry: 'EebusDeviceListNine',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListTen',
              isRead: 'true',
              interval: '3064',
              texttableentry: 'EebusDeviceListTen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VehicleChargingStationEnergy',
              isRead: 'true',
              interval: '3065',
              texttableentry: 'VehicleChargingStationEnergy',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterHighDemandDetection',
              isRead: 'true',
              interval: '3066',
              texttableentry: 'DomesticHotWaterHighDemandDetection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AirVolumeFlowValue',
              isRead: 'true',
              interval: '3067',
              texttableentry: 'AirVolumeFlowValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpointComfort',
              isRead: 'true',
              interval: '3068',
              texttableentry: 'DomesticHotWaterTemperatureSetpointComfort',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterSensorForDemand',
              isRead: 'true',
              interval: '3069',
              texttableentry: 'DomesticHotWaterSensorForDemand',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BufferTargetOperationMode',
              isRead: 'true',
              interval: '3070',
              texttableentry: 'BufferTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiscoveredAccessoryInfoOne',
              isRead: 'true',
              interval: '3071',
              texttableentry: 'DiscoveredAccessoryInfoOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiscoveredAccessoryInfoTwo',
              isRead: 'true',
              interval: '3072',
              texttableentry: 'DiscoveredAccessoryInfoTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiscoveredAccessoryInfoThree',
              isRead: 'true',
              interval: '3073',
              texttableentry: 'DiscoveredAccessoryInfoThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiscoveredAccessoryInfoFour',
              isRead: 'true',
              interval: '3074',
              texttableentry: 'DiscoveredAccessoryInfoFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiscoveredAccessoryInfoFive',
              isRead: 'true',
              interval: '3075',
              texttableentry: 'DiscoveredAccessoryInfoFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiscoveredAccessoryInfoSix',
              isRead: 'true',
              interval: '3076',
              texttableentry: 'DiscoveredAccessoryInfoSix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiscoveredAccessoryInfoSeven',
              isRead: 'true',
              interval: '3077',
              texttableentry: 'DiscoveredAccessoryInfoSeven',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiscoveredAccessoryInfoEight',
              isRead: 'true',
              interval: '3078',
              texttableentry: 'DiscoveredAccessoryInfoEight',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiscoveredAccessoryInfoNine',
              isRead: 'true',
              interval: '3079',
              texttableentry: 'DiscoveredAccessoryInfoNine',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiscoveredAccessoryInfoTen',
              isRead: 'true',
              interval: '3080',
              texttableentry: 'DiscoveredAccessoryInfoTen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VehicleChargingStationInstallerCurrentLimit',
              isRead: 'true',
              interval: '3081',
              texttableentry: 'VehicleChargingStationInstallerCurrentLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceCurrentConstraints',
              isRead: 'true',
              interval: '3082',
              texttableentry: 'DeviceCurrentConstraints',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BrinePumpPower',
              isRead: 'true',
              interval: '3083',
              texttableentry: 'BrinePumpPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PermanentHeatingControl',
              isRead: 'true',
              interval: '3084',
              texttableentry: 'PermanentHeatingControl',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleOneInformation',
              isRead: 'true',
              interval: '3085',
              texttableentry: 'ElectricalEnergyStorageModuleOneInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleTwoInformation',
              isRead: 'true',
              interval: '3086',
              texttableentry: 'ElectricalEnergyStorageModuleTwoInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleThreeInformation',
              isRead: 'true',
              interval: '3087',
              texttableentry: 'ElectricalEnergyStorageModuleThreeInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleFourInformation',
              isRead: 'true',
              interval: '3088',
              texttableentry: 'ElectricalEnergyStorageModuleFourInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleFiveInformation',
              isRead: 'true',
              interval: '3089',
              texttableentry: 'ElectricalEnergyStorageModuleFiveInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleSixInformation',
              isRead: 'true',
              interval: '3090',
              texttableentry: 'ElectricalEnergyStorageModuleSixInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetTwoEnable',
              isRead: 'true',
              interval: '3091',
              texttableentry: 'GatewayEthernetTwoEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetTwoConfig',
              isRead: 'true',
              interval: '3092',
              texttableentry: 'GatewayEthernetTwoConfig',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetTwoIp',
              isRead: 'true',
              interval: '3093',
              texttableentry: 'GatewayEthernetTwoIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetTwoNetworkStatus',
              isRead: 'true',
              interval: '3094',
              texttableentry: 'GatewayEthernetTwoNetworkStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MacAddressLanTwo',
              isRead: 'true',
              interval: '3095',
              texttableentry: 'MacAddressLanTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayWifiStationEnable',
              isRead: 'true',
              interval: '3096',
              texttableentry: 'GatewayWifiStationEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayInternetAccess',
              isRead: 'true',
              interval: '3097',
              texttableentry: 'GatewayInternetAccess',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterTemperatureOffset',
              isRead: 'true',
              interval: '3098',
              texttableentry: 'ExternalHeaterTemperatureOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerationFurnitureLightingOne',
              isRead: 'true',
              interval: '3099',
              texttableentry: 'RefrigerationFurnitureLightingOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerationFurnitureLightingTwo',
              isRead: 'true',
              interval: '3100',
              texttableentry: 'RefrigerationFurnitureLightingTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerationFurnitureLightingThree',
              isRead: 'true',
              interval: '3101',
              texttableentry: 'RefrigerationFurnitureLightingThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AirborneDustSensor',
              isRead: 'true',
              interval: '3102',
              texttableentry: 'AirborneDustSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_IslandModeLoadInformation',
              isRead: 'true',
              interval: '3103',
              texttableentry: 'IslandModeLoadInformation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AirVolatileOrganicCompoundsIndex',
              isRead: 'true',
              interval: '3104',
              texttableentry: 'AirVolatileOrganicCompoundsIndex',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TemperatureMeasurementEnable',
              isRead: 'true',
              interval: '3105',
              texttableentry: 'TemperatureMeasurementEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BufferMinimumMaximumSetTemperature',
              isRead: 'true',
              interval: '3106',
              texttableentry: 'BufferMinimumMaximumSetTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleExchangeAssistent',
              isRead: 'true',
              interval: '3107',
              texttableentry: 'BatteryModuleExchangeAssistent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicsActivePowerLimitationRampRate',
              isRead: 'true',
              interval: '3108',
              texttableentry: 'PhotovoltaicsActivePowerLimitationRampRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerBaseHeaterStatistical',
              isRead: 'true',
              interval: '3109',
              texttableentry: 'PrimaryHeatExchangerBaseHeaterStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalFaultSignalStatistical',
              isRead: 'true',
              interval: '3110',
              texttableentry: 'ExternalFaultSignalStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarCollectorFrostprotectionStatistical',
              isRead: 'true',
              interval: '3111',
              texttableentry: 'SolarCollectorFrostprotectionStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccentLedBarStatistical',
              isRead: 'true',
              interval: '3112',
              texttableentry: 'AccentLedBarStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputOneValueStatistical',
              isRead: 'true',
              interval: '3113',
              texttableentry: 'DeviceDigitalOutputOneValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTwoValueStatistical',
              isRead: 'true',
              interval: '3114',
              texttableentry: 'DeviceDigitalOutputTwoValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputThreeValueStatistical',
              isRead: 'true',
              interval: '3115',
              texttableentry: 'DeviceDigitalOutputThreeValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputFourValueStatistical',
              isRead: 'true',
              interval: '3116',
              texttableentry: 'DeviceDigitalOutputFourValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputFiveValueStatistical',
              isRead: 'true',
              interval: '3117',
              texttableentry: 'DeviceDigitalOutputFiveValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputSixValueStatistical',
              isRead: 'true',
              interval: '3118',
              texttableentry: 'DeviceDigitalOutputSixValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCircuitFourWayValveStatistical',
              isRead: 'true',
              interval: '3119',
              texttableentry: 'RefrigerantCircuitFourWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorCrankCaseHeaterStatistical',
              isRead: 'true',
              interval: '3120',
              texttableentry: 'CompressorCrankCaseHeaterStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnhancedVapourInjectionValveStatistical',
              isRead: 'true',
              interval: '3121',
              texttableentry: 'EnhancedVapourInjectionValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnableElectricalHeaterSmartGridLockStatistical',
              isRead: 'true',
              interval: '3122',
              texttableentry: 'EnableElectricalHeaterSmartGridLockStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnableElectricalHeaterSmartGridIncreaseMaxDemandStatistical',
              isRead: 'true',
              interval: '3123',
              texttableentry: 'EnableElectricalHeaterSmartGridIncreaseMaxDemandStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputSevenValueStatistical',
              isRead: 'true',
              interval: '3124',
              texttableentry: 'DeviceDigitalOutputSevenValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputEightValueStatistical',
              isRead: 'true',
              interval: '3125',
              texttableentry: 'DeviceDigitalOutputEightValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputNineValueStatistical',
              isRead: 'true',
              interval: '3126',
              texttableentry: 'DeviceDigitalOutputNineValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTenValueStatistical',
              isRead: 'true',
              interval: '3127',
              texttableentry: 'DeviceDigitalOutputTenValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputElevenValueStatistical',
              isRead: 'true',
              interval: '3128',
              texttableentry: 'DeviceDigitalOutputElevenValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FanDuctHeaterStatistical',
              isRead: 'true',
              interval: '3129',
              texttableentry: 'FanDuctHeaterStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelValveStatistical',
              isRead: 'true',
              interval: '3130',
              texttableentry: 'FuelValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FanStatistical',
              isRead: 'true',
              interval: '3131',
              texttableentry: 'FanStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrechargeRelaisStatistical',
              isRead: 'true',
              interval: '3132',
              texttableentry: 'PrechargeRelaisStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MainPowerRelaisStatistical',
              isRead: 'true',
              interval: '3133',
              texttableentry: 'MainPowerRelaisStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpStatistical',
              isRead: 'true',
              interval: '3134',
              texttableentry: 'DomesticHotWaterCirculationPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitOneStatistical',
              isRead: 'true',
              interval: '3135',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitOneStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitTwoStatistical',
              isRead: 'true',
              interval: '3136',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitTwoStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitThreeStatistical',
              isRead: 'true',
              interval: '3137',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitThreeStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpCircuitFourStatistical',
              isRead: 'true',
              interval: '3138',
              texttableentry: 'DomesticHotWaterCirculationPumpCircuitFourStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryCentralHeatingPumpStatistical',
              isRead: 'true',
              interval: '3139',
              texttableentry: 'SecondaryCentralHeatingPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PelletScrewConveyorStatistical',
              isRead: 'true',
              interval: '3140',
              texttableentry: 'PelletScrewConveyorStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalOneCircuitPumpStatistical',
              isRead: 'true',
              interval: '3141',
              texttableentry: 'ThermostatTerminalOneCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalTwoCircuitPumpStatistical',
              isRead: 'true',
              interval: '3142',
              texttableentry: 'ThermostatTerminalTwoCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalThreeCircuitPumpStatistical',
              isRead: 'true',
              interval: '3143',
              texttableentry: 'ThermostatTerminalThreeCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DigitalOutputCoolingStatistical',
              isRead: 'true',
              interval: '3144',
              texttableentry: 'DigitalOutputCoolingStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterStatistical',
              isRead: 'true',
              interval: '3145',
              texttableentry: 'ExternalHeaterStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseOneStatistical',
              isRead: 'true',
              interval: '3146',
              texttableentry: 'ElectricalHeaterPhaseOneStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseTwoStatistical',
              isRead: 'true',
              interval: '3147',
              texttableentry: 'ElectricalHeaterPhaseTwoStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseThreeStatistical',
              isRead: 'true',
              interval: '3148',
              texttableentry: 'ElectricalHeaterPhaseThreeStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExhaustFlapStatistical',
              isRead: 'true',
              interval: '3149',
              texttableentry: 'ExhaustFlapStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LiquidGasValveSwitchStatistical',
              isRead: 'true',
              interval: '3150',
              texttableentry: 'LiquidGasValveSwitchStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalFaultSignalOutputStatistical',
              isRead: 'true',
              interval: '3151',
              texttableentry: 'ExternalFaultSignalOutputStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_KitchenHoodStatistical',
              isRead: 'true',
              interval: '3152',
              texttableentry: 'KitchenHoodStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CombustionAirInterlockFlapStatistical',
              isRead: 'true',
              interval: '3153',
              texttableentry: 'CombustionAirInterlockFlapStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupplementaryHeatEngineStatistical',
              isRead: 'true',
              interval: '3154',
              texttableentry: 'SupplementaryHeatEngineStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadPumpStatus',
              isRead: 'true',
              interval: '3155',
              texttableentry: 'DomesticHotWaterShiftLoadPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadPumpType',
              isRead: 'true',
              interval: '3156',
              texttableentry: 'DomesticHotWaterShiftLoadPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardFive',
              isRead: 'true',
              interval: '3157',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardSix',
              isRead: 'true',
              interval: '3158',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardSix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardsSeven',
              isRead: 'true',
              interval: '3159',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardsSeven',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardEight',
              isRead: 'true',
              interval: '3160',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardEight',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardNine',
              isRead: 'true',
              interval: '3161',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardNine',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTwelveValue',
              isRead: 'true',
              interval: '3162',
              texttableentry: 'DeviceDigitalOutputTwelveValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputThirteenValue',
              isRead: 'true',
              interval: '3163',
              texttableentry: 'DeviceDigitalOutputThirteenValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmOutputFourValue',
              isRead: 'true',
              interval: '3164',
              texttableentry: 'DevicePwmOutputFourValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmOutputFiveValue',
              isRead: 'true',
              interval: '3165',
              texttableentry: 'DevicePwmOutputFiveValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmOutputSixValue',
              isRead: 'true',
              interval: '3166',
              texttableentry: 'DevicePwmOutputSixValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmOutputSevenValue',
              isRead: 'true',
              interval: '3167',
              texttableentry: 'DevicePwmOutputSevenValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DayNightControlConfiguration',
              isRead: 'true',
              interval: '3168',
              texttableentry: 'DayNightControlConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceElectricalCurrentConsumption',
              isRead: 'true',
              interval: '3169',
              texttableentry: 'DeviceElectricalCurrentConsumption',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTankAnodeSensorCurrent',
              isRead: 'true',
              interval: '3170',
              texttableentry: 'DomesticHotWaterTankAnodeSensorCurrent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationTimeScheduleMonday',
              isRead: 'true',
              interval: '3171',
              texttableentry: 'VentilationTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationTimeScheduleTuesday',
              isRead: 'true',
              interval: '3172',
              texttableentry: 'VentilationTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationTimeScheduleWednesday',
              isRead: 'true',
              interval: '3173',
              texttableentry: 'VentilationTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationTimeScheduleThursday',
              isRead: 'true',
              interval: '3174',
              texttableentry: 'VentilationTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationTimeScheduleFriday',
              isRead: 'true',
              interval: '3175',
              texttableentry: 'VentilationTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationTimeScheduleSaturday',
              isRead: 'true',
              interval: '3176',
              texttableentry: 'VentilationTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationTimeScheduleSunday',
              isRead: 'true',
              interval: '3177',
              texttableentry: 'VentilationTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarLogGatewayStatus',
              isRead: 'true',
              interval: '3178',
              texttableentry: 'SolarLogGatewayStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarLogGatewayRequest',
              isRead: 'true',
              interval: '3179',
              texttableentry: 'SolarLogGatewayRequest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarLogPairedGateway',
              isRead: 'true',
              interval: '3180',
              texttableentry: 'SolarLogPairedGateway',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarLogDetectedDeviceInfo',
              isRead: 'true',
              interval: '3181',
              texttableentry: 'SolarLogDetectedDeviceInfo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarLogDetectedDeviceInfoTwo',
              isRead: 'true',
              interval: '3182',
              texttableentry: 'SolarLogDetectedDeviceInfoTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarLogDetectedDeviceInfoThree',
              isRead: 'true',
              interval: '3183',
              texttableentry: 'SolarLogDetectedDeviceInfoThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarLogDetectedDeviceInfoFour',
              isRead: 'true',
              interval: '3184',
              texttableentry: 'SolarLogDetectedDeviceInfoFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarLogDetectedDeviceInfoFive',
              isRead: 'true',
              interval: '3185',
              texttableentry: 'SolarLogDetectedDeviceInfoFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationFanOneSerialNumber',
              isRead: 'true',
              interval: '3186',
              texttableentry: 'VentilationFanOneSerialNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationFanTwoSerialNumber',
              isRead: 'true',
              interval: '3187',
              texttableentry: 'VentilationFanTwoSerialNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TelemetryControlUnitTargetOperationMode',
              isRead: 'true',
              interval: '3188',
              texttableentry: 'TelemetryControlUnitTargetOperationMode',
              isWrite: 'false',
            },
          ],
        },
      ],
    };
  }
}
